import React from 'react';
import lodashFind from 'lodash/find';
import lodashFindIndex from 'lodash/findIndex';
import {
  LoadingOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  SearchOutlined,
  CloseOutlined,
  CloseCircleFilled,
  FormOutlined,
  DeleteFilled,
  CopyFilled,
  MinusCircleOutlined,
} from '@ant-design/icons';
import lodashIsEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { StickyCountdown } from './push/sticky-countdown';
import {
  isEmpty,
  isObject,
  isArray,
  cloneDeep as lodashCloneDeep,
  isEqual,
  merge,
  omitBy,
} from 'lodash';
import CommunicationStepsComponent from './CommunicationStepsComponent';
import {
  getPushLayout,
  getInAppLayout,
  getOnSiteLayout,
  showMessage,
} from '../../../../utils/RenderUtils';
import InputSelector from '../../../../component/form/InputSelector';
import { variationLetter } from '../../../../utils/FormUtils';
import { history } from '../../../../redux/store';
import EmailTemplareModal from '../../../channel/emailTemplate/component/EmailTemplateModal';
import {
  AuthorityProvider,
  getChannel,
  getCommunicationId,
  getCommunicationStep,
  getProductId,
  hasAnyAuthority,
} from '../../../../utils/AuthorityProvider';
import pushTextPng from '../../../../theme/icons/text.png';
import pushBannerPng from '../../../../theme/icons/banner.png';
import pushTimerPng from '../../../../theme/icons/timer.png';
import webBannerPng from '../../../../theme/icons/webpush-banner.png';
import webTextPng from '../../../../theme/icons/webpush-text.png';
import InAppThemeOptions from './inApp/InAppThemOptions';
import InAppActions from './inApp/InAppActions';
import { InAppPreview } from './previews/inApp';

import { InfoCircleFilled } from '@ant-design/icons';
import {
  Button,
  Spin,
  Select,
  Radio,
  Input,
  Switch,
  Tooltip,
  Upload,
  Modal,
  Form,
  message,
  Row,
  Col,
  Alert,
  Checkbox,
  Space,
  InputNumber,
} from 'antd';
import CommunicationFooterComponent from './CommunicationFooterComponent';
import {
  journeySteps,
  transactionalSteps,
} from '../../../../utils/CommunicationSteps';
import { errorHandling, emailRegEx } from '../../../../utils/FormUtils';
import texts from '../../../../utils/texts';
import vars from '@Theme/styles/vars.js';
import { OnSitePreview } from './previews/onSite';
import OnSiteActions from './inApp/OnSiteActions';
import {
  ONSITE_SIZE_MODES,
  ONSITE_SIZE_PRESETS,
  MOBILE_BREAKPOINT,
  getDefaultOnSiteConfiguration,
  getEffectiveSizeMode,
  getEffectiveSizePreset,
  resolveOnSiteSizeConfig,
  takeSavedOnSiteConfiguration,
  completeMobileBreakpoint,
  getMobileBreakpoint,
  setMobileBreakpointDimension,
} from './onsite/sizing';
import Card from '@Utils/Card';
import ListBase from '@Component/form/ListBase';
import { WhatsAppPreview } from './previews/whatsapp';
import inAppNewLayoutBanner from '../../../../theme/images/inapp-onsite-layout-img.svg';
import { InlineThemePicker } from './inlineThemePicker';
import { BorderRadiusInput } from './inlineThemePicker/borderRadiusInput';
import { isParentProduct } from '@Utils/isParentProduct';
import RichEditor from '@Component/form/RichEditor';
import './CommunicationMessage.less';
import QuestionsSection from './survey/questionsSection';
import SurveyPreview from './previews/survey';
import { WebpushPreview } from './previews/webPush';
import { checkIsSurvey } from '@Utils/checkIsSurvey';
import { PushPreview } from './previews/push';
import { SmsPreview } from './previews/sms';
import { TelegramPreview } from './previews/telegram';
import ThemeAttributes from './survey/ThemeAttributes';
import { cssInAppSelectors, cssOnSiteSelectors } from './previews/cssTemp';
import { OnSiteLayoutGallery } from './onsite/OnSiteLayoutGallery';
import { sanitizeOnSiteAdvancedCss } from './onsite/layoutFixCss';
import dayjs from 'dayjs';
const CustomChannelDefaultItems = [
  'message',
  'subject',
  'image',
  'keyValuePair',
  'icon',
  'badge',
  'attachments',
];

const styles = {
  actions: {
    backgroundColor: 'lightGray',
    margin: '20px',
  },

  layoutModalContent: {
    overflowX: 'hidden',
    overflowY: 'auto',
    height: '100%',
    display: 'block',
    maxHeight: 600,
    padding: 16,
  },

  actionInput: {
    width: 165,
    height: 48,
    border: '1px solid #ddd',
    outline: 'none',
    fontSize: 18,
    paddingInline: 16,
    textTransform: 'uppercase',
  },
  layoutSelector: {
    color: '#3d404e8c',
    fontWeight: 'bold',
    fontSize: 12,
    textTransform: 'uppercase',
    minWidth: 150,
  },
  selectedLayout: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    textTransform: 'uppercase',
    cursor: 'pointer',
    padding: '2px 4px',
  },
  editContainer: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
    direction: 'ltr',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 5,
    paddingBottom: 5,
  },
  editFieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 6,
    fontSize: 13,
    lineHeight: 1.43,
    color: '#3d404e',
  },
  editField: {
    width: 350,
  },
  editLabel: {
    color: 'rgba(61,64,78,.55)',
    marginRight: '5px',
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: '600',
    flex: 1,
    textAlign: 'left',
    width: '37px',
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    height: 60,
    backgroundColor: '#ffffff',
    boxShadow:
      '0 -2px 3px 0 rgba(61,64,78,.12), inset 0 -1px 0 0 rgba(61,64,78,.1)',
    padding: '10px 30px',
    transition: 'all .3s ease-in-out',
    left: 247,
    width: 'calc(100% - 247px)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: '5',
  },
  previewButton: {
    alignSelf: 'flex-end',
    position: 'relative',
  },
  headTitleContainer: {
    fontSize: 18,
    fontWeight: '500',
    color: '#3d404e',
    display: 'flex',
    flexDirection: 'row',
  },
  infoBoxHeader: {
    display: 'flex',
    flexDirection: 'row',
    padding: '15px 30px',
    borderBottom: '1px solid #e7e8e9',
    backgroundColor: '#fdfdfd',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dataRowContainer: { padding: 24 },
  dataRowFirst: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dataRow: {
    paddingTop: 20,
    paddingBottom: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #BFBFBF4D',
  },
  methodsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    gap: 8,
  },
  methodTitle: {
    fontWeight: '600',
    color: '#3d404e',
    lineHeight: '1.43',
    fontSize: 13,
  },
  methodContainer: {
    border: '1px solid #e7e8e9',
    borderRadius: '5px',
    padding: '20px',
    height: 460,
    width: 247,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  addNewSlotButton: {
    position: 'relative',
  },
  renderEditor: {
    background: 'none',
    paddingTop: 40,
    marginBottom: 60,
    direction: 'ltr',
  },
  renderCustomChannel: {
    paddingLeft: 0,
    paddingRight: 0,
    border: '1px solid #F1F1F3',
    backgroundColor: 'white',
  },
  formItem: {
    background: 'none',
    paddingTop: 40,
  },
  renderCustomChannelContent: {
    marginTop: '10px',
    padding: '0px',
  },
};

function mergeObjects(obj1, obj2) {
  if (!obj1 || !obj2) {
    return obj1 || obj2;
  }

  const result = { ...obj2 };

  Object.keys(obj1).forEach((key) => {
    const value1 = obj1[key];
    const value2 = obj2[key];

    if (
      value1 &&
      typeof value1 === 'object' &&
      !Array.isArray(value1) &&
      !(value1 instanceof Date) &&
      value2 &&
      typeof value2 === 'object' &&
      !Array.isArray(value2) &&
      !(value2 instanceof Date)
    ) {
      result[key] = mergeObjects(value1, value2);
    } else if (!(key in result)) {
      result[key] = value1;
    }
  });

  return result;
}

////todo/////fileFormatChecker implementation for checking image url format///////////////
class CommunicationMessageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.step = getCommunicationStep(this.props.pathname);
    this.isParent = isParentProduct(this.props.currentUser, location);
    this.channel = getChannel(this.props.pathname);
    if (props.journey) {
      this.communicationId =
        props.communicationId ||
        (props.communicationData && props.communicationData.id);
      this.channel = props.channel || 'SMS';
    } else {
      this.communicationId = getCommunicationId(this.props.pathname);
    }
    this.emptyVariation = {
      smsChannel: undefined,
      replyTo: undefined,
      ratingTitle: undefined,
      ratingTextColor: undefined,
      ratingDescription: undefined,
      autoDismiss: false,
      ratingBackgroundImage: undefined,
      autoDismissDuration: null,
      androidDismissButtonLabel: null,
      ratingBackgroundColor: undefined,
      pushType: 'TEXT',
      layoutType: undefined,
      inAppLayoutType: 'MODAL',
      onSiteLayoutType: 'TEXT',
      sticky: false,
      timerTemplate: {
        type: 'PLAIN',
        countDownType: 'DURATION',
        endTime: dayjs().toDate(),
        duration: null,
      },
      theme: {
        label: {
          color: '#000000',
        },
        title: {
          color: '#000000',
        },
        message: {
          color: '#000000',
        },
        actions: [
          {
            bg_color: '#000000',
            style: {
              color: '#000000',
            },
          },
          {
            bg_color: '#000000',
            style: {
              color: '#000000',
            },
          },
        ],
      },
      percentage: undefined,
      message: '',
      subject: '',
      configuration: getDefaultOnSiteConfiguration(),
      label: '',
      buttonText: '',
      buttonOnsiteAction: '',
      keyValuePair: [],
      json: undefined,
      iosRatingSubmitText: undefined,
      iosOnClickAction: undefined,
      iosButtonsType: undefined,
      iosButton1OnClickAction: undefined,
      image: undefined,
      fromName: undefined,
      fromEmail: undefined,
      emailChannel: undefined,
      carouselType: undefined,
      carouselImages: [],
      cc: undefined,
      bcc: undefined,
      attachments: [],
      androidRatingSubmitText: undefined,
      androidOnClickAction: undefined,
      customChannel: undefined,

      showIosPushButtons: false,
      showIosAdvance: false,
      iosPushButtonType: undefined,
      pushPictureUrl: null,
      pushPicture: null,
      emailAttachment: null,
      emailAttachmentUrl: null,

      showAndroidPushButtons: false,
      showAndroidAdvance: false,

      showWebPushAdvance: false,

      showKeyValue: false,

      androidButtons: [],
      iosButtons: [],

      showReplyTo: false,
      showCc: false,
      showBcc: false,
      selectedTemplateJson: '',
      selectedTemplateHtml: '',
      emailHtml: null,
      uploadFileList: [],
      checkedDefaultLogo: false,
    };
    this.state = {
      showVariationModal: [],
      activeIndex: 0,
      attachmentsThreshold: 0,
      currentUploadedAttachmentSize: 0,
      pushTimerDurationMode: 'HOUR',
      messageEditorType: this.readMessageEditorTypeFromSession(),
      variations: [lodashCloneDeep(this.emptyVariation)],
      newVariations: {
        styles: {
          theme: '',
          css: ``,
        },
        percentage: 100,
        setting: { language: 'ENGLISH' },
        email: {
          enabled: false,
          type: 'QUESTION',
          question: { type: 'TEXT_BOX', fields: { email: 'EMAIL' } },
          body: 'Can you please tell us your email? It will help us better',
        },
        welcome: {
          body: '',
          type: 'STATIC',
          staticType: 'WELCOME',
        },
        exitPoint: {
          body: 'Thanks a ton for taking the survey',
          type: 'STATIC',
          staticType: 'EXIT_POINT',
        },
        questions: [],
      },
      isPreviewAndroid: true,
      selectedEmailTemplate: null,
      templateModalVisible: false,
      editCurrentTemplateVisible: false,
      canEditSelectedTemplate: false,
      showEmojiPicker: false,
      showAttributePicker: false,
      emailBodyType: 'raw', // drag
      uploadingAttachmentIndex: -1,
      uploadingVariationIndex: -1,
      uploadingImageVariationIndex: -1,
      emailPreviewVisible: false,
      uploadingWebPushIcon: false,
      uploadingWebPushImage: false,
      uploadingWebPushBadge: false,
      imageUrlFormatError: true,
      invalidImageUrlError: null,
      fromEmailValidationError: false,
      isInPreviewMode: false,
      isLayoutSelectorOpen: false,
      emailErrors: {
        replyToEmailError: false,
        ccEmailError: false,
        bccEmailError: false,
      },
      isBasicAttributesVisible: true,
      enabledCSS: false,
    };
    this.iosPushButtonType = {
      YES_NO_OPEN_DISMISS: 'YES_NO_OPEN_DISMISS',
      YES_NO_DISMISS: 'YES_NO_DISMISS',
      ACCEPT_DECLINE_OPEN_DISMISS: 'ACCEPT_DECLINE_OPEN_DISMISS',
      ACCEPT_DECLINE_DISMISS: 'ACCEPT_DECLINE_DISMISS',
      SHOP_NOW: 'SHOP_NOW',
      BUY_NOW: 'BUY_NOW',
      DOWNLOAD: 'DOWNLOAD',
    };

    this.formRef = React.createRef();
  }

  getMessageEditorTypeStorageKey() {
    return `intrack_message_editor_type_${this.communicationId}_${this.channel}`;
  }

  readMessageEditorTypeFromSession() {
    try {
      const raw = sessionStorage.getItem(this.getMessageEditorTypeStorageKey());
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return typeof parsed === 'object' &&
        parsed !== null &&
        !Array.isArray(parsed)
        ? parsed
        : {};
    } catch (e) {
      return {};
    }
  }

  persistMessageEditorType(messageEditorType) {
    try {
      sessionStorage.setItem(
        this.getMessageEditorTypeStorageKey(),
        JSON.stringify(messageEditorType)
      );
    } catch (e) {
      // ignore quota / private mode
    }
  }

  handleClickOutside(event) {
    if (this.ref && !this.ref?.current?.contains(event?.target)) {
      const showVariationModal = this.state.showVariationModal;
      let newArr = showVariationModal.map((item) =>
        item === true ? false : false
      );
      this.setState({ showVariationModal: newArr });
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.props.communicationUpdateMessageFetch(this.communicationId);
    this.props.communicationUpdateAudienceFetch(this.communicationId);
    if (this.channel === 'EMAIL') {
      this.props.communicationListEmailChannelsFetch();
    }
    if (this.channel === 'WHATSAPP') {
      this.props.whatsappChannelTemplateListFetch({
        ...this.props.whatsAppTemplatePageRequest,
        name: null,
        page: 0,
      });
    }
    if (this.channel === 'PUSH' || this.channel === 'WEB_PUSH') {
      this.props.communicationListPushChannelsFetch();
    }
    if (this.channel === 'SMS') {
      this.props.communicationListSmsChannelsFetch();
    }
    if (this.channel === 'TELEGRAM') {
      this.props.communicationListTelegramChannelsFetch();
    }
    if (this.channel === 'CUSTOM') {
      this.props.communicationListCustomChannelsFetch();
    }
    this.props.productSegmentListAttributesFetch();
    this.props.productSegmentListEventsFetch();
    this.props.journeyListBusinessEventsFetch();
    if (hasAnyAuthority(AuthorityProvider.ROLE_FONT_LIST)) {
      this.props.fontsListFetch();
    }
  }

  calcAttachmentsThreshold = async (data, currentSize = 0) => {
    currentSize = currentSize / 1024;

    if (!Array.isArray(data)) return false;

    const files = data.map((at) => at.file);

    const sizes = await Promise.all(files.map(this.getAttachmentFilesize));
    return sizes.reduce((p, q) => p + q, 0) + currentSize;
  };

  isAttachmentsSizeExceeded = () => {
    return this.state.attachmentsThreshold > 512;
  };

  componentDidUpdate(prevProps) {
    if (
      !this.props.loadingUpdateMessage &&
      prevProps.loadingUpdateMessage &&
      !isEmpty(this.props.currentMessage)
    ) {
      if (
        this.props.currentMessage?.newVariations &&
        this.props.currentMessage?.newVariations.length > 0
      ) {
        const [item] = this.handleRevertNewVariations(
          this.props.currentMessage?.newVariations
        );

        if (
          this.channel === 'ON_SITE' &&
          this.props.currentMessage?.variationType === 'SURVEY'
        ) {
          const newVariations = merge({}, this.state.newVariations, item);

          this.setState({ newVariations });
        }
      }

      if (
        this.props.currentMessage?.variations &&
        this.props.currentMessage?.variations.length > 0
      ) {
        this.props.currentMessage?.variations?.map((variation, index) => {
          if (variation?.whatsAppTemplate) {
            this.props.whatsappChannelTemplateViewFetch(
              variation?.whatsAppTemplate,
              index
            );
          }
        });

        if (this.channel === 'EMAIL') {
          this.prepareEmailVariations(this.props.currentMessage?.variations);

          return;
        }
        const variations = [];
        const showVariationModal = [];

        this.props.currentMessage?.variations?.forEach((item, i) => {
          if (this.channel === 'PUSH' || this.channel === 'WEB_PUSH') {
            let showAndroidAdvance = false;
            let showWebPushAdvance = false;
            let showAndroidPushButtons = false;
            let showKeyValue = false;
            let autoDismiss = false;
            if (
              !isNil(item.androidButton1Label) ||
              !isNil(item.androidButton1OnClickAction) ||
              !isNil(item.androidButton2Label) ||
              !isNil(item.androidButton2OnClickAction)
            ) {
              showAndroidPushButtons = true;
            }
            if (!isNil(item.androidOnClickAction) || showAndroidPushButtons) {
              showAndroidAdvance = true;
            }
            if (item.autoHide === false) {
              showWebPushAdvance = true;
            }

            if (item.autoDismissDuration) {
              item.autoDismissDuration =
                item.autoDismissDuration /
                (this.state.pushTimerDurationMode === 'HOUR' ? 3600 : 60);

              autoDismiss = true;
            }
            if (
              !isNil(item.keyValuePair) &&
              !lodashIsEmpty(item.keyValuePair) &&
              item.keyValuePair.length > 0
            ) {
              showKeyValue = true;
            }
            let androidButtons = [];
            if (
              !isNil(item.androidButton1Label) ||
              !isNil(item.androidButton1OnClickAction)
            ) {
              androidButtons.push({
                label: item.androidButton1Label,
                onClick: item.androidButton1OnClickAction,
              });
            }
            if (
              !isNil(item.androidButton2Label) ||
              !isNil(item.androidButton2OnClickAction)
            ) {
              androidButtons.push({
                label: item.androidButton2Label,
                onClick: item.androidButton2OnClickAction,
              });
            }
            const s = mergeObjects(lodashCloneDeep(this.emptyVariation), item);
            variations.push({
              ...s,
              showAndroidPushButtons,
              showAndroidAdvance,
              showWebPushAdvance,
              androidButtons,
              showKeyValue,
              autoDismiss,
            });
            if (this.channel === 'PUSH') {
              this.formRef.current?.setFieldsValue({
                [`variations[${i}].subject`]: item?.subject,
                [`variations[${i}].message`]: item?.message,
              });
            }
          } else if (this.channel === 'CUSTOM') {
            // this.formRef.current.
            let showKeyValue = false;
            if (
              !isNil(item.keyValuePair) &&
              !lodashIsEmpty(item.keyValuePair) &&
              item.keyValuePair.length > 0
            ) {
              showKeyValue = true;
            }
            const s = mergeObjects(lodashCloneDeep(this.emptyVariation), item);
            variations.push({
              ...s,
              showKeyValue,
            });
            this.formRef.current?.setFieldsValue({
              [`variations[${i}].customChannel`]: item?.customChannel,
              [`variations[${i}].subject`]: item?.subject,
              [`variations[${i}].message`]: item?.message,
            });
          } else if (this.channel === 'IN_APP' || this.channel === 'ON_SITE') {
            if (
              item.onSiteLayoutType &&
              item.onSiteLayoutType === 'TEXT_AND_IMAGE'
            ) {
              item.onSiteLayoutType = 'TEXT';
            }
            const s = mergeObjects(lodashCloneDeep(this.emptyVariation), item);
            // emptyVariation includes Auto size defaults — do not let them
            // overwrite saved/duplicated configuration (sizeMode + metrics).
            if (item?.configuration) {
              s.configuration = takeSavedOnSiteConfiguration(
                item.configuration
              );
            }

            variations.push(s);
            this.formRef.current?.setFieldsValue({
              [`variations[${i}].subject`]: item?.subject,
              [`variations[${i}].message`]: item?.message,
              [`variations[${i}].configuration`]: s.configuration,
            });
          } else {
            const s = mergeObjects(lodashCloneDeep(this.emptyVariation), item);

            variations.push(s);
          }
        });
        variations.forEach(() => showVariationModal.push(false));
        this.setState({ variations, showVariationModal });
      }
    } else if (
      !this.props.loadingUploadFile &&
      prevProps.loadingUploadFile &&
      this.props.uploadedFile &&
      this.props.uploadedFile.path
    ) {
      if (this.channel === 'EMAIL') {
        const clonedAttachments =
          this.state.variations[this.state.uploadingVariationIndex] &&
          this.state.variations[this.state.uploadingVariationIndex]
            .attachments &&
          Array.isArray(
            this.state.variations[this.state.uploadingVariationIndex]
              .attachments
          )
            ? lodashCloneDeep(
                this.state.variations[this.state.uploadingVariationIndex]
                  .attachments
              )
            : [];

        clonedAttachments[this.state.uploadingAttachmentIndex] = {
          ...clonedAttachments[this.state.uploadingAttachmentIndex],
          file: this.props.uploadedFile.path,
          ...this.props.uploadedFile,
        };

        this.handleChangeVariations(
          this.state.uploadingVariationIndex,
          'attachments',
          clonedAttachments
        );

        this.setState(
          { uploadingAttachmentIndex: -1, uploadingVariationIndex: -1 },
          () => {
            this.props.communicationUploadFileReset();
          }
        );
      } else if (this.channel === 'PUSH') {
        this.handleChangeVariations(
          this.state.uploadingImageVariationIndex,
          'image',
          this.props.uploadedFile.path
        );
        this.setState({ uploadingImageVariationIndex: -1 }, () => {
          this.props.communicationUploadFileReset();
        });
      } else if (this.channel === 'WEB_PUSH') {
        let name = null;
        if (this.state.uploadingWebPushIcon) {
          name = 'icon';
        } else if (this.state.uploadingWebPushImage) {
          name = 'image';
        } else if (this.state.uploadingWebPushBadge) {
          name = 'badge';
        }
        if (!isNil(name)) {
          this.handleChangeVariations(
            this.state.uploadingImageVariationIndex,
            name,
            this.props.uploadedFile.path
          );
          this.setState({ uploadingImageVariationIndex: -1 }, () => {
            this.props.communicationUploadFileReset();
          });
        }
      } else if (this.channel === 'CUSTOM') {
        let name = null;
        if (this.state.uploadingWebPushIcon) {
          name = 'icon';
        } else if (this.state.uploadingWebPushImage) {
          name = 'image';
        } else if (this.state.uploadingWebPushBadge) {
          name = 'badge';
        }
        if (!isNil(name)) {
          this.handleChangeVariations(
            this.state.uploadingImageVariationIndex,
            name,
            this.props.uploadedFile.path
          );
          this.setState({ uploadingImageVariationIndex: -1 }, () => {
            this.props.communicationUploadFileReset();
          });
          this.clearLoading(name);
        } else if (this.state.uploadingAttachmentIndex >= 0) {
          const clonedAttachments =
            this.state.variations[this.state.uploadingVariationIndex] &&
            this.state.variations[this.state.uploadingVariationIndex]
              .attachments &&
            Array.isArray(
              this.state.variations[this.state.uploadingVariationIndex]
                .attachments
            )
              ? lodashCloneDeep(
                  this.state.variations[this.state.uploadingVariationIndex]
                    .attachments
                )
              : [];
          clonedAttachments[this.state.uploadingAttachmentIndex] = {
            ...clonedAttachments[this.state.uploadingAttachmentIndex],
            file: this.props.uploadedFile.path,
            ...this.props.uploadedFile,
          };
          this.handleChangeVariations(
            this.state.uploadingVariationIndex,
            'attachments',
            clonedAttachments
          );
          this.setState(
            { uploadingAttachmentIndex: -1, uploadingVariationIndex: -1 },
            () => {
              this.props.communicationUploadFileReset();
            }
          );
        }
      } else if (this.channel === 'IN_APP' || this.channel === 'ON_SITE') {
        this.handleChangeVariations(
          this.state.uploadingImageVariationIndex,
          'image',
          this.props.uploadedFile.path
        );
        this.setState({ uploadingImageVariationIndex: -1 }, () => {
          this.props.communicationUploadFileReset();
        });
      }
    } else if (
      !this.props.loadingUpdateAudience &&
      prevProps.loadingUpdateAudience &&
      this.props.currentAudience
    ) {
      let isPreviewAndroid = true;
      if (this.props.currentAudience.mobileDevice === 'IOS') {
        isPreviewAndroid = false;
      }
      this.setState({ isPreviewAndroid });
    } else if (
      !this.props.loadingViewTemplate &&
      prevProps.loadingViewTemplate &&
      this.props.currentTemplate
    ) {
      //todo
      // fill template and open continue modal
      this.setState({ selectedEmailTemplate: this.props.currentTemplate });
    } else if (
      this.props.journey &&
      prevProps.successUpdateMessageSubmit !==
        this.props.successUpdateMessageSubmit &&
      this.props.successUpdateMessageSubmit &&
      !this.state.isInPreviewMode
    ) {
      this.props.goToStepOnJourney('conversion');
    } else if (this.props.customChannel !== prevProps.customChannel) {
      let customChannelItems = CustomChannelDefaultItems;
      // const body_ = this.props.customChannel.body;
      // if (body_) {
      //     customChannelItems = CustomChannelDefaultItems.filter(item => body_.search(item) >= 0);
      // }
      this.setState({
        [`selectedCustomChannelItems_${this.state.activeIndex}`]:
          customChannelItems,
      });
    }
  }

  clearLoading(name) {
    if (name === 'icon') {
      this.setState({
        uploadingWebPushIcon: false,
      });
    } else if (name === 'image') {
      this.setState({
        uploadingWebPushImage: false,
      });
    } else if (name === 'badge') {
      this.setState({
        uploadingWebPushIuploadingWebPushBadgecon: false,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    this.props.clearCommunicationMessageError(
      this.props.errorUpdateMessageSubmit.errors
    );

    this.props.resetCurrentMessage({});
  }

  setEmailError = (field, value) => {
    this.setState({
      emailErrors: { ...this.state.emailErrors, [field]: value },
    });
  };

  viewItem(id) {
    if (hasAnyAuthority(AuthorityProvider.ROLE_PRODUCT_CUSTOM_ATTRIBUTE_VIEW)) {
      history.push(`view/${id}`);
    }
  }

  getNavigation() {
    return [{ name: 'Custom Attribute List', path: '' }];
  }

  communicationHasJourneyType = () => {
    if (
      !this.props.journey &&
      this.props.currentMessage &&
      ['JOURNEY', 'RELAY'].includes(this.props.currentMessage?.type)
    ) {
      return true;
    }
    return false;
  };

  addVariation = () => {
    if (this.props.readOnly) {
      return;
    }
    const { variations } = this.state;
    const showVariationModal = this.state.showVariationModal;
    if (variations.length < 5) {
      variations.push(lodashCloneDeep(this.emptyVariation));
      const newArr = showVariationModal.map((item) =>
        item === true ? false : false
      );
      newArr.push(false);
      this.setState({ showVariationModal: newArr });
    }
    this.setState({ variations });
  };

  addEmailAttachment = (index) => {
    const cloned =
      this.state.variations[index] &&
      this.state.variations[index].attachments &&
      Array.isArray(this.state.variations[index].attachments)
        ? lodashCloneDeep(this.state.variations[index].attachments)
        : [];
    cloned.push({ file: null });
    this.handleChangeVariations(index, 'attachments', cloned);
  };

  changeEmailAttachment = (index, attachmentIndex, value) => {
    const cloned = lodashCloneDeep(this.state.variations[index].attachments);
    cloned[attachmentIndex].file = value;
    this.handleChangeVariations(index, 'attachments', cloned);
  };

  removeVariation = (index) => {
    if (this.props.readOnly) {
      return;
    }
    const { variations } = this.state;
    const showVariationModal = this.state.showVariationModal;
    if (variations.length > 1) {
      variations.splice(index, 1);
      showVariationModal.splice(index, 1);
    }
    let myActiveIndex = variations.length - 1;
    if ((index === 1 && myActiveIndex === index) || variations.length === 1) {
      myActiveIndex = 0;
    }
    this.setState({
      variations,
      activeIndex: myActiveIndex,
      showVariationModal,
    });
  };

  duplicateVariation = (index) => {
    if (this.props.readOnly) {
      return;
    }
    const { variations } = this.state;
    const showVariationModal = this.state.showVariationModal;
    if (variations.length < 5) {
      let foundVar = variations.filter((element, i) => i === index);
      delete foundVar[0].id;
      variations.push(lodashCloneDeep(foundVar[0]));
      const newArr = showVariationModal.map((item) =>
        item === true ? false : false
      );
      newArr.push(false);
      this.setState({ showVariationModal: newArr });
    }
    this.setState({ variations });
  };

  isEditDisable = () => {
    return (
      !this.props.journey &&
      this.props.currentMessage &&
      this.props.currentMessage?.status === 'ENDED'
    );
  };

  getAndroidAdvance = (index) => {
    const result = {};
    if (!this.state.variations[index].showAndroidAdvance) {
      result.androidButton1Label = null;
      result.androidButton1OnClickAction = null;
      result.androidButton2Label = null;
      result.androidButton2OnClickAction = null;
      if (this.channel !== 'WEB_PUSH') {
        result.androidOnClickAction = null;
      }
    } else if (!this.state.variations[index].showAndroidPushButtons) {
      result.androidButton1Label = null;
      result.androidButton1OnClickAction = null;
      result.androidButton2Label = null;
      result.androidButton2OnClickAction = null;
    } else {
      if (this.state.variations[index].androidButtons.length === 1) {
        result.androidButton1Label =
          this.state.variations[index].androidButtons[0].label;
        result.androidButton1OnClickAction =
          this.state.variations[index].androidButtons[0].onClick;
        result.androidButton2Label = null;
        result.androidButton2OnClickAction = null;
      }
      if (this.state.variations[index].androidButtons.length === 2) {
        result.androidButton1Label =
          this.state.variations[index].androidButtons[0].label;
        result.androidButton1OnClickAction =
          this.state.variations[index].androidButtons[0].onClick;
        result.androidButton2Label =
          this.state.variations[index].androidButtons[1].label;
        result.androidButton2OnClickAction =
          this.state.variations[index].androidButtons[1].onClick;
      }
    }
    return result;
  };

  getWebPushButtons = (index) => {
    const result = {};
    if (!this.state.variations[index].showAndroidPushButtons) {
      result.androidButton1Label = null;
      result.androidButton1OnClickAction = null;
      result.androidButton2Label = null;
      result.androidButton2OnClickAction = null;
    } else {
      if (this.state.variations[index].androidButtons.length === 1) {
        result.androidButton1Label =
          this.state.variations[index].androidButtons[0].label;
        result.androidButton1OnClickAction =
          this.state.variations[index].androidButtons[0].onClick;
        result.androidButton2Label = null;
        result.androidButton2OnClickAction = null;
      }
      if (this.state.variations[index].androidButtons.length === 2) {
        result.androidButton1Label =
          this.state.variations[index].androidButtons[0].label;
        result.androidButton1OnClickAction =
          this.state.variations[index].androidButtons[0].onClick;
        result.androidButton2Label =
          this.state.variations[index].androidButtons[1].label;
        result.androidButton2OnClickAction =
          this.state.variations[index].androidButtons[1].onClick;
      }
    }
    return result;
  };

  getIosAdvance = (index) => {
    const result = {};
    if (!this.state.variations[index].showIosAdvance) {
      result.iosButton1OnClickAction = null;
      result.iosButtonsType = null;
      result.iosOnClickAction = null;
    } else {
      if (
        this.state.variations[index].iosButtons.length > 0 &&
        (this.state.variations[index].iosPushButtonType ===
          this.iosPushButtonType.YES_NO_OPEN_DISMISS ||
          this.state.variations[index].iosPushButtonType ===
            this.iosPushButtonType.ACCEPT_DECLINE_OPEN_DISMISS ||
          this.state.variations[index].iosPushButtonType ===
            this.iosPushButtonType.SHOP_NOW ||
          this.state.variations[index].iosPushButtonType ===
            this.iosPushButtonType.BUY_NOW ||
          this.state.variations[index].iosPushButtonType ===
            this.iosPushButtonType.DOWNLOAD)
      ) {
        result.iosButton1OnClickAction =
          this.state.variations[index].iosButtons[0].onClick;
      }
    }
    return result;
  };

  getKeyValue = (index) => {
    let keyValuePair = this.state.variations[index].keyValuePair
      ? lodashCloneDeep(this.state.variations[index].keyValuePair)
      : [];
    if (!this.state.variations[index].showKeyValue) {
      keyValuePair = [];
    }
    return keyValuePair;
  };

  getVariation = () => {
    const result = [];
    const { variations } = this.state;
    variations.forEach((item, index) => {
      // const onSiteLayoutType = item.image ? 'TEXT_AND_IMAGE' : 'TEXT';
      const androidAdvance =
        this.channel === 'IN_APP' || this.channel === 'ON_SITE'
          ? {}
          : this.getAndroidAdvance(index);
      const webPushButtons =
        this.channel === 'WEB_PUSH' ? this.getWebPushButtons(index) : null;
      const iosAdvance = this.getIosAdvance(index);
      const keyValuePair = this.getKeyValue(index);
      const cc = item.showCc ? item.cc : null;
      const bcc = item.showBcc ? item.bcc : null;
      const replyTo = item.showReplyTo ? item.replyTo : null;
      let autoHide = item.autoHide;
      if (this.channel === 'WEB_PUSH' && !item.showWebPushAdvance) {
        autoHide = true;
      }

      result.push({
        ...item,
        // onSiteLayoutType,
        ...androidAdvance,
        ...iosAdvance,
        ...webPushButtons,
        keyValuePair,
        cc,
        bcc,
        replyTo,
        percentage: this.getVariationPercentage(index, variations.length),
        autoHide,
      });
    });
    return result;
  };

  openEmailPreview = (index) => {
    const htmlInput =
      this.state.variations[index] && this.state.variations[index].message
        ? this.state.variations[index].message
        : '';
    this.setState({
      emailPreviewVisible: true,
      emailHtml: htmlInput,
    });
  };

  cancelEmailPreview = () => {
    this.setState({ emailPreviewVisible: false });
  };

  confirmDeleteAttachment = (index, attachmentIndex) => {
    const cloned = lodashCloneDeep(this.state.variations[index].attachments);
    cloned.splice(attachmentIndex, 1);
    this.handleChangeVariations(index, 'attachments', cloned);
    if (this.channel === 'EMAIL') {
      this.calcAttachmentsThreshold(cloned).then((attachmentsThreshold) => {
        this.setState({ attachmentsThreshold });
      });
    }
  };

  cancel = (e) => {
    e.stopPropagation();
  };

  checkEmailErrors = (showType, value) => {
    let selectedVariation = this.state.variations[this.state.activeIndex];
    if (
      selectedVariation[showType] &&
      (isEmpty(selectedVariation[value]) ||
        !isNil(this.checkValidEmail(selectedVariation[value])))
    ) {
      return true;
    }
    return false;
  };

  getBlobURL = (code, type) => {
    const blob = new Blob([code], { type });
    return URL.createObjectURL(blob);
  };

  prepareEmailVariations = async (variatons) => {
    const preparedVariations = await Promise.all(
      variatons.map((variation) => this.prepareEmailVariation(variation))
    );

    this.setState({ variations: preparedVariations });
  };

  prepareEmailVariation = async (variation) => {
    let showReplyTo = false;
    let showCc = false;
    let showBcc = false;
    let attachments = variation.attachments ?? [];

    if (variation.attachments && Array.isArray(variation.attachments)) {
      attachments = await Promise.all(
        variation.attachments.map(async (attachment) => {
          const size = await this.getAttachmentFilesize(attachment.file);

          return {
            ...attachment,
            size,
          };
        })
      );
    }

    if (!isNil(variation.bcc)) {
      showBcc = true;
    }
    if (!isNil(variation.cc)) {
      showCc = true;
    }
    if (!isNil(variation.replyTo)) {
      showReplyTo = true;
    }

    const message = variation.message;
    const el = document.createElement('html');
    el.innerHTML = message;

    const prepareHeaderStyle = el.querySelector('#intkPreheaderStyle');
    if (prepareHeaderStyle) prepareHeaderStyle.remove();

    let preHeaderBody = el.querySelector('#intkPreheaderBody');
    let preheaderText = '';
    if (preHeaderBody) {
      preheaderText = preHeaderBody.innerText;
      preHeaderBody.remove();
    }

    let messageHtml = el.outerHTML;
    const REGEX_ATTR = /{{[a-zA-Z]+\[[^}}]*]}}+/g;
    const populatedAttrs = messageHtml.match(REGEX_ATTR);

    populatedAttrs?.forEach((item) => {
      messageHtml = messageHtml.replace(item, item.replaceAll(' ', ''));
    });

    const alteredMessage = messageHtml;

    return {
      ...lodashCloneDeep(this.emptyVariation),
      ...variation,
      attachments,
      message: preheaderText ? alteredMessage : message,
      preheader: preheaderText,
      showReplyTo,
      showCc,
      showBcc,
    };
  };

  addingPreHeaderToEmailMessage = async (variation) => {
    const message = variation.message;
    const preheader = variation.preheader;
    let messageWithPreheader = message;
    if (preheader) {
      const el = document.createElement('html');
      el.innerHTML = message;

      const preHeaderCSS =
        'font-size: 0px;line-height: 1px;mso-line-height-rule: exactly;display: none;overflow: hidden;visibility: hidden;color: transparent;opacity: 0;height: 0;width: 0;max-width: 0px;max-height: 0px;mso-hide: all;';

      if (!el.querySelector('#intkPreheaderStyle')) {
        const css = `.intkpreheader {${preHeaderCSS}}`,
          elHead = el.head || el.getElementsByTagName('head')[0],
          style = document.createElement('style');

        style.setAttribute('id', 'intkPreheaderStyle');

        elHead.appendChild(style);

        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
      }

      let preHeaderBody = el.querySelector('#intkPreheaderBody');
      if (preHeaderBody) {
        preHeaderBody.remove();
      }

      const preHeaderText = document.createTextNode(preheader);
      preHeaderBody = document.createElement('div');
      preHeaderBody.setAttribute('id', 'intkPreheaderBody');
      preHeaderBody.setAttribute('style', preHeaderCSS);
      preHeaderBody.setAttribute('class', 'intkpreheader');
      preHeaderBody.appendChild(preHeaderText);

      const elBody = el.body || el.getElementsByTagName('body')[0];

      elBody.prepend(preHeaderBody);
      let messageHtml = el.outerHTML;
      const REGEX_ATTR = /{{[a-zA-Z]+\[[^}}]*]}}+/g;
      const populatedAttrs = messageHtml.match(REGEX_ATTR);
      populatedAttrs?.forEach((item) => {
        messageHtml = messageHtml.replace(item, item.replaceAll(' ', ''));
      });

      messageWithPreheader = messageHtml;
    }

    let attachments = variation.attachments ?? [];

    if (variation.attachments && Array.isArray(variation.attachments)) {
      attachments = variation.attachments.map(({ id, file }) => ({ id, file }));
    }

    return {
      ...variation,
      attachments,
      message: messageWithPreheader,
    };
  };

  prepareOnSiteVariations = async () => {
    const onsiteVariations = this.getVariation();

    onsiteVariations.map((f) => {
      f.onSiteLayoutType =
        f.image && f.onSiteLayoutType === 'TEXT'
          ? 'TEXT_AND_IMAGE'
          : f.onSiteLayoutType;
    });

    const isValid = onsiteVariations.every((item) => {
      switch (item.onSiteLayoutType) {
        case 'IMAGE':
          return item?.image;
        case 'TEXT':
          return (
            item?.subject &&
            ((item.androidButton1Label && item.androidButton1OnClickAction) ||
              (!item.androidButton1Label && !item.androidButton1OnClickAction))
          );
        case 'TEXT_AND_IMAGE':
          return (
            item?.subject &&
            item?.image &&
            ((item.androidButton1Label && item.androidButton1OnClickAction) ||
              (!item.androidButton1Label && !item.androidButton1OnClickAction))
          );
        case 'COUPON':
          return item?.subject && item?.couponCode;

        default:
          return false;
      }
    });
    if (!isValid) return;
    try {
      await this.formRef.current.validateFields();

      const variations = onsiteVariations.map((variation) => ({
        ...variation,
        configuration: this.parseOnSiteConfiguration(variation),
        theme: {
          ...(variation.theme || {}),
          // Clear silent/stock advancedCss — API rejects it ("Invalid css…").
          // Preview layout fixes stay in prepareOnSitePreviewHtml only.
          advanced_css: sanitizeOnSiteAdvancedCss(
            variation.theme?.advanced_css,
            variation.onSiteLayoutType
          ),
        },
      }));

      return variations;
    } catch (errorInfo) {
      return;
    }
  };

  prepareInAppVariations = async () => {
    const inAppVariations = this.getVariation();
    const isValid = inAppVariations.every((item) => {
      switch (item.inAppLayoutType) {
        case 'IMAGE_ONLY':
          return item?.image;
        case 'BANNER':
        case 'BANNER_RTL':
          return item?.message && item?.subject;

        case 'MODAL':
          return (
            item?.message &&
            item?.subject &&
            ((item.androidButton1Label && item.androidButton1OnClickAction) ||
              (!item.androidButton1Label && !item.androidButton1OnClickAction))
          );

        case 'CARD':
          return (
            item?.message &&
            item?.subject &&
            item?.image &&
            item.androidButton1Label &&
            item.androidButton1OnClickAction &&
            ((item.androidButton2Label && item.androidButton2OnClickAction) ||
              (!item.androidButton2Label && !item.androidButton2OnClickAction))
          );
        case 'COUPON':
          return item?.subject && item?.message && item?.couponCode;
        default:
          return false;
      }
    });
    if (!isValid) return;
    try {
      await this.formRef.current.validateFields();

      const variations = inAppVariations.map((variation) => ({
        ...variation,
        configuration: this.parseInAppConfiguration(variation),
      }));

      return variations;
    } catch (errorInfo) {
      return;
    }
  };

  previewMessage = async (index) => {
    this.setState({ isInPreviewMode: true });
    if (this.channel === 'ON_SITE') {
      if (this.props.currentMessage?.variationType === 'SURVEY') {
        const data = this.state.newVariations;

        if (data.setting?.layout !== 'ON_SITE_MODAL') {
          delete data?.questionHeader;
        }

        const newVariations = this.handleTransformNewVariations(data);

        this.props.communicationUpdateSubmitMessageFetch(
          this.communicationId,
          {
            newVariations,
            variations: [],
          },
          this.props.journey,
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          ),
          () => {
            if (this.props.currentMessage.newVariations[0]?.id) {
              this.props.communicationPreviewFetch(
                this.communicationId,
                this.props.currentMessage.newVariations[0]?.id
              );
            }
          },
          this.isEditDisable()
        );
        return;
      } else {
        const variations = await this.prepareOnSiteVariations();
        if (!variations) {
          return showMessage('Some fields are required', 'error');
        }

        const _variations = [];

        if (Array.isArray(variations)) {
          variations.forEach((item, index) => {
            _variations[index] = item;
            _variations[index].carouselImages = [];
            _variations[index].attachments = [];

            if (this.props.currentMessage.variations[index]?.id) {
              _variations[index]['id'] =
                this.props.currentMessage.variations[index]?.id;
            }
          });
        }

        this.props.communicationUpdateSubmitMessageFetch(
          this.communicationId,
          {
            variations: _variations,
          },
          this.props.journey,
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          ),
          (newVariations) => {
            const v =
              this.props.currentMessage?.variations?.length === 0
                ? newVariations?.variations
                : this.props.currentMessage?.variations;
            if (v[index]?.id) {
              this.props.communicationPreviewFetch(
                this.communicationId,
                v[index]?.id
              );
            }
          },
          this.isEditDisable()
        );
      }
    } else if (this.channel === 'IN_APP') {
      const variations = await this.prepareInAppVariations();

      if (!variations) {
        return showMessage('Some fields are required', 'error');
      }
      this.setState({ isInPreviewMode: true });

      const _variations = [];

      if (Array.isArray(variations)) {
        variations.forEach((item, index) => {
          _variations[index] = item;
          _variations[index].carouselImages = [];
          _variations[index].attachments = [];
          if (this.props.currentMessage.variations[index]?.id) {
            _variations[index]['id'] =
              this.props.currentMessage.variations[index]?.id;
          }
        });
      }

      this.props.communicationUpdateSubmitMessageFetch(
        this.communicationId,
        {
          variations: _variations,
        },
        this.props.journey,
        checkIsSurvey(
          this.channel,
          this.props.currentMessage,
          this.props.pathname
        ),
        (newVariations) => {
          const v =
            this.props.currentMessage?.variations?.length === 0
              ? newVariations.variations
              : this.props.currentMessage?.variations;
          if (v[index]?.id) {
            this.props.communicationPreviewFetch(
              this.communicationId,
              v[index]?.id
            );
          }
        },
        this.isEditDisable()
      );
    }
  };

  isInvalidImageUrl = (image) => {
    if (!image) return false;

    const validImageRegex = /\.(jpe?g|png|gif)(\?.*)?$/i;

    const templateRegex = /{{[^{}]+}}/g;

    if (
      templateRegex.test(image) &&
      image.replace(templateRegex, '').trim() === ''
    ) {
      return false;
    }

    return !validImageRegex.test(image);
  };

  handleClickNext = async () => {
    if (this.channel === 'PUSH') {
      const getVariation = this.getVariation();
      let isValid = true;
      getVariation.map((item) => {
        delete item.inAppLayoutType;
        delete item.onSiteLayoutType;

        if (!item.sticky) {
          delete item.androidDismissButtonLabel;
        }

        if (item.timerTemplate.countDownType === 'DURATION') {
          delete item.timerTemplate?.endTime;
        } else if (item.timerTemplate.countDownType === 'END_TIME') {
          delete item.timerTemplate?.duration;
        }

        if (item.showAndroidPushButtons) {
          item.androidButtons.map((button) => {
            if (!button?.label) {
              isValid = false;
            }
          });
        }
      });
      if (getVariation.some((f) => this.isInvalidImageUrl(f.image))) {
        return showMessage('Some image fields has invalid format', 'error');
      }

      if (!isValid) {
        return showMessage('Some fields are required', 'error');
      }
      const variations = getVariation?.map((item) => ({
        ...item,
        image: item.pushType === 'TEXT' ? null : item.image,
        timerTemplate: omitBy(item.timerTemplate, isNil),
        autoDismissDuration: item.autoDismissDuration
          ? item.autoDismissDuration *
            (this.state.pushTimerDurationMode === 'MIN' ? 60 : 3600)
          : null,
      }));
      this.props.communicationUpdateSubmitMessageFetch(
        this.communicationId,
        {
          variations,
        },
        this.props.journey,
        checkIsSurvey(
          this.channel,
          this.props.currentMessage,
          this.props.pathname
        )
      );
    } else if (this.channel === 'EMAIL') {
      if (this.isAttachmentsSizeExceeded()) {
        return showMessage(
          `The total size of the attached files (~${this.state.attachmentsThreshold.toFixed(
            1
          )}KB) exceeds the limit of 512 KB.`,
          'error'
        );
      }

      const replyToEmailError = this.checkEmailErrors('showReplyTo', 'replyTo');
      const ccEmailError = this.checkEmailErrors('showCc', 'cc');
      const bccEmailError = this.checkEmailErrors('showBcc', 'bcc');

      if (
        !isNil(
          this.checkValidEmail(
            this.state.variations[this.state.activeIndex].fromEmail
          )
        ) ||
        replyToEmailError ||
        ccEmailError ||
        bccEmailError
      ) {
        this.setState({
          emailErrors: {
            ...this.state.emailErrors,
            replyToEmailError,
            ccEmailError,
            bccEmailError,
          },
        });
        return;
      } else {
        let variations = await Promise.all(
          this.getVariation().map((variation) =>
            this.addingPreHeaderToEmailMessage(variation)
          )
        );

        variations = variations.map((variation) => {
          if (variation.cc && variation.cc.includes(',')) {
            return {
              ...variation,
              cc: variation.cc
                .split(',')
                .map((e) => e.trim())
                .filter(Boolean)
                .join(','),
            };
          }

          if (variation.bcc && variation.bcc.includes(',')) {
            return {
              ...variation,
              bcc: variation.bcc
                .split(',')
                .map((e) => e.trim())
                .filter(Boolean)
                .join(','),
            };
          }

          return variation;
        });

        this.props.communicationUpdateSubmitMessageFetch(
          this.communicationId,
          {
            variations,
          },
          this.props.journey,
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          )
        );
        if (
          !isEmpty(this.props.errorUpdateMessageSubmit) &&
          Array.isArray(this.props.errorUpdateMessageSubmit.errors) &&
          this.props.errorUpdateMessageSubmit.errors.length > 0
        ) {
          const errorKey = this.props.errorUpdateMessageSubmit.errors[0].key;
          // Extract index from error key like "variations[0].message" or handle generic "content" key
          let index = 0;
          if (
            errorKey &&
            errorKey.includes('variations[') &&
            errorKey.length > 11
          ) {
            const extractedIndex = parseInt(errorKey.substring(11, 12));
            if (!isNaN(extractedIndex)) {
              index = extractedIndex;
            }
          }
          // For "content" key or other generic keys, keep current activeIndex or use 0
          this.setState(
            {
              activeIndex: index,
            },
            () => {}
          );
        }
      }
    } else if (this.channel === 'SMS') {
      this.props.communicationUpdateSubmitMessageFetch(
        this.communicationId,
        {
          variations: this.getVariation(),
        },
        this.props.journey,
        checkIsSurvey(
          this.channel,
          this.props.currentMessage,
          this.props.pathname
        )
      );
    } else if (this.channel === 'TELEGRAM') {
      this.props.communicationUpdateSubmitMessageFetch(
        this.communicationId,
        {
          variations: this.getVariation(),
        },
        this.props.journey,
        checkIsSurvey(
          this.channel,
          this.props.currentMessage,
          this.props.pathname
        )
      );
    } else if (this.channel === 'WEB_PUSH') {
      const variations = this.getVariation()?.map((item) => ({
        ...item,
        image: item.pushType === 'TEXT' ? null : item.image,
      }));

      let isValid = true;
      variations.map((item) => {
        delete item.onSiteLayoutType;
        delete item.inAppLayoutType;

        if (item.showAndroidPushButtons) {
          item.androidButtons.map((button) => {
            if (!button?.label) {
              isValid = false;
            }
          });
        }
      });

      if (variations.some((v) => this.isInvalidImageUrl(v.image))) {
        return showMessage('Some image fields has invalid format', 'error');
      }

      if (!isValid) {
        return showMessage('Some fields are required', 'error');
      }
      this.props.communicationUpdateSubmitMessageFetch(
        this.communicationId,
        {
          variations,
        },
        this.props.journey,
        checkIsSurvey(
          this.channel,
          this.props.currentMessage,
          this.props.pathname
        )
      );
    } else if (this.channel === 'CUSTOM') {
      try {
        await this.formRef.current.validateFields();
        this.props.communicationUpdateSubmitMessageFetch(
          this.communicationId,
          {
            variations: this.getVariation(),
          },
          this.props.journey,
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          )
        );
      } catch (errorInfo) {
        return;
      }
    } else if (this.channel === 'IN_APP') {
      //check form validation

      const inAppVariations = this.getVariation();

      inAppVariations.forEach((item) => {
        delete item.pushType;
        delete item.onSiteLayoutType;
        const defaultTheme = {
          message: { color: '#000000' },
          title: { color: '#000000' },
          ...(item?.inAppLayoutType === 'MODAL' ||
          item?.inAppLayoutType === 'CARD'
            ? {
                actions: [
                  { bg_color: '#000000', style: { color: '#000000' } },
                  { bg_color: '#000000', style: { color: '#000000' } },
                ],
              }
            : {}),
          ...(item?.inAppLayoutType === 'COUPON'
            ? {
                coupon: { color: '#000000' },
                cta_background_coupon: '#000000',
                coupon_button_color: '#ee3939',
                coupon_button_hover_color: '#d15454',
              }
            : {}),
        };

        if (item?.inAppLayoutType === 'IMAGE_ONLY') {
          item.theme = {};
        } else {
          item.theme = item.theme || {};

          Object.keys(defaultTheme).forEach((key) => {
            if (
              typeof defaultTheme[key] === 'object' &&
              !Array.isArray(defaultTheme[key])
            ) {
              item.theme[key] = { ...defaultTheme[key], ...item.theme[key] };
            }
          });
        }
      });

      const isValid = inAppVariations.every((item) => {
        switch (item.inAppLayoutType) {
          case 'IMAGE_ONLY':
            return item?.image;
          case 'BANNER':
          case 'BANNER_RTL':
            return item?.message && item?.subject;

          case 'MODAL':
            return (
              item?.message &&
              item?.subject &&
              ((item.androidButton1Label && item.androidButton1OnClickAction) ||
                (!item.androidButton1Label &&
                  !item.androidButton1OnClickAction))
            );

          case 'CARD':
            return (
              item?.message &&
              item?.subject &&
              item?.image &&
              item.androidButton1Label &&
              item.androidButton1OnClickAction &&
              ((item.androidButton2Label && item.androidButton2OnClickAction) ||
                (!item.androidButton2Label &&
                  !item.androidButton2OnClickAction))
            );
          case 'COUPON':
            return item?.subject && item?.message && item?.couponCode;
          default:
            return false;
        }
      });
      if (inAppVariations.some((v) => this.isInvalidImageUrl(v.image))) {
        return showMessage('Some image fields has invalid format', 'error');
      }

      if (!isValid) return showMessage('Some fields are required', 'error');
      try {
        const variations = await this.prepareInAppVariations();
        variations.forEach((variation) => {
          variation.carouselImages = [];
          variation.attachments = [];
        });

        if (!variations) return;

        this.props.communicationUpdateSubmitMessageFetch(
          this.communicationId,
          {
            variations,
          },
          this.props.journey,
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          )
        );
        return;
      } catch (error) {
        return;
      }
    } else if (this.channel === 'ON_SITE') {
      if (this.props.currentMessage?.variationType === 'SURVEY') {
        const data = this.state.newVariations;

        if (data.setting?.layout !== 'ON_SITE_MODAL') {
          delete data?.questionHeader;
        }

        const newVariations = this.handleTransformNewVariations(data);

        this.props.communicationUpdateSubmitMessageFetch(
          this.communicationId,
          {
            newVariations,
            variations: [],
          },
          this.props.journey,
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          )
        );
        return;
      }
      //check form validation
      const onsiteVariations = this.getVariation();

      onsiteVariations.map((item) => {
        delete item.pushType;
        delete item.inAppLayoutType;
        item.onSiteLayoutType =
          item.image && item?.onSiteLayoutType === 'TEXT'
            ? 'TEXT_AND_IMAGE'
            : item?.onSiteLayoutType;
      });
      const isValid = onsiteVariations.every((item) => {
        switch (item.onSiteLayoutType) {
          case 'IMAGE':
            return item?.image;
          case 'TEXT':
            return (
              item?.subject &&
              ((item.androidButton1Label && item.androidButton1OnClickAction) ||
                (!item.androidButton1Label &&
                  !item.androidButton1OnClickAction))
            );
          case 'TEXT_AND_IMAGE':
            return (
              item?.subject &&
              item?.image &&
              ((item.androidButton1Label && item.androidButton1OnClickAction) ||
                (!item.androidButton1Label &&
                  !item.androidButton1OnClickAction))
            );
          case 'COUPON':
            return item?.subject && item?.couponCode;

          default:
            return false;
        }
      });
      if (onsiteVariations.some((v) => this.isInvalidImageUrl(v.image))) {
        return showMessage('Some image fields has invalid format', 'error');
      }

      if (!isValid) return showMessage('Some fields are required', 'error');
      try {
        const variations = await this.prepareOnSiteVariations();

        if (!variations) return;

        this.props.communicationUpdateSubmitMessageFetch(
          this.communicationId,
          {
            variations,
          },
          this.props.journey,
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          )
        );
      } catch (errorInfo) {
        return;
      }
    } else if (this.channel === 'WHATSAPP') {
      this.props.communicationUpdateSubmitMessageFetch(
        this.communicationId,
        {
          variations: this.getVariation(),
        },
        this.props.journey,
        checkIsSurvey(
          this.channel,
          this.props.currentMessage,
          this.props.pathname
        )
      );
    }
    if (
      !isEmpty(this.props.errorUpdateMessageSubmit) &&
      Array.isArray(this.props.errorUpdateMessageSubmit.errors) &&
      this.props.errorUpdateMessageSubmit.errors.length > 0
    ) {
      const errorKey = this.props.errorUpdateMessageSubmit.errors[0].key;
      // Extract index from error key like "variations[0].message" or handle generic "content" key
      let index = 0;
      if (
        errorKey &&
        errorKey.includes('variations[') &&
        errorKey.length > 11
      ) {
        const extractedIndex = parseInt(errorKey.substring(11, 12));
        if (!isNaN(extractedIndex)) {
          index = extractedIndex;
        }
      }
      // For "content" key or other generic keys, use 0 as default
      this.setState({
        activeIndex: index,
      });
    }
  };

  handleClickBack = () => {
    if (!this.props.journey) {
      history.push('audience');
    } else if (
      this.props.channel === 'IN_APP' ||
      this.props.channel === 'ON_SITE'
    ) {
      this.props.goToStepOnJourney('when');
    } else {
      this.props.goToStepOnJourney('audience');
    }
  };

  addKeyValuePair = (index) => {
    const { variations } = this.state;
    variations[index].keyValuePair.push({ key: '', value: '' });
    this.setState({ variations });
  };

  handleRemoveIosButtons = (index) => {
    const { iosButtons } = this.state;
    iosButtons.splice(index, 1);
    if (iosButtons.length === 0) {
      this.setState({ showIosPushButtons: false, iosButtons });
    } else {
      this.setState({ iosButtons });
    }
  };

  addAndroidButton = (index) => {
    const { variations } = this.state;
    const androidButtons = variations[index].androidButtons.slice(0);
    if (androidButtons.length < 2) {
      androidButtons.push({
        label: '',
        onClick: '',
      });
      this.handleChangeVariations(index, 'androidButtons', androidButtons);
    }
  };

  addDismissButton = (index) => {
    this.handleChangeVariations(index, 'androidDismissButtonLabel', '');
  };

  addIosButton = () => {
    const { iosButtons } = this.state;
    if (iosButtons.length < 2) {
      iosButtons.push({ label: '', onClick: '' });
      this.setState({ iosButtons });
    }
  };

  handleRemoveKeyValue = (index, keyValueIndex) => {
    const { variations } = this.state;
    if (variations[index].keyValuePair.length === 1 && keyValueIndex === 0) {
      variations[index].keyValuePair = [{ key: '', value: '' }];
      variations[index].showKeyValue = false;
      this.setState({ variations });
    } else {
      variations[index].keyValuePair = variations[index].keyValuePair.filter(
        (_, i) => i !== keyValueIndex
      );
      this.setState({ variations });
    }
  };

  handleChangeKeyValueKey = (index, keyValueIndex, value) => {
    const { variations } = this.state;
    variations[index].keyValuePair = [
      ...this.state.variations[index].keyValuePair.slice(0, keyValueIndex),
      {
        ...this.state.variations[index].keyValuePair[keyValueIndex],
        key: value,
      },
      ...this.state.variations[index].keyValuePair.slice(keyValueIndex + 1),
    ];
    this.setState({ variations });
    this.props.clearCommunicationMessageError(
      this.props.errorUpdateMessageSubmit.errors,
      'variations[' + [index] + '].keyValuePair[' + [keyValueIndex] + '].key'
    );
  };

  handleChangeKeyValueValue = (index, keyValueIndex, value) => {
    const { variations } = this.state;
    variations[index].keyValuePair = [
      ...this.state.variations[index].keyValuePair.slice(0, keyValueIndex),
      {
        ...this.state.variations[index].keyValuePair[keyValueIndex],
        value: value,
      },
      ...this.state.variations[index].keyValuePair.slice(keyValueIndex + 1),
    ];
    this.setState({ variations });
    this.props.clearCommunicationMessageError(
      this.props.errorUpdateMessageSubmit.errors,
      'variations[' + [index] + '].keyValuePair[' + [keyValueIndex] + '].value'
    );
  };

  handleRemoveUploaded = (selector = null) => {
    // todo
    if (!isNil(selector)) {
      if (selector === 'icon') {
        this.setState({
          uploadFileList: [],
          uploadingWebPushIcon: false,
          uploadingWebPushImage: false,
        });
      } else if (selector === 'image') {
        this.setState({ uploadFileList: [], uploadingWebPushImage: false });
      } else if (selector === 'badge') {
        this.setState({ uploadFileList: [], uploadingWebPushBadge: false });
      }
    } else {
      this.setState({ uploadFileList: [] });
    }
    this.setState({ uploadFileList: [] });
    // this.setState({ uploadFileList: [], newAction: { ...this.state.newAction, emailAttachment: null, pushPicture: null } });
    // this.props.notificationTypeUploadReset();
  };

  handleChangeAndroidPushButtons = (index) => {
    const { variations } = this.state;
    if (variations[index].showAndroidPushButtons) {
      variations[index].showAndroidPushButtons = false;
      variations[index].androidButtons = [];
      this.setState({ variations });
    } else if (!variations[index].showAndroidPushButtons) {
      variations[index].showAndroidPushButtons = true;
      variations[index].androidButtons = [{ label: '', onClick: '' }];
      this.setState({ variations });
    }
  };

  handleChangeIosPush = (index) => {
    const { variations } = this.state;
    if (variations[index].showIosPushButtons) {
      variations[index].showIosPushButtons = false;
      variations[index].iosButtons = [];
      this.setState({ variations });
    } else if (!variations[index].showIosPushButtons) {
      variations[index].showIosPushButtons = true;
      variations[index].iosButtons = [];
      this.setState({ variations });
    }
  };

  handleRevertNewVariations = (transformed) => {
    const [item] = transformed || [];

    const styles = { theme: item?.message?.theme ?? '' };

    if (!item?.message) return [];

    const { layout, language, css, questionHeader, steps = [] } = item?.message;

    if (css) styles['css'] = css;

    const data = { setting: { layout, language }, styles };

    const count = steps.length;

    let start = 0;
    let end = count;

    const maybeWelcome = steps[0];

    const maybeExitPoint = steps[count - 1];

    const email = steps[count - 2];

    const isEmail = email && email?.question?.type === 'TEXT_BOX';

    if (maybeWelcome?.type === 'STATIC') {
      start = 1;
    }

    if (maybeExitPoint?.type === 'STATIC') {
      end = end - 1;
    }

    if (isEmail) {
      end = end - 1;
    }

    const questions = steps.slice(start, end) || [];

    if (questionHeader) data['questionHeader'] = questionHeader;

    if (maybeWelcome && maybeWelcome?.type === 'STATIC') {
      data['welcome'] = maybeWelcome;
    }

    if (maybeExitPoint && maybeExitPoint?.type === 'STATIC') {
      data['exitPoint'] = maybeExitPoint;
    }
    if (isEmail) data['email'] = email;
    if (questions) data['questions'] = questions;
    return [{ ...data, styles }];
  };

  handleTransformNewVariations = (variation) => {
    const { styles = {}, setting, questionHeader, ...config } = variation;

    let steps = this.getTransformedSteps(config);

    if (steps.some((step) => !step?.id)) {
      steps = steps.map((s) => {
        if ('id' in s) delete s['id'];

        return s;
      });
    }

    const message = { ...setting, steps };

    if (styles?.css) message['css'] = styles?.css;
    if (questionHeader) message['questionHeader'] = questionHeader;

    return [
      {
        type: 'SURVEY',
        percentage: 100,

        message: {
          id: this.props.currentMessage?.newVariations[0]?.message?.id || null,
          theme: styles?.theme,
          ...message,
        },
        id: this.props.currentMessage?.newVariations[0]?.id || null,
      },
    ];
  };

  getTransformedSteps = (config) => {
    const { email, welcome, questions = [], exitPoint } = config ?? {};

    const { enabled, ...emailProps } = email ?? {};

    const steps = [
      welcome?.body ? welcome : undefined,
      ...questions,
      enabled ? emailProps : undefined,
      exitPoint?.body ? exitPoint : undefined,
    ].filter(Boolean);

    return steps;
  };

  handleChangeNewVariations = (name, value) => {
    this.setState({
      newVariations: { ...this.state.newVariations, [name]: value },
      //merge({}, this.state.newVariations, { [name]: value }),
    });
  };

  handleChangeStickyCountdown = (index, name, value, countDownType) => {
    const { variations } = this.state;
    if (variations[index] && variations[index]['timerTemplate']) {
      variations[index]['timerTemplate'][name] = value;

      if (name !== 'countDownType') {
        variations[index]['timerTemplate']['countDownType'] = countDownType;
      }
    }

    this.setState({ variations });
  };

  handleChangeVariations = (index, name, value) => {
    this.setState({
      uploadingWebPushIcon: false,
      uploadingWebPushImage: false,
    });
    const { variations } = this.state;
    const current = variations[index];

    // Merge configuration updates so position/layout changes do not wipe
    // fallbackMetric / responsiveMetrics already stored on the variation.
    if (name === 'configuration' && current) {
      variations[index] = {
        ...current,
        configuration: {
          ...(current.configuration || {}),
          ...value,
        },
      };
      this.setState({ variations });
      return;
    }

    if (name === 'fallbackMetric' && current) {
      const config = current.configuration || {};

      variations[index] = {
        ...current,
        configuration: {
          ...config,
          fallbackMetric: {
            ...config.fallbackMetric,
            ...value,
          },
        },
      };

      this.setState({ variations });
      return;
    }

    if (variations[index]) {
      variations[index][name] = value;

      if (name === 'sticky' && value === false) {
        variations[index]['autoDismiss'] = false;
      }
    }
    if (name === 'pushType' && value === 'TIMER') {
      variations[index]['sticky'] = true;
    }

    if (['pushType', 'inAppLayoutType', 'onSiteLayoutType'].includes(name)) {
      variations[index]['layoutType'] = value;
    }

    this.setState({ variations });

    if (name === 'image') {
      let { imageUrlFormatError } = this.state;
      if (isEmpty(value)) {
        imageUrlFormatError = false;
      } else {
        if (value.includes('.')) {
          const imageUrl = value.includes('?') ? value.split('?')[0] : value;

          const accepted = ['jpg', 'jpeg', 'png', 'gif'];

          imageUrlFormatError = !accepted.some((a) => imageUrl.endsWith(a));
        } else {
          imageUrlFormatError = true;
        }
      }
      this.setState({ imageUrlFormatError });
    }
    if (
      name === 'smsChannel' ||
      name === 'message' ||
      name === 'emailChannel' ||
      name === 'fromName' ||
      name === 'fromEmail' ||
      name === 'subject' ||
      name === 'image'
    ) {
      this.props.clearCommunicationMessageError(
        this.props.errorUpdateMessageSubmit.errors,
        'variations[' + [index] + '].' + name
      );
    }
    if (name === 'replyTo') {
      this.setEmailError('replyToEmailError', false);
    }
    if (name === 'cc') {
      this.setEmailError('ccEmailError', false);
    }
    if (name === 'bcc') {
      this.setEmailError('bccEmailError', false);
    }
    if (name === 'customChannel') {
      // fetch specific customChannel
      this.props.customChannelUpdateFetch(value);
    }
  };

  setOnSiteMobileDimension = (index, key, dimension) => {
    const config = this.state.variations[index]?.configuration || {};
    this.handleChangeVariations(index, 'configuration', {
      responsiveMetrics: setMobileBreakpointDimension(
        config.responsiveMetrics,
        key,
        dimension
      ),
    });
  };

  checkValidImageUrl = (url) => {
    // var types = ['jpg', 'jpeg', 'png', 'gif'];
    if (isNil(url) || isEmpty(url)) {
      return true;
    }
    // else {
    //   var parts = url.split('.');
    //   var extension = parts[parts.length - 1];
    //   if (types.indexOf(extension) !== -1) {
    //     return true;
    //   }
    // }
  };

  handleChangeIosPushButtonType = (index, iosPushButtonType) => {
    let iosButtons = [];
    if (iosPushButtonType === this.iosPushButtonType.YES_NO_OPEN_DISMISS) {
      iosButtons.push({ label: 'Yes', onClick: '', disable: false });
      iosButtons.push({
        label: 'No',
        onClick: 'Dismisses the notification',
        disable: true,
      });
    } else if (iosPushButtonType === this.iosPushButtonType.YES_NO_DISMISS) {
      iosButtons.push({
        label: 'Yes',
        onClick: 'Dismisses the notification',
        disable: true,
      });
      iosButtons.push({
        label: 'No',
        onClick: 'Dismisses the notification',
        disable: true,
      });
    } else if (
      iosPushButtonType === this.iosPushButtonType.ACCEPT_DECLINE_OPEN_DISMISS
    ) {
      iosButtons.push({ label: 'Accept', onClick: '', disable: false });
      iosButtons.push({
        label: 'Decline',
        onClick: 'Dismisses the notification',
        disable: true,
      });
    } else if (
      iosPushButtonType === this.iosPushButtonType.ACCEPT_DECLINE_DISMISS
    ) {
      iosButtons.push({
        label: 'Accept',
        onClick: 'Dismisses the notification',
        disable: true,
      });
      iosButtons.push({
        label: 'Decline',
        onClick: 'Dismisses the notification',
        disable: true,
      });
    } else if (iosPushButtonType === this.iosPushButtonType.SHOP_NOW) {
      iosButtons.push({ label: 'Shop Now', onClick: '', disable: false });
    } else if (iosPushButtonType === this.iosPushButtonType.BUY_NOW) {
      iosButtons.push({ label: 'Buy Now', onClick: '', disable: false });
    } else if (iosPushButtonType === this.iosPushButtonType.DOWNLOAD) {
      iosButtons.push({ label: 'Download', onClick: '', disable: false });
    }
    const { variations } = this.state;
    variations[index].iosPushButtonType = iosPushButtonType;
    variations[index].iosButtons = iosButtons;
    this.setState({ variations });
  };

  handleSelectUpload = ({ fileList }, index, attachmentIndex) => {
    if (
      Array.isArray(fileList) &&
      fileList.length > 0 &&
      fileList[0].originFileObj
    ) {
      this.setState(
        {
          uploadingAttachmentIndex: attachmentIndex,
          uploadingVariationIndex: index,
          currentUploadedAttachmentSize: (fileList[0]?.size ?? 0) / 1024,
        },
        () => {
          if (this.channel === 'EMAIL') {
            this.calcAttachmentsThreshold(
              this.state.variations[index].attachments,
              fileList[0].size
            ).then((attachmentsThreshold) => {
              this.setState({ attachmentsThreshold });
            });
          }

          this.props.communicationUploadFileFetch(fileList[0].originFileObj);

          this.props.clearCommunicationMessageError(
            this.props.errorUpdateMessageSubmit.errors,
            'variations[' +
              [index] +
              '].attachments[' +
              [attachmentIndex] +
              '].file'
          );
        }
      );
    }
  };

  handleSelectImage = ({ fileList }, index, selector = null) => {
    if (
      Array.isArray(fileList) &&
      fileList.length > 0 &&
      fileList[0].originFileObj
    ) {
      this.setState({ uploadingImageVariationIndex: index }, () => {
        if (!isNil(selector)) {
          if (selector === 'icon') {
            this.setState({ uploadingWebPushIcon: true });
          } else if (selector === 'image') {
            this.setState({ uploadingWebPushImage: true });
          } else if (selector === 'badge') {
            this.setState({ uploadingWebPushBadge: true });
          }
        }
        this.props.communicationUploadPublicFileFetch(
          fileList[0].originFileObj
        );
        this.props.clearCommunicationMessageError(
          this.props.errorUpdateMessageSubmit.errors,
          'variations[' + [index] + '].image'
        );
      });
    }
  };

  handleClickActiveVariation = (activeIndex) => {
    this.setState({ activeIndex });
  };

  handleChangeButtonsAttribute = (
    index,
    buttonName,
    buttonIndex,
    name,
    value
  ) => {
    const { variations } = this.state;
    const buttons = variations[index][buttonName].slice(0);

    buttons[buttonIndex][name] = value;
    this.handleChangeVariations(index, buttonName, buttons);
  };

  handleRemoveButtons = (index, buttonName, buttonIndex) => {
    const { variations } = this.state;

    const buttons = variations[index][buttonName].slice(0);
    buttons.splice(buttonIndex, 1);
    variations[index][buttonName] = buttons;
    if (buttons.length === 0 && buttonName === 'androidButtons') {
      variations[index].showAndroidPushButtons = false;
      this.setState({ variations });
    } else {
      this.setState({ variations });
    }
  };

  selectDragAndDropEditor = (index) => {
    if (
      this.state.variations[index].message &&
      this.state.selectedTemplateHtml ===
        this.state.variations[index].message &&
      this.state.selectedTemplateJson
    ) {
      this.setState({
        editCurrentTemplateVisible: true,
        canEditSelectedTemplate: true,
      });
    } else {
      this.props.emailTemplateListAllFetch();
      this.setState({ emailBodyType: 'drag', selectedEmailTemplate: null });
    }
  };

  selectTemplate = (id) => {
    this.props.emailTemplateToggleModal(false, id, true);
    this.setState({ templateModalVisible: true });
    this.props.clearCommunicationMessageError(
      this.props.errorUpdateMessageSubmit.errors,
      'variations[' + [this.state.activeIndex] + '].message'
    );
  };

  showAndroidIosPreview = () => {
    return (
      this.props.currentAudience ||
      isNil(this.props.currentAudience.mobileDevice)
    );
  };

  selectPushType = (index, pushType) => {
    this.setState({ isLayoutSelectorOpen: false }, () => {
      this.handleChangeVariations(index, 'pushType', pushType);
      if (pushType === 'TEXT') {
        this.handleChangeVariations(index, 'image', null);
      }
    });
  };

  selectInAppType = (index, layoutType) => {
    this.setState({ isLayoutSelectorOpen: false }, () => {
      this.handleChangeVariations(index, 'inAppLayoutType', layoutType);

      switch (layoutType) {
        case 'IMAGE_ONLY':
          this.handleChangeVariations(index, 'theme', {});
          this.handleChangeVariations(index, 'configuration', {
            position: 'CENTER_TOP',
          });
          this.handleChangeVariations(index, 'androidButton1Label', null);
          this.handleChangeVariations(
            index,
            'androidButton1OnClickAction',
            null
          );
          this.handleChangeVariations(index, 'androidButton2Label', null);
          this.handleChangeVariations(
            index,
            'androidButton2OnClickAction',
            null
          );
          this.handleChangeVariations(index, 'subject', 'Subject...');
          this.handleChangeVariations(index, 'message', 'Message...');
          break;
        case 'BANNER':
        case 'BANNER_RTL':
          this.handleChangeVariations(index, 'androidButton1Label', null);
          this.handleChangeVariations(index, 'configuration', {
            position: 'CENTER_TOP',
          });
          this.handleChangeVariations(
            index,
            'androidButton1OnClickAction',
            null
          );
          this.handleChangeVariations(index, 'androidButton2Label', null);
          this.handleChangeVariations(
            index,
            'androidButton2OnClickAction',
            null
          );
          break;
        case 'MODAL':
          this.handleChangeVariations(index, 'androidButton2Label', null);
          this.handleChangeVariations(index, 'configuration', {
            position: 'CENTER',
          });
          this.handleChangeVariations(
            index,
            'androidButton2OnClickAction',
            null
          );
          break;
        case 'CARD':
          this.handleChangeVariations(index, 'configuration', {
            position: 'CENTER',
          });
          break;
        case 'COUPON':
          this.handleChangeVariations(index, 'configuration', {
            position: 'CENTER',
          });
          break;
        default:
          break;
      }
    });
  };

  applyOnSiteSizeConfig = (index, { sizeMode, sizePreset }) => {
    const current = this.state.variations[index]?.configuration || {};
    const previousSizeMode = getEffectiveSizeMode(current);
    const patch = resolveOnSiteSizeConfig({
      sizeMode,
      sizePreset:
        sizePreset != null ? sizePreset : getEffectiveSizePreset(current),
      fallbackMetric: current.fallbackMetric,
      responsiveMetrics: current.responsiveMetrics,
      previousSizeMode,
    });
    this.handleChangeVariations(index, 'configuration', patch);
    const updatedConfig = {
      ...(current || {}),
      ...patch,
    };
    this.formRef.current?.setFieldsValue({
      [`variations[${index}].configuration`]: updatedConfig,
    });
  };

  selectOnSiteType = (index, onSiteLayoutType) => {
    this.setState({ isLayoutSelectorOpen: false }, () => {
      this.handleChangeVariations(index, 'onSiteLayoutType', onSiteLayoutType);
    });

    switch (onSiteLayoutType) {
      case 'TEXT':
      case 'IMAGE':
      case 'COUPON': {
        const current = this.state.variations[index]?.configuration || {};
        const sizeMode = getEffectiveSizeMode(current);
        const sizePatch = resolveOnSiteSizeConfig({
          sizeMode,
          sizePreset: getEffectiveSizePreset(current),
          fallbackMetric: current.fallbackMetric,
          responsiveMetrics: current.responsiveMetrics,
          // Same mode — not a user switch; keep existing metrics intact.
          previousSizeMode: sizeMode,
        });
        this.handleChangeVariations(index, 'configuration', {
          position: 'CENTER',
          ...sizePatch,
        });
        break;
      }
      default:
        break;
    }
  };

  cancelEditCurrentTemplate = () => {
    this.setState({
      editCurrentTemplateVisible: false,
      emailBodyType: 'drag',
      selectedEmailTemplate: null,
    });
  };

  continueEditCurrentTemplate = () => {
    if (this.state.selectedEmailTemplate) {
      this.setState({
        editCurrentTemplateVisible: false,
        canEditSelectedTemplate: true,
        templateModalVisible: true,
      });
    } else {
      this.setState({
        editCurrentTemplateVisible: false,
        canEditSelectedTemplate: true,
      });

      this.props.emailTemplateToggleModal(true, undefined, true);
    }
  };

  continueSelectTemplate = () => {
    this.setState({
      templateModalVisible: false,
      canEditSelectedTemplate: false,
    });

    this.props.emailTemplateToggleModal(true, undefined, true);
  };

  cancelSelectTemplateModal = () => {
    this.setState({
      emailBodyType: 'raw',
      templateModalVisible: false,
      canEditSelectedTemplate: false,
      selectedEmailTemplate: null,
    });
  };

  checkValidEmail = (value) => {
    const e = value?.trim();

    if (e && e.includes(',')) {
      const emails = e
        .split(',')
        .map((email) => email.trim())
        .filter(Boolean);

      if (
        emails.length > 0 &&
        !emails.every((email) => emailRegEx.test(email))
      ) {
        return 'error';
      }

      return null;
    }

    if (!isEmpty(value) && !emailRegEx.test(e)) {
      return 'error';
    }
    return null;
  };

  renderMobileNumber = (variationIndex) => {
    let result = '8758316578';
    const { variations } = this.state;
    if (
      variations[variationIndex] &&
      !isNil(variations[variationIndex].smsChannel)
    ) {
      const foundItem = lodashFind(
        this.props.smsChannels,
        (item) => item.id === variations[variationIndex].smsChannel
      );
      if (foundItem && !isNil(foundItem.name)) {
        result = foundItem.name;
      }
    }
    return result;
  };

  isEdited = () => {
    const variations = this.getVariation();
    if (
      (this.props.currentMessage?.variations?.length !== 0 &&
        this.props.currentMessage?.variations?.length < variations?.length) ||
      this.props.currentMessage?.variations?.length > variations?.length
    ) {
      return true;
    }

    let sourceKeys = [
      { key: 'id', defaultValue: undefined },
      { key: 'message', defaultValue: '' },
      { key: 'subject', defaultValue: '' },
      { key: 'percentage', defaultValue: '100' },
    ];
    if (this.channel === 'PUSH' || this.channel === 'WEB_PUSH') {
      let sourceKeysPush = [
        { key: 'pushType', defaultValue: 'TEXT' },
        { key: 'image', defaultValue: undefined },
        { key: 'androidOnClickAction', defaultValue: null },
        { key: 'androidButton1Label', defaultValue: null },
        { key: 'androidButton1OnClickAction', defaultValue: null },
        { key: 'androidButton2Label', defaultValue: null },
        { key: 'androidButton2OnClickAction', defaultValue: null },
        { key: 'keyValuePair', defaultValue: [] },
      ];
      let sourceKeysWebPush = [
        { key: 'icon', defaultValue: undefined },
        { key: 'badge', defaultValue: undefined },
        { key: 'autoHide', defaultValue: true },
      ];
      if (this.channel === 'PUSH') {
        sourceKeys = sourceKeys.concat(sourceKeysPush);
      } else if (this.channel === 'WEB_PUSH') {
        sourceKeys = sourceKeys.concat(sourceKeysPush, sourceKeysWebPush);
      }
    } else if (this.channel === 'SMS') {
      sourceKeys = sourceKeys.concat([
        { key: 'smsChannel', defaultValue: null },
      ]);
    } else if (this.channel === 'TELEGRAM') {
      sourceKeys = sourceKeys.concat([
        { key: 'telegramChannel', defaultValue: null },
      ]);
    } else if (this.channel === 'EMAIL') {
      sourceKeys = sourceKeys.concat([
        { key: 'emailChannel', defaultValue: null },
        { key: 'json', defaultValue: undefined },
        { key: 'fromName', defaultValue: undefined },
        { key: 'fromEmail', defaultValue: undefined },
        { key: 'replyTo', defaultValue: null },
        { key: 'cc', defaultValue: null },
        { key: 'bcc', defaultValue: null },
        { key: 'attachments', defaultValue: [] },
      ]);
    } else if (this.channel === 'CUSTOM') {
      sourceKeys = sourceKeys.concat([
        { key: 'customChannel', defaultValue: null },
        { key: 'icon', defaultValue: undefined },
        { key: 'image', defaultValue: undefined },
        { key: 'keyValuePair', defaultValue: [] },
        { key: 'attachments', defaultValue: [] },
      ]);
    } else if (this.channel === 'IN_APP') {
      sourceKeys = sourceKeys.concat([
        { key: 'inAppLayoutType', defaultValue: 'MODAL' },
        {
          key: 'theme',
          defaultValue: {},
        },
        { key: 'image', defaultValue: undefined },
        { key: 'androidButton1Label', defaultValue: null },
        { key: 'androidButton1OnClickAction', defaultValue: null },
      ]);
    } else if (this.channel === 'ON_SITE') {
      sourceKeys = sourceKeys.concat([
        { key: 'onSiteLayoutType', defaultValue: 'TEXT' },
        { key: 'label', defaultValue: '' },
        { key: 'couponCode', defaultValue: undefined },
        { key: 'androidButton1Labe', defaultValue: null },
        { key: 'androidButton1OnClickAction', defaultValue: null },
        { key: 'theme', defaultValue: {} },
        { key: 'image', defaultValue: undefined },
      ]);
    }

    const changedCurrentMessage = this.props.currentMessage?.variations?.some(
      (sVar, idx) => {
        const res = sourceKeys.some((key) => {
          const src = this.props.currentMessage?.variations?.[idx]?.[key.key];
          const dest = variations?.[idx]?.[key.key];
          var isChanged = false;
          var cond1 =
            (src === null || src === undefined) &&
            (dest === null || dest === undefined);
          var cond2 =
            (src === null || src === undefined) && dest === key.defaultValue;
          var cond3 = src == dest;
          var cond4 =
            isEqual(src, dest) &&
            (isArray(src) || isObject(src)) &&
            (isArray(dest) || isObject(dest));
          if (cond1 || cond2 || cond3 || cond4) isChanged = false;
          else isChanged = true;
          return isChanged;
        });
        return res;
      }
    );

    if (this.props.currentMessage?.variations?.length === 0) {
      const result = sourceKeys.some((key) => {
        const src = sourceKeys.filter((t) => t.key === key.key)[0].defaultValue;
        if (variations[0] !== undefined) {
          const dest = variations[0][key.key];
          var cond1 =
            (src === null || src === undefined) &&
            (dest === null || dest === undefined || dest === '' || src === '');
          var cond2 =
            (src === null || src === undefined) && dest === key.defaultValue;
          var cond3 = src == dest;
          var cond4 =
            isEqual(src, dest) &&
            (isArray(dest) || isArray(dest) || isObject(src) || isObject(src));
          var noChanged = cond1 || cond2 || cond3 || cond4;

          return !noChanged;
        }
        return false;
      });
      return result;
    }
    if (this.props.currentMessage?.variations?.length >= 1) {
      return changedCurrentMessage;
    }
  };

  renderSteps = () => {
    let steps = null;

    if (this.props.journey) {
      steps = this.props.journeySteps;
    }
    if (this.communicationHasJourneyType()) {
      steps = journeySteps;
    }
    if (this.props.currentMessage?.type === 'TRANSACTIONAL') {
      steps = transactionalSteps;
    }
    return (
      <CommunicationStepsComponent
        step={
          checkIsSurvey(
            this.channel,
            this.props.currentMessage,
            this.props.pathname
          )
            ? 'question'
            : 'message'
        }
        isSurvey={checkIsSurvey(
          this.channel,
          this.props.currentMessage,
          this.props.pathname
        )}
        isEdited={this.isEdited}
        campaignType={
          this.props.currentMessage && this.props.currentMessage?.type
        }
        creationStep={
          this.props.currentMessage && this.props.currentMessage?.creationStep
            ? this.props.currentMessage?.creationStep
            : null
        }
        steps={steps}
        journey={this.props.journey}
        goToStepOnJourney={this.props.goToStepOnJourney}
        channel={this.channel}
      />
    );
  };

  renderUploader = (index) => {
    const showButton = this.channel === 'EMAIL' || this.channel === 'CUSTOM';

    const attachmentIndex =
      this.state.variations[index].attachments.length ?? 0;

    const attachment =
      this.state.variations[index] &&
      this.state.variations[index].attachments &&
      Array.isArray(this.state.variations[index].attachments);

    return (
      <Upload
        multiple={false}
        disabled={this.props.readOnly || this.isEditDisable()}
        fileList={attachment && attachment.file ? [attachment] : []}
        onChange={(object) =>
          this.handleSelectUpload(object, index, attachmentIndex)
        }
        onRemove={this.handleRemoveUploaded}
        beforeUpload={() => false}
        data-cy="upload-file"
      >
        {showButton && (
          <Button
            type="primary"
            disabled={
              this.props.readOnly ||
              this.isEditDisable() ||
              this.isAttachmentsSizeExceeded()
            }
            loading={
              this.props.loadingUploadFile &&
              attachmentIndex === this.state.uploadingAttachmentIndex
            }
          >
            Add Attachment
          </Button>
        )}
      </Upload>
    );
  };

  renderWebPushIconUploader = (selector, index) => {
    const acceptedImageUrlFormat = '.jpeg,.jpg,.png,.gif';
    let showButton = false;
    const image =
      this.state.variations[index] && this.state.variations[index][selector]
        ? this.state.variations[index][selector]
        : null;
    if (this.channel === 'WEB_PUSH' || this.channel === 'CUSTOM') {
      showButton = isNil(image);
    }
    if (showButton) {
      const props = {
        beforeUpload: (file) => {
          const validUrl =
            file.type.includes('png') ||
            file.type.includes('jpg') ||
            file.type.includes('jpeg');
          if (!validUrl) {
            message.error('Invalid Image URL');
          }
          return validUrl || Upload.LIST_IGNORE;
        },
        onChange: (info) => {
          console.log(info.fileList);
        },
      };
      return (
        <Upload
          {...props}
          accept={acceptedImageUrlFormat}
          disabled={this.isEditDisable()}
          fileList={image ? [image] : []}
          id={selector}
          key={selector}
          onChange={(object) => this.handleSelectImage(object, index, selector)}
          onRemove={() => this.handleRemoveUploaded(selector)}
          beforeUpload={() => false}
        >
          <Button
            id={selector}
            key={selector}
            disabled={
              this.isEditDisable() ||
              this.state.variations[index]?.checkedDefaultLogo
            }
            type="primary"
            shape="round"
            size={'small'}
            ghost
            loading={
              selector === 'icon'
                ? this.state.uploadingWebPushIcon
                : this.state.uploadingWebPushImage
            }
            style={{
              top: -11,
            }}
          >
            Upload
          </Button>
        </Upload>
      );
    }
    return null;
  };

  renderPushUploader = (selector, index) => {
    const acceptedImageUrlFormat = '.jpeg,.jpg,.png,.gif';
    let showButton = false;
    const image =
      this.state.variations[index] && this.state.variations[index].image
        ? this.state.variations[index].image
        : null;
    if (
      this.channel === 'PUSH' ||
      this.channel === 'CUSTOM' ||
      this.channel === 'IN_APP' ||
      this.channel === 'ON_SITE'
    ) {
      showButton = isNil(image);
    }
    if (showButton) {
      return (
        <Upload
          beforeUpload={() => false}
          accept={acceptedImageUrlFormat}
          disabled={this.isEditDisable()}
          fileList={image ? [image] : []}
          onChange={(object) => this.handleSelectImage(object, index, selector)}
          onRemove={this.handleRemoveUploaded}
        >
          <Button
            data-cy="upload-image"
            disabled={this.isEditDisable()}
            type="primary"
            shape="round"
            size={'small'}
            ghost
            loading={
              this.props.loadingUploadFile && this.state.uploadingWebPushImage
            }
          >
            Upload
          </Button>
        </Upload>
      );
    }
    return null;
  };

  renderFooter = (index) => {
    let steps = null;
    const isSurvey = checkIsSurvey(
      this.channel,
      this.props.currentMessage,
      this.props.pathname
    );

    if (this.props.journey) {
      steps = this.props.journeySteps;
    }
    if (this.communicationHasJourneyType()) {
      steps = journeySteps;
    }
    if (this.props.currentMessage?.type === 'TRANSACTIONAL') {
      steps = transactionalSteps;
    }
    return (
      <CommunicationFooterComponent
        isEdited={this.isEdited}
        step={isSurvey ? 'question' : 'message'}
        invisiblePreview={['EMAIL', 'CUSTOM'].includes(this.channel)}
        isSurvey={isSurvey}
        channel={this.channel}
        loadingNext={this.props.loadingUpdateMessageSubmit}
        showLayoutPreview={() => this.setState({ isInPreviewMode: true })}
        steps={steps}
        journey={this.props.journey}
        readOnly={this.props.readOnly || this.isEditDisable()}
        handleClickNext={() => this.handleClickNext()}
        handleClickBack={() => this.handleClickBack()}
        previewMessage={() => this.previewMessage(index)}
      />
    );
  };

  renderTemplateDetectedModal = () => {
    if (this.state.editCurrentTemplateVisible) {
      return (
        <Modal
          width={600}
          title={'HTML is detected for drag & drop parser'}
          centered
          open={this.state.editCurrentTemplateVisible}
          onOk={() => this.continueEditCurrentTemplate()}
          onCancel={() => this.cancelEditCurrentTemplate()}
          okText={'Edit current data'}
          cancelText={'Start a fresh template'}
        >
          <div>
            <div>
              Would you like to edit current HTML data in drag & drop editor?
              Instead of edit current data, you can start with a fresh template
              that replace content in the email body.
            </div>
          </div>
        </Modal>
      );
    }
    return null;
  };

  renderTemplateModalVisible = () => {
    if (this.state.templateModalVisible) {
      return (
        <Modal
          width={600}
          title={
            this.props.currentTemplate && this.props.currentTemplate.name
              ? 'Select Email Template: ' + this.props.currentTemplate.name
              : 'Select Email Template'
          }
          centered
          open={this.state.templateModalVisible}
          onOk={() => this.continueSelectTemplate()}
          onCancel={() => this.cancelSelectTemplateModal()}
          okText={'Continue'}
        >
          <div>
            {this.props.loadingViewTemplate ? (
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Spin />
              </div>
            ) : (
              <div>
                Are you sure to select this email template? Current body will be
                replaced.
              </div>
            )}
          </div>
        </Modal>
      );
    }
  };

  renderPushModalVisible = (index) => {
    return (
      <Modal
        width={550}
        title={'Select a Layout'}
        centered
        footer={null}
        open={this.state.isLayoutSelectorOpen}
        onOk={() => this.setState({ isLayoutSelectorOpen: false })}
        onCancel={() => this.setState({ isLayoutSelectorOpen: false })}
      >
        <div style={styles.methodsContainer}>
          <div
            onClick={() => this.selectPushType(index, 'TEXT')}
            className="method-push-container"
            style={styles.methodContainer}
          >
            <div style={styles.methodTitle}>Text</div>
            <div>
              <img
                src={this.channel === 'PUSH' ? pushTextPng : webTextPng}
                style={{ maxWidth: '100%' }}
                alt=""
              />
            </div>
          </div>
          <div
            data-cy="push-layout-banner"
            onClick={() => this.selectPushType(index, 'BANNER')}
            className="method-push-container"
            style={styles.methodContainer}
          >
            <div style={styles.methodTitle}>Banner</div>
            <div>
              <img
                src={this.channel === 'PUSH' ? pushBannerPng : webBannerPng}
                style={{ maxWidth: '100%' }}
                alt=""
              />
            </div>
          </div>
          {this.channel === 'PUSH' && (
            <div
              onClick={() => this.selectPushType(index, 'TIMER')}
              className="method-push-container"
              style={styles.methodContainer}
            >
              <div style={styles.methodTitle}>Timer</div>
              <div>
                <img
                  src={this.channel === 'PUSH' ? pushTimerPng : webTextPng}
                  style={{ maxWidth: '100%', height: 237 }}
                  alt=""
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  };

  renderWhatsAppModalVisible = (index) => {
    const columns = [
      {
        title: 'TEMPLATE NAME',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'TEMPLATE TEXT',
        dataIndex: 'bodyText',
        key: 'bodyText',
        render: (x) => (
          <div
            style={{
              display: 'inline-block',
              width: '300px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {x}
          </div>
        ),
        width: 300,
      },
      {
        title: 'TEMPLATE TYPE',
        dataIndex: 'headerType',
        key: 'headerType',
      },
      {
        title: 'WSP',
        dataIndex: ['whatsAppChannel', 'name'],
        key: 'wsp',
      },
    ];

    return (
      <Modal
        width={'70%'}
        title={'Select a Layout'}
        centered
        footer={null}
        open={this.state.isLayoutSelectorOpen}
        onOk={() => this.setState({ isLayoutSelectorOpen: false })}
        onCancel={() => this.setState({ isLayoutSelectorOpen: false })}
      >
        <ListBase
          page={this.props.whatsAppTemplate}
          columns={columns}
          pageRequest={this.props.whatsAppTemplatePageRequest}
          onChange={this.props.whatsappChannelTemplateListFetch}
          onClick={(row) => {
            this.setState({ isLayoutSelectorOpen: false });
            this.props.whatsappChannelTemplateViewChange(index, row);
            this.handleChangeVariations(index, 'whatsAppTemplate', row.id);
            this.handleChangeVariations(index, 'whatsAppVariables', {});
            this.handleChangeVariations(index, 'dynamicUrlSuffix', '');
          }}
        />
      </Modal>
    );
  };

  renderEmailTemplateEditor = (index) => {
    return (
      <EmailTemplareModal
        onDone={(data) => {
          this.props.emailTemplateListAllFetch();
          const { design, html } = data;
          const { variations } = this.state;
          variations[index]['message'] = html;
          variations[index]['json'] = JSON.stringify(design);
          this.setState({
            selectedEmailTemplate: null,
            emailBodyType: 'raw',
            selectedTemplateHtml: html,
            selectedTemplateJson: JSON.stringify(design),
            variations,
          });
        }}
        onCancel={() => {
          this.setState({
            emailBodyType: 'raw',
          });
        }}
      />
    );
  };

  renderEmailPreviewModal = () => {
    if (this.state.emailPreviewVisible) {
      return (
        <Modal
          title={'Email Preview'}
          width={900}
          bodyStyle={{ height: 450, padding: 0 }}
          styles={{
            body: {
              height: 450,
              padding: 0,
            },
          }}
          centered
          open={this.state.emailPreviewVisible}
          footer={null}
          onCancel={() => this.cancelEmailPreview()}
          data-cy="preview-modal"
        >
          <iframe
            sandbox="allow-same-origin allow-scripts allow-popups"
            id="emailPreview"
            width="100%"
            height="100%"
            srcDoc={this.state.emailHtml}
            style={{ margin: 0 }}
            frameBorder={0}
          />
        </Modal>
      );
    }
  };

  humanizedAttachmentFilesize = (item, isLast) => {
    if (isLast && typeof item?.size === 'undefined') {
      item.size = this.state.currentUploadedAttachmentSize;
    }

    return `(~${(item.size ?? 0).toFixed(1)}KB)`;
  };

  getAttachmentFilesize = async (url) => {
    let filesize = 0;

    try {
      const response = await fetch(url);
      const contentLength = response.headers.get('Content-Length');

      if (contentLength) {
        filesize = parseInt(contentLength) / 1024; // in kilobytes
      }
    } catch (error) {
      console.error('failed to get file size');
    }

    return filesize;
  };

  inputGenerator = (type, index) => {
    const inputLoadingSpin = <LoadingOutlined style={{ fontSize: 18 }} spin />;
    const unSubLinkText = '<a href="{{unsubscribe}}" >Unsubscribe Here</a>';
    const productId = this.props.match?.params?.productId;
    const currentProduct = this.props?.userProducts?.find(
      (p) => p.id === +productId
    );

    const isAttachmentsExists =
      this.state.variations[index] &&
      this.state.variations[index].attachments &&
      Array.isArray(this.state.variations[index].attachments) &&
      this.state.variations[index].attachments?.length > 0;

    const attachmentsList = isAttachmentsExists
      ? this.state.variations[index].attachments
      : [];

    switch (type) {
      case 'subject':
        return (
          <div style={styles.editContainer}>
            <div style={styles.editLabel}>SUBJECT</div>
            <div
              style={{ ...styles.editFieldContainer, flex: 3, marginLeft: 20 }}
            >
              <Form.Item
                validateStatus={
                  this.channel !== 'CUSTOM'
                    ? errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].subject'
                      )
                      ? 'error'
                      : null
                    : undefined
                }
                help={
                  this.channel !== 'CUSTOM'
                    ? errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].subject'
                      )
                    : undefined
                }
                id={
                  errorHandling(
                    this.props.errorUpdateMessageSubmit,
                    'variations[' + [index] + '].subject'
                  )
                    ? 'error'
                    : null
                }
                // name={`variations[${index}].subject`}
                // initialValue={
                //   this.state.variations[index] &&
                //   this.state.variations[index].subject
                //     ? this.state.variations[index].subject
                //     : ''
                // }
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  },
                ]}
              >
                <InputSelector
                  type="richInline"
                  index={index}
                  id={'variations[' + [index] + '].subject'}
                  dataCy="subject"
                  journeySteps={this.props.journeyStepsForVariable}
                  disabled={this.props.readOnly || this.isEditDisable()}
                  value={
                    this.state.variations[index] &&
                    this.state.variations[index].subject
                      ? this.state.variations[index].subject
                      : ''
                  }
                  onChange={(value) =>
                    this.handleChangeVariations(index, 'subject', value)
                  }
                  attributes={this.props.attributes}
                  events={this.props.events}
                  currentType={this.props.currentMessage?.type}
                  currentEvent={this.props.currentMessage?.event}
                  businessEvents={this.props.businessEvents}
                  size="middle"
                  style={{ ...styles.editField, width: '90%' }}
                  emojiStyle={{ position: 'relative', top: 1, left: 312 }}
                />
              </Form.Item>
            </div>
          </div>
        );
      case 'preheader':
        return (
          <div style={styles.editContainer}>
            <div style={styles.editLabel}>
              PRE HEADER
              <Tooltip
                placement="bottom"
                title={`Email preheader text is what many mobile, desktop, and web email clients show readers to give them an idea of what's inside the message before they actually open it.
                  If you input preheader text, we will convert your body to HTML (if it is not already in HTML)
                  `}
              >
                <span style={{ display: 'inline-block', marginLeft: '1em' }}>
                  <InfoCircleOutlined />
                </span>
              </Tooltip>
            </div>
            <div
              style={{ ...styles.editFieldContainer, flex: 3, marginLeft: 20 }}
            >
              <Form.Item
                validateStatus={
                  this.state.variations[index].preheader &&
                  this.state.variations[index]?.message.indexOf('<html') === -1
                    ? 'warning'
                    : null
                }
                help={
                  this.state.variations[index].preheader &&
                  this.state.variations[index]?.message.indexOf('<html') === -1
                    ? 'If you input preheader text, we will convert your message body to HTML'
                    : ''
                }
              >
                <InputSelector
                  id={'variations[' + [index] + '].preheader'}
                  dataCy="preheader"
                  journeySteps={this.props.journeyStepsForVariable}
                  disabled={this.props.readOnly || this.isEditDisable()}
                  value={
                    this.state.variations[index] &&
                    this.state.variations[index].preheader
                      ? this.state.variations[index].preheader
                      : ''
                  }
                  onChange={(value) =>
                    this.handleChangeVariations(index, 'preheader', value)
                  }
                  attributes={this.props.attributes}
                  events={this.props.events}
                  currentType={this.props.currentMessage?.type}
                  currentEvent={this.props.currentMessage?.event}
                  businessEvents={this.props.businessEvents}
                  size="middle"
                  style={{ ...styles.editField, width: '90%' }}
                  emojiStyle={{ position: 'relative', top: 1, left: 312 }}
                />
              </Form.Item>
            </div>
          </div>
        );
      case 'body':
        return (
          <div>
            <div style={{ ...styles.editContainer, marginTop: 20 }}>
              <div style={styles.editLabel}>BODY</div>
              <div
                style={{
                  ...styles.editFieldContainer,
                  marginLeft: 30,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginRight: 59,
                }}
              >
                <Radio.Group
                  disabled={this.props.readOnly || this.isEditDisable()}
                  onChange={(e) => {
                    if (e.target.value === 'drag') {
                      this.selectDragAndDropEditor(index);
                    } else {
                      this.setState({ emailBodyType: e.target.value });
                    }
                  }}
                  value={this.state.emailBodyType}
                >
                  <Radio data-cy="raw-html" value={'raw'}>
                    Raw HTML
                  </Radio>
                  <Radio data-cy="drag-drop-editor" value={'drag'}>
                    Drag & Drop Editor
                  </Radio>
                </Radio.Group>
                <Button
                  type="primary"
                  shape="round"
                  size={'large'}
                  style={styles.previewButton}
                  ghost
                  onClick={() => this.openEmailPreview(index)}
                  data-cy="see-raw-preview"
                >
                  SEE RAW PREVIEW
                </Button>
              </div>
            </div>
            {this.state.emailBodyType === 'raw' && (
              <div style={{ ...styles.editContainer, marginTop: 0 }}>
                <div style={{ ...styles.editLabel }}></div>
                <div
                  style={{
                    ...styles.editFieldContainer,
                    marginLeft: 20,
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ flex: 0.7 }}>
                    <Form.Item
                      validateStatus={
                        errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].message'
                        )
                          ? 'error'
                          : null
                      }
                      help={errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].message'
                      )}
                      style={{ ...styles.editField, width: 800 }}
                    >
                      <InputSelector
                        ref={(emailEditor) => (this.emailEditor = emailEditor)}
                        id="email-editor"
                        // id={
                        //   errorHandling(
                        //     this.props.errorUpdateMessageSubmit,
                        //     'variations[' + [index] + '].message'
                        //   )
                        //     ? 'error'
                        //     : null
                        // }
                        dataCy="email-body-text"
                        journeySteps={this.props.journeyStepsForVariable}
                        disabled={this.props.readOnly || this.isEditDisable()}
                        attributes={this.props.attributes}
                        events={this.props.events}
                        currentType={this.props.currentMessage?.type}
                        currentEvent={this.props.currentMessage?.event}
                        businessEvents={this.props.businessEvents}
                        value={
                          this.state.variations[index] &&
                          this.state.variations[index]?.message
                            ? this.state.variations[index]?.message
                            : ''
                        }
                        hideEmojiPicker={false}
                        placeholder={''}
                        className={'not-resizable'}
                        textArea={true}
                        onChange={(value) =>
                          this.handleChangeVariations(index, 'message', value)
                        }
                        style={{ ...styles.editField, width: 800, height: 250 }}
                        autoSize={{ maxRows: 25, minRows: 25 }}
                        rows={25}
                        size="large"
                      />
                    </Form.Item>
                    {!this.isEditDisable() && (
                      <Button
                        type="primary"
                        shape="round"
                        size={'large'}
                        style={{ ...styles.previewButton }}
                        ghost
                        onClick={() =>
                          this.emailEditor.appendMessage(unSubLinkText, true)
                        }
                        data-cy="insert-unsubscribe-link"
                      >
                        INSERT UNSUBSCRIBE LINK
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            )}
            {this.state.emailBodyType === 'drag' && (
              <div style={{ ...styles.editContainer, marginTop: 20 }}>
                <div style={{ ...styles.editLabel }}>Select Template</div>
                <div
                  style={{
                    ...styles.editFieldContainer,
                    marginLeft: 20,
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  {this.props.loadingListAllTemplate ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Spin indicator={inputLoadingSpin} />
                    </div>
                  ) : (
                    <React.Fragment>
                      <Form.Item
                        validateStatus={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].message'
                          )
                            ? 'error'
                            : null
                        }
                        help={errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].message'
                        )}
                        id={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].message'
                          )
                            ? 'error'
                            : null
                        }
                      >
                        <Select
                          id={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].message'
                            )
                              ? 'error'
                              : null
                          }
                          data-cy="select-template"
                          disabled={this.props.readOnly || this.isEditDisable()}
                          showSearch
                          dropdownMenuStyle={{ maxHeight: 150 }}
                          style={styles.editField}
                          size="large"
                          value={
                            this.state.selectedEmailTemplate &&
                            this.state.selectedEmailTemplate?.id
                              ? this.state.selectedEmailTemplate.id
                              : null
                          }
                          onChange={(id) => this.selectTemplate(id)}
                          filterOption={(input, option) => {
                            return (
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                        >
                          <Select.Option value={null}>-</Select.Option>
                          {this.props.listAllTemplate.map((ua) => (
                            <Select.Option value={ua.id} key={ua.id}>
                              {ua.name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </React.Fragment>
                  )}
                  <Button
                    style={{ height: 40, margin: '0 0 23px 23px' }}
                    onClick={() => {
                      this.props.emailTemplateChangeCurrent({});
                      this.props.emailTemplateToggleModal(true, null, false);
                    }}
                  >
                    NEW TEMPLATE
                  </Button>
                </div>
              </div>
            )}
          </div>
        );
      case 'attachments':
        return (
          <Card styles={{ marginTop: '10px' }}>
            <div style={styles.infoBoxHeader}>
              <div style={styles.headTitleContainer}>
                <span>Attachments</span>
              </div>
            </div>
            <div
              style={{
                padding: 30,
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                backgroundColor: 'white',
              }}
            >
              {isAttachmentsExists &&
                attachmentsList.map((attachmentItem, attachmentIndex) => (
                  <div
                    key={attachmentIndex}
                    style={{
                      fontSize: 12,
                      flex: 1,
                      padding: 16,
                      background: '#f2f2f233',
                      border: '1px solid #cccccc33',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderRadius: 4,
                      gap: 16,
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: 'flex',
                        gap: 8,
                        overflow: 'hidden',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'monospace',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {attachmentItem.file || '-'}
                      </span>
                      <span style={{ opacity: 0.7 }}>
                        {this.humanizedAttachmentFilesize(
                          attachmentItem,
                          attachmentIndex === attachmentsList.length - 1
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: 12,
                      }}
                    >
                      {attachmentItem.file ? (
                        <CopyFilled
                          onClick={async () => {
                            if ('clipboard' in navigator) {
                              await navigator.clipboard.writeText(
                                attachmentItem.file
                              );

                              message.info('file copied successfully');
                            }
                          }}
                          style={{
                            maxWidth: 46,
                            display: 'flex',
                            flex: 1,
                            fontSize: 14,
                            cursor: 'pointer',
                          }}
                        />
                      ) : null}
                      {attachmentItem.file ? (
                        <DeleteFilled
                          onClick={() =>
                            this.confirmDeleteAttachment(index, attachmentIndex)
                          }
                          style={{
                            maxWidth: 46,
                            display: 'flex',
                            flex: 1,
                            color: '#ff4d4f',
                            fontSize: 14,
                            cursor: 'pointer',
                          }}
                        />
                      ) : null}
                    </div>
                  </div>
                ))}
              {this.isAttachmentsSizeExceeded() &&
                !this.props.loadingUploadFile && (
                  <Alert
                    message={`The total size of the attached files (~${this.state.attachmentsThreshold.toFixed(
                      1
                    )}KB) exceeds the limit of 512 KB.`}
                    type="error"
                    showIcon
                  />
                )}
              <div style={{ ...styles.editContainer }}>
                <div
                  style={{
                    ...styles.editFieldContainer,
                    marginTop: isAttachmentsExists ? 20 : 0,
                    alignItems: 'flex-start',
                  }}
                >
                  {this.renderUploader(index)}
                </div>
              </div>
            </div>
          </Card>
        );
      case 'image':
        return (
          <div style={styles.editContainer}>
            <div style={styles.editLabel}>IMAGE</div>
            <div
              style={{
                marginLeft: 20,
                flex: 3,
                fontSize: 13,
                lineHeight: 1.43,
                color: '#3d404e',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <Form.Item
                  style={{ margin: 0, width: '100%' }}
                  validateStatus={
                    errorHandling(
                      this.props.errorUpdateMessageSubmit,
                      'variations[' + [index] + '].image'
                    )
                      ? 'error'
                      : this.state.imageUrlFormatError
                      ? 'error'
                      : null
                  }
                  help={
                    !isNil(
                      errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].image'
                      )
                    )
                      ? errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].image'
                        )
                      : this.state.imageUrlFormatError
                      ? 'Incorrect image url'
                      : null
                  }
                  id={
                    errorHandling(
                      this.props.errorUpdateMessageSubmit,
                      'variations[' + [index] + '].image'
                    )
                      ? 'error'
                      : this.state.imageUrlFormatError
                      ? 'error'
                      : null
                  }
                >
                  <InputSelector
                    index={index}
                    dataCy="image-url"
                    id={'variations[' + [index] + '].image'}
                    disabled={this.isEditDisable()}
                    attributes={this.props.attributes}
                    events={this.props.events}
                    currentType={this.props.currentMessage?.type}
                    currentEvent={this.props.currentMessage?.event}
                    journeySteps={this.props.journeyStepsForVariable}
                    businessEvents={this.props.businessEvents}
                    hideEmojiPicker
                    hideAttributePicker
                    placeholder="https://www.abc.com/image.png"
                    value={
                      this.state.variations[index] &&
                      this.state.variations[index].image
                        ? this.state.variations[index].image
                        : ''
                    }
                    onChange={(value) =>
                      this.handleChangeVariations(index, 'image', value)
                    }
                    size="large"
                    style={{ ...styles.editField, width: '100%' }}
                  />
                </Form.Item>
                {!isNil(this.state.variations[index].image) &&
                this.state.variations[index].image.length > 0 ? (
                  <Button
                    disabled={this.isEditDisable()}
                    type="primary"
                    shape="round"
                    ghost
                    onClick={() =>
                      this.handleChangeVariations(index, 'image', null)
                    }
                    size={'small'}
                    style={{
                      marginLeft: 15,
                    }}
                  >
                    Reset
                  </Button>
                ) : (
                  <React.Fragment>
                    <span style={{ marginInline: 8 }}>or</span>
                    {this.renderPushUploader('image', index)}
                  </React.Fragment>
                )}
              </div>
              <div
                style={{
                  color: '#94969e',
                  fontSize: '10px',
                  paddingLeft: '5px',
                  paddingTop: '5px',
                  display: 'block',
                }}
              >
                {
                  'Recommended size: 1080px x 540px. Aspect ratio (width:height): 2:1. Actual rendering depends on screen size. JPG, JPEG, PNG formats only. GIF format also available but for iOS 10+ only. Less than 1 MB in size. URL must begin with HTTPS.'
                }
              </div>
            </div>
          </div>
        );
      case 'icon':
        return (
          <div style={styles.editContainer}>
            <div style={styles.editLabel}>ICON</div>
            <div
              style={{
                marginLeft: 20,
                flex: 3,
                fontSize: 13,
                lineHeight: 1.43,
                color: '#3d404e',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Form.Item
                  style={{ width: '100%' }}
                  validateStatus={
                    this.checkValidImageUrl(this.state.variations[index].icon)
                      ? null
                      : 'warning'
                  }
                  // help={
                  //   this.checkValidImageUrl(this.state.variations[index].icon)
                  //     ? null
                  //     : 'Invalid Image URL'
                  // }
                  disabled={this.state.variations[index].checkedDefaultLogo}
                >
                  <InputSelector
                    index={index}
                    disabled={
                      this.isEditDisable() ||
                      this.state.variations[index]?.checkedDefaultLogo
                    }
                    id={'variations[' + [index] + '].icon'}
                    attributes={this.props.attributes}
                    events={this.props.events}
                    currentType={this.props.currentMessage?.type}
                    currentEvent={this.props.currentMessage?.event}
                    journeySteps={this.props.journeyStepsForVariable}
                    businessEvents={this.props.businessEvents}
                    hideEmojiPicker
                    hideAttributePicker
                    placeholder="https://www.abc.com/image.png"
                    value={
                      this.state.variations[index] &&
                      this.state.variations[index].icon
                        ? this.state.variations[index].icon
                        : ''
                    }
                    onChange={(value) => {
                      this.handleChangeVariations(index, 'icon', value);
                    }}
                    size="large"
                    style={{ ...styles.editField, width: '100%' }}
                    onChangeButton={
                      this.state.variations[index].checkedDefaultLogo
                    }
                  />
                </Form.Item>
                {this.state.variations[index] &&
                !isNil(this.state.variations[index].icon) &&
                this.state.variations[index].icon.length > 0 ? (
                  <Button
                    disabled={
                      this.isEditDisable() ||
                      this.state.variations[index]?.checkedDefaultLogo
                    }
                    type="primary"
                    shape="round"
                    ghost
                    onClick={() =>
                      this.handleChangeVariations(index, 'icon', null)
                    }
                    size={'small'}
                    style={{
                      position: 'realtive',
                      top: 13,

                      marginLeft: 15,
                    }}
                  >
                    Reset
                  </Button>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginInline: 8 }}>or</span>
                    {this.renderWebPushIconUploader('icon', index)}
                  </div>
                )}
              </div>

              <div
                style={{
                  color: '#94969e',
                  fontSize: '10px',
                  paddingLeft: '5px',
                  paddingTop: '5px',
                  display: 'block',
                }}
              >
                {
                  'Recommended size: 192px x 192px. JPG, JPEG, PNG formats only. Less than 1 MB in size. URL must begin with HTTPS'
                }
              </div>
              {currentProduct?.defaultPushIcon &&
                !isEmpty(currentProduct?.defaultPushIcon) && (
                  <Checkbox
                    disabled={this.isEditDisable()}
                    style={{
                      fontSize: 12,
                      textTransform: 'capitalize',
                      fontWeight: 'normal',
                    }}
                    checked={this.state.variations[index].checkedDefaultLogo}
                    onChange={(e) => {
                      if (e.target.checked) {
                        this.handleChangeVariations(
                          index,
                          'icon',
                          currentProduct?.defaultPushIcon
                        );
                      }
                      this.handleChangeVariations(
                        index,
                        'checkedDefaultLogo',
                        e.target.checked
                      );
                    }}
                  >
                    Use Default Logo
                  </Checkbox>
                )}
            </div>
          </div>
        );
      case 'message':
        return (
          <div style={styles.editContainer}>
            <div style={styles.editLabel}>MESSAGE</div>
            <div
              style={{ ...styles.editFieldContainer, marginLeft: 20, flex: 3 }}
            >
              <Form.Item
                data-cy="push-message"
                validateStatus={
                  this.channel !== 'CUSTOM'
                    ? errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].message'
                      )
                      ? 'error'
                      : null
                    : undefined
                }
                help={
                  this.channel !== 'CUSTOM'
                    ? errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].message'
                      )
                      ? 'error'
                      : null
                    : undefined
                }
                id={
                  errorHandling(
                    this.props.errorUpdateMessageSubmit,
                    'variations[' + [index] + '].message'
                  )
                    ? 'error'
                    : null
                }
                // name="message"
                // name={`variations[${index}].message`}
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  },
                ]}
              >
                <InputSelector
                  type="richTextArea"
                  index={index}
                  id={
                    errorHandling(
                      this.props.errorUpdateMessageSubmit,
                      'variations[' + [index] + '].message'
                    )
                      ? 'error'
                      : null
                  }
                  journeySteps={this.props.journeyStepsForVariable}
                  disabled={this.isEditDisable()}
                  textArea
                  className={'not-resizable'}
                  currentType={this.props.currentMessage?.type}
                  currentEvent={this.props.currentMessage?.event}
                  attributes={this.props.attributes}
                  events={this.props.events}
                  businessEvents={this.props.businessEvents}
                  style={{
                    paddingRight: 58,
                    color: 'rgb(61, 64, 78)',
                    fontFamily: 'monospace',
                    fontSize: 13,
                    fontWeight: 400,
                    width: '100%',
                  }}
                  autoSize={{ maxRows: 3, minRows: 3 }}
                  rows={3}
                  value={
                    this.state.variations[index] &&
                    this.state.variations[index]?.message
                      ? this.state.variations[index]?.message
                      : ''
                  }
                  onChange={(value) =>
                    this.handleChangeVariations(index, 'message', value)
                  }
                  size="large"
                />
              </Form.Item>
              <span
                style={{
                  color: '#94969e',
                  fontSize: '10px',
                  paddingLeft: '5px',
                  paddingTop: '5px',
                  display: 'block',
                }}
              >
                {'Recommended maximum length: ' +
                  (this.state.variations[index] &&
                  this.state.variations[index].pushType === 'BANNER'
                    ? 36
                    : 180) +
                  ' characters. Current count:' +
                  (this.state.variations[index] &&
                  this.state.variations[index]?.message
                    ? this.state.variations[index]?.message?.length
                    : 0)}
              </span>
            </div>
          </div>
        );

      case 'rich-message':
        return (
          <div style={styles.editContainer}>
            <div style={styles.editLabel}>MESSAGE</div>
            <div
              style={{
                ...styles.editFieldContainer,
                marginLeft: 20,
                flex: 3,
                maxWidth: '78%',
              }}
            >
              <Form.Item
                data-cy="push-message"
                validateStatus={
                  this.channel !== 'CUSTOM'
                    ? errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].message'
                      )
                      ? 'error'
                      : null
                    : undefined
                }
                help={
                  this.channel !== 'CUSTOM'
                    ? errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].message'
                      )
                      ? 'error'
                      : null
                    : undefined
                }
                id={
                  errorHandling(
                    this.props.errorUpdateMessageSubmit,
                    'variations[' + [index] + '].message'
                  )
                    ? 'error'
                    : null
                }
                // name="message"
                // name={`variations[${index}].message`}
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  },
                ]}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 10,
                    width: 'fit-content',
                    gap: 10,
                  }}
                >
                  <Button
                    onClick={() => {
                      const messageEditorType = {
                        ...this.state.messageEditorType,
                        [index]: 'plain',
                      };
                      this.persistMessageEditorType(messageEditorType);
                      this.setState({ messageEditorType });
                    }}
                    type={
                      this.state.messageEditorType[index] !== 'rich'
                        ? 'primary'
                        : 'default'
                    }
                    size="middle"
                    style={{ padding: 8 }}
                  >
                    Plain Text
                  </Button>

                  <Button
                    onClick={() => {
                      const messageEditorType = {
                        ...this.state.messageEditorType,
                        [index]: 'rich',
                      };
                      this.persistMessageEditorType(messageEditorType);
                      this.setState({ messageEditorType });
                    }}
                    style={{ padding: 8 }}
                    type={
                      this.state.messageEditorType[index] === 'rich'
                        ? 'primary'
                        : 'default'
                    }
                    size="middle"
                  >
                    {' '}
                    Rich Text Editor
                  </Button>
                </div>
                {this.state.messageEditorType[index] === 'rich' ? (
                  <InputSelector
                    isRich={true}
                    type="rich"
                    index={index}
                    id={
                      errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].message'
                      )
                        ? 'error'
                        : null
                    }
                    journeySteps={this.props.journeyStepsForVariable}
                    disabled={this.isEditDisable()}
                    textArea
                    className={'not-resizable'}
                    attributes={this.props.attributes}
                    events={this.props.events}
                    currentType={this.props.currentMessage?.type}
                    currentEvent={this.props.currentMessage?.event}
                    businessEvents={this.props.businessEvents}
                    style={{
                      paddingRight: 58,
                      color: 'rgb(61, 64, 78)',
                      fontFamily: 'monospace',
                      fontSize: 13,
                      fontWeight: 400,
                      width: '100%',
                    }}
                    autoSize={{ maxRows: 3, minRows: 3 }}
                    rows={3}
                    value={
                      this.state.variations[index] &&
                      this.state.variations[index].message
                        ? this.state.variations[index].message
                        : ''
                    }
                    onChange={(value) =>
                      this.handleChangeVariations(index, 'message', value)
                    }
                    size="large"
                  />
                ) : (
                  <Input.TextArea
                    id={
                      errorHandling(
                        this.props.errorUpdateMessageSubmit,
                        'variations[' + [index] + '].message'
                      )
                        ? 'error'
                        : null
                    }
                    disabled={this.isEditDisable()}
                    className={'not-resizable'}
                    style={{
                      paddingRight: 58,
                      color: 'rgb(61, 64, 78)',
                      fontFamily: 'monospace',
                      fontSize: 13,
                      fontWeight: 400,
                      width: '100%',
                    }}
                    autoSize={{ maxRows: 3, minRows: 3 }}
                    rows={3}
                    value={
                      this.state.variations[index] &&
                      this.state.variations[index].message
                        ? this.state.variations[index].message
                        : ''
                    }
                    onChange={(e) =>
                      this.handleChangeVariations(
                        index,
                        'message',
                        e.target.value
                      )
                    }
                    size="large"
                  />
                )}
              </Form.Item>
              <span
                style={{
                  color: '#94969e',
                  fontSize: '10px',
                  paddingLeft: '5px',
                  paddingTop: '5px',
                  display: 'block',
                }}
              >
                {'Recommended maximum length: ' +
                  (this.state.variations[index] &&
                  this.state.variations[index].pushType === 'BANNER'
                    ? 36
                    : 180) +
                  ' characters. Current count:' +
                  (this.state.variations[index] &&
                  this.state.variations[index].message
                    ? this.state.variations[index].message
                        .replace(/<[^>]*>?/gm, '')
                        .replaceAll('&nbsp;', ' ').length
                    : 0)}
              </span>
            </div>
          </div>
        );
      default:
        return '';
    }
  };

  renderEmailSection = (index) => {
    if (this.channel === 'EMAIL') {
      return (
        <React.Fragment>
          <Form layout="vertical">
            <div style={styles.formItem}>
              {this.props.currentMessage?.type === 'TRANSACTIONAL' && (
                <div
                  style={{
                    paddingLeft: 0,
                    paddingRight: 0,
                    border: '1px solid #F1F1F3',
                    backgroundColor: 'white',
                    marginBottom: 40,
                  }}
                >
                  <div
                    style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}
                  >
                    <div style={styles.headTitleContainer}>
                      Personalizing Content in Transactional Campaigns
                    </div>
                  </div>
                  <div style={{ ...styles.dataRowContainer, paddingBottom: 0 }}>
                    You can use any variable to personalize any of the fields in
                    the message below. Eg. To include order_id in the order
                    confirmation message, please specify the order_id variable
                    in the message as <span>{'{{token.order_id }}'}</span> .
                    Please also ensure that your variables are prefixed with the
                    keyword token. Once you launch this campaign, send the token
                    as token: <span>{'{ "order_id" : "abc123" }'}</span> in the{' '}
                    <a href={texts.brandName} target={'blank'}>
                      transactional campaign API call{' '}
                    </a>{' '}
                    for each order confirmation, so that the message gets
                    personalized.
                  </div>
                  <div style={styles.dataRowContainer}>
                    Please refer to our{' '}
                    <a href={texts.campaignApi} target={'blank'}>
                      documentation
                    </a>{' '}
                    for more details on transactional campaigns.
                  </div>
                </div>
              )}
              <Card>
                <div style={styles.infoBoxHeader}>
                  <div style={styles.headTitleContainer}>
                    <span>Service Provider</span>
                  </div>
                </div>
                <div style={{ padding: 30, backgroundColor: 'white' }}>
                  <div style={{ ...styles.editContainer }}>
                    <div style={{ ...styles.editLabel }}>{'ESP'}</div>
                    <div
                      style={{ ...styles.editFieldContainer, marginLeft: 20 }}
                    >
                      <Form.Item
                        validateStatus={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].emailChannel'
                          )
                            ? 'error'
                            : null
                        }
                        help={errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].emailChannel'
                        )}
                        id={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].emailChannel'
                          )
                            ? 'error'
                            : null
                        }
                      >
                        <Select
                          id={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].emailChannel'
                            )
                              ? 'error'
                              : null
                          }
                          data-cy="email-channel"
                          style={styles.editField}
                          loading={this.props.loadingEmailChannels}
                          disabled={this.props.readOnly || this.isEditDisable()}
                          value={this.channelValue(index, 'emailChannel')}
                          dropdownMenuStyle={{ maxHeight: 150 }}
                          size="large"
                          onChange={(value) =>
                            this.handleChangeVariations(
                              index,
                              'emailChannel',
                              value
                            )
                          }
                        >
                          {this.props.loadingEmailChannels
                            ? null
                            : this.renderServiceProviderOptions(
                                this.props.emailChannels
                              )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div style={styles.formItem}>
              <Card>
                <div style={styles.infoBoxHeader}>
                  <div style={styles.headTitleContainer}>
                    <span>From</span>
                  </div>
                </div>
                <div style={{ padding: 30, backgroundColor: 'white' }}>
                  <div style={{ ...styles.editContainer }}>
                    <div style={{ ...styles.editLabel }}>FROM NAME</div>
                    <div
                      style={{ ...styles.editFieldContainer, marginLeft: 20 }}
                    >
                      <Form.Item
                        validateStatus={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].fromName'
                          )
                            ? 'error'
                            : null
                        }
                        help={errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].fromName'
                        )}
                        id={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].fromName'
                          )
                            ? 'error'
                            : null
                        }
                      >
                        <InputSelector
                          id={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].fromName'
                            )
                              ? 'error'
                              : null
                          }
                          type="richInline"
                          index={index}
                          dataCy="from-name"
                          journeySteps={this.props.journeyStepsForVariable}
                          disabled={this.props.readOnly || this.isEditDisable()}
                          attributes={this.props.attributes}
                          events={this.props.events}
                          currentType={this.props.currentMessage?.type}
                          currentEvent={this.props.currentMessage?.event}
                          businessEvents={this.props.businessEvents}
                          style={styles.editField}
                          hideEmojiPicker
                          placeholder={'Alex Smith'}
                          value={
                            this.state.variations[index] &&
                            this.state.variations[index].fromName
                              ? this.state.variations[index].fromName
                              : ''
                          }
                          onChange={(value) =>
                            this.handleChangeVariations(
                              index,
                              'fromName',
                              value
                            )
                          }
                          size="middle"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div style={{ ...styles.editContainer, marginTop: 20 }}>
                    <div style={{ ...styles.editLabel }}>FROM EMAIL</div>
                    <div
                      style={{ ...styles.editFieldContainer, marginLeft: 20 }}
                    >
                      <Form.Item
                        validateStatus={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].fromEmail'
                          )
                            ? 'error'
                            : this.checkValidEmail(
                                this.state.variations[index].fromEmail
                              )
                        }
                        help={
                          !isNil(
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].fromEmail'
                            )
                          )
                            ? errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].fromEmail'
                              )
                            : isNil(
                                this.checkValidEmail(
                                  this.state.variations[index].fromEmail
                                )
                              )
                            ? null
                            : 'Invalid Email Address'
                        }
                        id={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].fromEmail'
                          )
                            ? 'error'
                            : this.checkValidEmail(
                                this.state.variations[index].fromEmail
                              )
                        }
                      >
                        <InputSelector
                          id={'variations[' + [index] + '].fromEmail'}
                          type="richInline"
                          index={index}
                          dataCy="from-email"
                          journeySteps={this.props.journeyStepsForVariable}
                          disabled={this.props.readOnly || this.isEditDisable()}
                          attributes={this.props.attributes}
                          events={this.props.events}
                          currentType={this.props.currentMessage?.type}
                          currentEvent={this.props.currentMessage?.event}
                          businessEvents={this.props.businessEvents}
                          style={styles.editField}
                          hideEmojiPicker
                          placeholder={'alex.smith@company.com'}
                          value={
                            this.state.variations[index] &&
                            this.state.variations[index].fromEmail
                              ? this.state.variations[index].fromEmail
                              : ''
                          }
                          onChange={(value) =>
                            this.handleChangeVariations(
                              index,
                              'fromEmail',
                              value
                            )
                          }
                          size="middle"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div style={{ ...styles.editContainer, marginTop: 20 }}>
                    <div style={styles.editLabel}>REPLY TO</div>
                    <div
                      style={{
                        display: 'flex',
                        flex: 6,
                        alignItems: 'center',
                        fontSize: 13,
                        lineHeight: 1.43,
                        marginLeft: 20,
                      }}
                    >
                      <Switch
                        checked={
                          this.state.variations[index] &&
                          this.state.variations[index].showReplyTo
                        }
                        disabled={this.props.readOnly || this.isEditDisable()}
                        onChange={(value) =>
                          this.handleChangeVariations(
                            index,
                            'showReplyTo',
                            value
                          )
                        }
                        data-cy="button-email-reply-to"
                      />
                    </div>
                  </div>
                  {this.state.variations[index] &&
                    this.state.variations[index].showReplyTo && (
                      <div style={{ ...styles.editContainer }}>
                        <div style={styles.editLabel}></div>
                        <div
                          style={{
                            flex: 6,
                            alignItems: 'center',
                            fontSize: 13,
                            lineHeight: 1.43,
                            marginLeft: 20,
                          }}
                        >
                          <Form.Item
                            validateStatus={
                              this.state.emailErrors.replyToEmailError
                                ? 'error'
                                : null
                            }
                            help={
                              this.state.emailErrors.replyToEmailError
                                ? 'Invalid Email Address'
                                : null
                            }
                            id={
                              this.state.emailErrors.replyToEmailError
                                ? 'error'
                                : null
                            }
                          >
                            <InputSelector
                              id="email-reply-to"
                              type="richInline"
                              index={index}
                              dataCy="email-reply-to"
                              journeySteps={this.props.journeyStepsForVariable}
                              disabled={
                                this.props.readOnly || this.isEditDisable()
                              }
                              style={styles.editField}
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              businessEvents={this.props.businessEvents}
                              hideEmojiPicker
                              placeholder={'alex.smith@company.com'}
                              value={
                                this.state.variations[index] &&
                                this.state.variations[index].replyTo
                                  ? this.state.variations[index].replyTo
                                  : ''
                              }
                              onChange={(value) =>
                                this.handleChangeVariations(
                                  index,
                                  'replyTo',
                                  value
                                )
                              }
                              size="middle"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    )}
                  <div style={{ ...styles.editContainer, marginTop: 20 }}>
                    <div style={styles.editLabel}>CC</div>
                    <div
                      style={{
                        flex: 6,
                        alignItems: 'center',
                        fontSize: 13,
                        lineHeight: 1.43,
                        marginLeft: 20,
                      }}
                    >
                      <Switch
                        checked={
                          this.state.variations[index] &&
                          this.state.variations[index].showCc
                        }
                        disabled={this.props.readOnly || this.isEditDisable()}
                        onChange={(value) =>
                          this.handleChangeVariations(index, 'showCc', value)
                        }
                        data-cy="button-email-cc-address"
                      />
                    </div>
                  </div>
                  {this.state.variations[index] &&
                    this.state.variations[index].showCc && (
                      <div style={{ ...styles.editContainer }}>
                        <div style={styles.editLabel}></div>
                        <div
                          style={{
                            flex: 6,
                            alignItems: 'center',
                            fontSize: 13,
                            lineHeight: 1.43,
                            marginLeft: 20,
                          }}
                        >
                          <Form.Item
                            validateStatus={
                              this.state.emailErrors.ccEmailError
                                ? 'error'
                                : null
                            }
                            help={
                              this.state.emailErrors.ccEmailError
                                ? 'Invalid Email(s) Addresses'
                                : null
                            }
                            id={
                              this.state.emailErrors.ccEmailError
                                ? 'error'
                                : null
                            }
                          >
                            <InputSelector
                              type="richInline"
                              index={index}
                              journeySteps={this.props.journeyStepsForVariable}
                              disabled={
                                this.props.readOnly || this.isEditDisable()
                              }
                              style={styles.editField}
                              id="email-cc-address"
                              dataCy="email-cc-address"
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              businessEvents={this.props.businessEvents}
                              hideEmojiPicker
                              placeholder={'dave.smith@company.com'}
                              value={
                                this.state.variations[index] &&
                                this.state.variations[index].cc
                                  ? this.state.variations[index].cc
                                  : ''
                              }
                              onChange={(value) =>
                                this.handleChangeVariations(index, 'cc', value)
                              }
                              size="middle"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    )}
                  <div style={{ ...styles.editContainer, marginTop: 20 }}>
                    <div style={styles.editLabel}>BCC</div>
                    <div
                      style={{
                        flex: 6,
                        alignItems: 'center',
                        fontSize: 13,
                        lineHeight: 1.43,
                        marginLeft: 20,
                      }}
                    >
                      <Switch
                        checked={
                          this.state.variations[index] &&
                          this.state.variations[index].showBcc
                        }
                        disabled={this.props.readOnly || this.isEditDisable()}
                        onChange={(value) =>
                          this.handleChangeVariations(index, 'showBcc', value)
                        }
                        data-cy="button-email-bcc-address"
                      />
                    </div>
                  </div>
                  {this.state.variations[index] &&
                    this.state.variations[index].showBcc && (
                      <div style={{ ...styles.editContainer }}>
                        <div style={styles.editLabel}></div>
                        <div
                          style={{
                            flex: 6,
                            alignItems: 'center',
                            fontSize: 13,
                            lineHeight: 1.43,
                            marginLeft: 20,
                          }}
                        >
                          <Form.Item
                            validateStatus={
                              this.state.emailErrors.bccEmailError
                                ? 'error'
                                : null
                            }
                            help={
                              this.state.emailErrors.bccEmailError
                                ? 'Invalid Email(s) Addresses'
                                : null
                            }
                            id={
                              this.state.emailErrors.bccEmailError
                                ? 'error'
                                : null
                            }
                          >
                            <InputSelector
                              id="email-bcc-address"
                              type="richInline"
                              index={index}
                              dataCy="email-bcc-address"
                              journeySteps={this.props.journeyStepsForVariable}
                              disabled={
                                this.props.readOnly || this.isEditDisable()
                              }
                              style={styles.editField}
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              businessEvents={this.props.businessEvents}
                              hideEmojiPicker
                              placeholder={'peter.smith@company.com'}
                              value={
                                this.state.variations[index] &&
                                this.state.variations[index].bcc
                                  ? this.state.variations[index].bcc
                                  : ''
                              }
                              onChange={(value) =>
                                this.handleChangeVariations(index, 'bcc', value)
                              }
                              size="middle"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    )}
                </div>
              </Card>
            </div>
            <div style={styles.formItem}>
              <Card>
                <div style={styles.infoBoxHeader}>
                  <div style={styles.headTitleContainer}>
                    <span>Message</span>
                    <div style={{ cursor: 'pointer' }}></div>
                  </div>
                </div>
                <React.Fragment>
                  <div
                    style={{
                      padding: 30,
                      backgroundColor: 'white',
                      width: '100%',
                    }}
                  >
                    {this.inputGenerator('subject', index)}
                    {this.inputGenerator('preheader', index)}
                    {this.inputGenerator('body', index)}
                  </div>
                </React.Fragment>
              </Card>
            </div>
            <div style={styles.formItem}>
              {this.inputGenerator('attachments', index)}
            </div>
            {this.renderEmailPreviewModal()}
            {this.renderTemplateDetectedModal()}
            {this.renderTemplateModalVisible()}
            {this.renderEmailTemplateEditor(index)}
          </Form>
        </React.Fragment>
      );
    }
    return null;
  };

  renderServiceProviderDefaultValue = () => {
    if (
      this.channel === 'SMS' &&
      this.props.smsChannels &&
      this.props.smsChannels.length > 0 &&
      !isNil(this.props.smsChannels[0]?.id)
    ) {
      return this.props.smsChannels[0].id;
    }
    if (
      this.channel === 'EMAIL' &&
      this.props.emailChannels &&
      this.props.emailChannels.length > 0 &&
      !isNil(this.props.emailChannels[0]?.id)
    ) {
      return this.props.emailChannels[0].id;
    }
    return undefined;
  };

  renderServiceProviderOptions = (serviceProvider) => {
    const result = [];
    serviceProvider.forEach((item) => {
      result.push(<Select.Option value={item.id}>{item.name}</Select.Option>);
    });
    return result;
  };

  channelValue = (variationIndex, name) => {
    let result;
    const { variations } = this.state;
    if (
      variations[variationIndex] &&
      !isNil(variations[variationIndex][name])
    ) {
      result = variations[variationIndex][name];
    }
    return result;
  };

  renderSurveySectionMessage = () => {
    if (
      checkIsSurvey(
        this.channel,
        this.props.currentMessage,
        this.props.pathname
      )
    ) {
      const serverVariations = this.props.currentMessage?.newVariations;

      const localVariations = this.state.newVariations;

      const revertedVariations =
        this.handleRevertNewVariations(serverVariations);

      const variations = revertedVariations?.[0] ?? {};

      const initialValues = merge({}, localVariations, variations);

      return (
        <QuestionsSection
          customFonts={this.props.uploadedFonts}
          attributes={this.props.attributes}
          currentType={this.props.currentMessage?.type}
          currentEvent={this.props.currentMessage?.event}
          events={this.props.events}
          businessEvents={this.props.businessEvents}
          initialValues={initialValues}
          onChange={(key, value) => this.handleChangeNewVariations(key, value)}
          partialUpdateQuestions={(values, callback) => {
            if (values.setting?.layout !== 'ON_SITE_MODAL') {
              delete values?.questionHeader;
            }

            const newVariations = this.handleTransformNewVariations(values);

            this.props.communicationUpdateSubmitMessageFetch(
              this.communicationId,
              {
                newVariations,
                variations: [],
              },
              this.props.journey,
              checkIsSurvey(
                this.channel,
                this.props.currentMessage,
                this.props.pathname
              ),
              () => {
                callback();
                this.props.communicationUpdateMessageFetch(
                  this.communicationId
                );
              }
            );
          }}
        />
      );
    }

    return null;
  };

  renderTelegramSectionMessage = (index) => {
    if (this.channel === 'TELEGRAM') {
      return (
        <React.Fragment>
          <Form layout="vertical">
            {!this.isParent && (
              <Card
                styles={{
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              >
                <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                  <div style={styles.headTitleContainer}>BOT SERVICE</div>
                </div>
                <div style={styles.dataRowContainer}>
                  <div style={{ ...styles.dataRow, border: 'none' }}>
                    <div style={{ ...styles.editContainer }}>
                      <div
                        style={{ ...styles.editLabel, maxWidth: 'fit-content' }}
                      >
                        Bot Name
                      </div>
                      <div
                        style={{
                          ...styles.editFieldContainer,
                          marginLeft: 20,
                          flex: 3,
                        }}
                      >
                        <Form.Item
                          validateStatus={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].telegramChannel'
                            )
                              ? 'error'
                              : null
                          }
                          help={errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].telegramChannel'
                          )}
                          id={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].telegramChannel'
                            )
                              ? 'error'
                              : null
                          }
                        >
                          <Select
                            id={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].telegramChannel'
                              )
                                ? 'error'
                                : null
                            }
                            data-cy="telegram-channel"
                            loading={this.props.loadingTelegramChannels}
                            style={{
                              ...styles.editField,
                              width: '100%',
                              maxWidth: 600,
                            }}
                            value={this.channelValue(index, 'telegramChannel')}
                            dropdownMenuStyle={{ maxHeight: 150 }}
                            size="large"
                            disabled={
                              this.props.readOnly || this.isEditDisable()
                            }
                            onChange={(value) =>
                              this.handleChangeVariations(
                                index,
                                'telegramChannel',
                                value
                              )
                            }
                          >
                            {this.props.loadingTelegramChannels
                              ? null
                              : this.renderServiceProviderOptions(
                                  this.props.telegramChannels || []
                                )}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            )}
            <Card
              styles={{
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              <div style={styles.dataRowContainer}>
                <div style={styles.dataRow}>
                  <div style={styles.editContainer}>
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                        maxWidth: 'fit-content',
                      }}
                    >
                      Message
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                        maxWidth: 800,
                      }}
                    >
                      <Form.Item
                        validateStatus={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].message'
                          )
                            ? 'error'
                            : null
                        }
                        help={errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].message'
                        )}
                        id={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].message'
                          )
                            ? 'error'
                            : null
                        }
                        data-cy="message-text-area"
                      >
                        <RichEditor
                          isRich={true}
                          channel={this.channel}
                          type="rich"
                          index={index}
                          hiddenTypes={[
                            'header-one',
                            'header-two',
                            'header-three',
                            'header-four',
                            'header-five',
                            'header-six',
                            'unordered-list-item',
                            'ordered-list-item',
                          ]}
                          style={{ maxWidth: 600 }}
                          value={
                            this.state.variations[index] &&
                            this.state.variations[index].message
                              ? this.state.variations[index].message
                              : ''
                          }
                          onChange={(value) =>
                            this.handleChangeVariations(index, 'message', value)
                          }
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Form>
        </React.Fragment>
      );
    }
    return null;
  };

  renderSMSSectionServiceProviderMessage = (index) => {
    if (this.channel === 'SMS') {
      const reg = /{{[^}]*}}+/g;
      const smsDefaultCount = this.state.variations[index].message.match(
        /[\u0600-\u06FF\s]/
      )
        ? 70
        : 160;
      return (
        <React.Fragment>
          <Form layout="vertical">
            {this.props.currentMessage?.type === 'TRANSACTIONAL' && (
              <Card
                styleSheet={{
                  marginBottom: 40,
                }}
              >
                <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                  <div style={styles.headTitleContainer}>
                    Personalizing Content in Transactional Campaigns
                  </div>
                </div>
                <div style={{ ...styles.dataRowContainer, paddingBottom: 0 }}>
                  You can use any variable to personalize any of the fields in
                  the message below. Eg. To include order_id in the order
                  confirmation message, please specify the order_id variable in
                  the message as <span>{'{{token.order_id }}'}</span> . Please
                  also ensure that your variables are prefixed with the keyword
                  token. Once you launch this campaign, send the token as token:{' '}
                  <span>{'{ "order_id" : "abc123" }'}</span> in the{' '}
                  <a href={texts.campaignApi} target={'blank'}>
                    transactional campaign API call{' '}
                  </a>{' '}
                  for each order confirmation, so that the message gets
                  personalized.
                </div>
                <div style={styles.dataRowContainer}>
                  Please refer to our{' '}
                  <a href={texts.campaignApi} target={'blank'}>
                    documentation
                  </a>{' '}
                  for more details on transactional campaigns.
                </div>
              </Card>
            )}
            {!this.isParent && (
              <Card
                styles={{
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              >
                <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                  <div style={styles.headTitleContainer}>Service Provider</div>
                </div>
                <div style={styles.dataRowContainer}>
                  <div style={styles.dataRow}>
                    <div style={{ ...styles.editContainer }}>
                      <div style={{ ...styles.editLabel }}>SSP</div>
                      <div
                        style={{
                          ...styles.editFieldContainer,
                          marginLeft: 20,
                          flex: 3,
                        }}
                      >
                        <Form.Item
                          validateStatus={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].smsChannel'
                            )
                              ? 'error'
                              : null
                          }
                          help={errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].smsChannel'
                          )}
                          id={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].smsChannel'
                            )
                              ? 'error'
                              : null
                          }
                        >
                          <Select
                            id={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].smsChannel'
                              )
                                ? 'error'
                                : null
                            }
                            data-cy="sms-channel"
                            loading={this.props.loadingSmsChannels}
                            style={styles.editField}
                            value={this.channelValue(index, 'smsChannel')}
                            dropdownMenuStyle={{ maxHeight: 150 }}
                            size="large"
                            disabled={
                              this.props.readOnly || this.isEditDisable()
                            }
                            onChange={(value) =>
                              this.handleChangeVariations(
                                index,
                                'smsChannel',
                                value
                              )
                            }
                          >
                            {this.props.loadingSmsChannels
                              ? null
                              : this.renderServiceProviderOptions(
                                  this.props.smsChannels || []
                                )}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            )}
            <Card
              styles={{
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Message</div>
              </div>
              <div style={styles.dataRowContainer}>
                <div style={styles.dataRow}>
                  <div style={styles.editContainer}>
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                        // top: -17,
                      }}
                    >
                      SMS Text
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                      }}
                    >
                      <Form.Item
                        validateStatus={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].message'
                          )
                            ? 'error'
                            : null
                        }
                        help={errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].message'
                        )}
                        id={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].message'
                          )
                            ? 'error'
                            : null
                        }
                        data-cy="description-text-area"
                      >
                        <InputSelector
                          id={
                            errorHandling('variations[' + [index] + '].message')
                              ? 'error'
                              : null
                          }
                          journeySteps={this.props.journeyStepsForVariable}
                          disabled={this.props.readOnly || this.isEditDisable()}
                          textArea
                          type="richTextArea"
                          className={'not-resizable'}
                          attributes={this.props.attributes}
                          currentType={this.props.currentMessage?.type}
                          currentEvent={this.props.currentMessage?.event}
                          events={this.props.events}
                          businessEvents={this.props.businessEvents}
                          style={{
                            paddingRight: 58,
                            color: 'rgb(61, 64, 78)',
                            direction: 'ltr',
                            fontFamily: 'monospace',
                            fontSize: 13,
                            fontWeight: 400,
                            width: '100%',
                          }}
                          readOnly={this.props.readOnly}
                          autoSize={{ maxRows: 8, minRows: 3 }}
                          rows={4}
                          value={
                            this.state.variations[index] &&
                            this.state.variations[index].message
                              ? this.state.variations[index].message
                              : ''
                          }
                          onChange={(value) =>
                            this.handleChangeVariations(index, 'message', value)
                          }
                          size="large"
                          index={index}
                        />
                      </Form.Item>
                      <span
                        style={{
                          color: '#94969e',
                          fontSize: '10px',
                          paddingLeft: '5px',
                          paddingTop: '5px',
                          display: 'block',
                          marginBottom: '80px',
                        }}
                      >
                        {'Current count:' +
                          (this.state.variations[index] &&
                          this.state.variations[index].message
                            ? this.state.variations[index].message.replace(
                                /{{[^}]*}}+/g,
                                ''
                              ).length
                            : 0)}
                        <br />
                        {process.env.THEME !== 'Usermost' &&
                          'SMS count:' +
                            (this.state.variations[index] &&
                            this.state.variations[index].message
                              ? Math.floor(
                                  this.state.variations[index].message.replace(
                                    reg,
                                    ''
                                  ).length / smsDefaultCount
                                ) + 1
                              : 0)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Form>
        </React.Fragment>
      );
    }
    return null;
  };

  renderCustomChannelContent = (index) => {
    const availableItems =
      this.state[`selectedCustomChannelItems_${index}`] ||
      (this.state.variations[index]
        ? Object.keys(this.state.variations[index])
        : null) ||
      [];

    return (
      <>
        <Card styles={styles.renderCustomChannelContent}>
          <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
            <div style={styles.headTitleContainer}>Properties</div>
          </div>
          <div style={{ padding: 30, backgroundColor: 'white', width: '100%' }}>
            {availableItems.includes('subject') &&
              this.inputGenerator('subject', index)}
            {/* fmb: rich >>>>>>>> */}
            {availableItems.includes('message') &&
              this.inputGenerator('rich-message', index)}
            <br />
            {availableItems.includes('image') &&
              this.inputGenerator('image', index)}
            <br />
            {/* {availableItems.includes('icon') &&  */}
            {this.inputGenerator('icon', index)}
          </div>
        </Card>
        {availableItems.includes('keyValuePair') &&
          this.renderKeyValuePairs(index, 12)}
        {availableItems.includes('attachments') &&
          this.inputGenerator('attachments', index)}
      </>
    );
  };

  renderCustomChannel = (index) => {
    if (this.channel === 'CUSTOM') {
      return (
        <React.Fragment>
          <Form ref={this.formRef} layout="vertical">
            {this.props.currentMessage?.type === 'TRANSACTIONAL' && (
              <div
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  border: '1px solid #F1F1F3',
                  backgroundColor: 'white',
                  marginBottom: 40,
                }}
              >
                <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                  <div style={styles.headTitleContainer}>
                    Personalizing Content in Transactional Campaigns
                  </div>
                </div>
                <div style={{ ...styles.dataRowContainer, paddingBottom: 0 }}>
                  You can use any variable to personalize any of the fields in
                  the message below. Eg. To include order_id in the order
                  confirmation message, please specify the order_id variable in
                  the message as <span>{'{{token.order_id }}'}</span> . Please
                  also ensure that your variables are prefixed with the keyword
                  token. Once you launch this campaign, send the token as token:{' '}
                  <span>{'{ "order_id" : "abc123" }'}</span> in the{' '}
                  <a href={texts.campaignApi} target={'blank'}>
                    transactional campaign API call{' '}
                  </a>{' '}
                  for each order confirmation, so that the message gets
                  personalized.
                </div>
                <div style={styles.dataRowContainer}>
                  Please refer to our{' '}
                  <a href={texts.campaignApi} target={'blank'}>
                    documentation
                  </a>{' '}
                  for more details on transactional campaigns.
                </div>
              </div>
            )}
            <Card styles={styles.renderCustomChannel}>
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Channel Provider</div>
              </div>
              <div style={styles.dataRowContainer}>
                <div style={styles.dataRow}>
                  <div style={styles.editContainer}>
                    <div style={{ ...styles.editLabel, flex: 1 }}>
                      Custom Channel
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                      }}
                    >
                      <Form.Item
                        // name={`variations[${index}].customChannel`}
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select
                          loading={this.props.loadingCustomChannels}
                          // id="int-communication-custom-channel"
                          style={styles.editField}
                          value={this.channelValue(index, 'customChannel')}
                          dropdownMenuStyle={{ maxHeight: 150 }}
                          size="large"
                          disabled={this.props.readOnly || this.isEditDisable()}
                          onChange={(value) =>
                            this.handleChangeVariations(
                              index,
                              'customChannel',
                              value
                            )
                          }
                        >
                          {this.props.loadingCustomChannels
                            ? null
                            : this.renderServiceProviderOptions(
                                this.props.customChannels || []
                              )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            {this.renderCustomChannelContent(index)}
          </Form>
        </React.Fragment>
      );
    }
    return null;
  };

  renderTelegramSectionPreview = (index) => {
    if (this.channel === 'TELEGRAM') {
      return <TelegramPreview variation={this.state.variations[index] ?? {}} />;
    }
    return null;
  };

  renderSurveySectionPreview = () => {
    if (
      checkIsSurvey(
        this.channel,
        this.props.currentMessage,
        this.props.pathname
      )
    ) {
      return (
        <SurveyPreview
          // steps={this.getTransformedSteps(this.state.newVariations)}
          // css={this.state.newVariations?.styles?.css}
          // newVariations={this.state.newVariations}
          newVariations={this.props.currentConversion.newVariations}
        />
      );
    }
    return null;
  };
  renderSMSSectionMessage = (index) => {
    if (this.channel === 'SMS') {
      return <SmsPreview variation={this.state.variations[index] ?? {}} />;
    }
    return null;
  };

  renderKeyValuePairs = (index) => {
    return (
      <div
        style={{
          paddingLeft: 0,
          paddingRight: 0,
          border: '1px solid #F1F1F3',
          marginTop: 40,
          backgroundColor: 'white',
        }}
      >
        <div style={styles.infoBoxHeader}>
          <div style={styles.headTitleContainer}>
            <span>Key-Value Pairs</span>
            <Switch
              data-cy="key-value-pair-switch"
              disabled={this.isEditDisable()}
              style={{ position: 'relative', top: 5, left: 10 }}
              checked={
                this.state.variations[index] &&
                this.state.variations[index].showKeyValue
              }
              onChange={(value) =>
                this.handleChangeVariations(index, 'showKeyValue', value)
              }
            />
          </div>
        </div>
        {this.state.variations[index] &&
          this.state.variations[index].showKeyValue && (
            <div style={styles.dataRowContainer}>
              {this.state.variations[index] &&
                this.state.variations[index].keyValuePair.map(
                  (item, keyValueIndex) => {
                    const keyCyData = 'push-key' + (keyValueIndex + 1);
                    const valueCyData = 'push-value' + (keyValueIndex + 1);
                    const removeKeyValueCyData =
                      'remove-key-value-pair-' + (keyValueIndex + 1);
                    return (
                      <div key={keyValueIndex} style={styles.dataRowFirst}>
                        <div style={styles.editContainer}>
                          <div style={{ ...styles.editLabel }}>
                            {keyValueIndex === 0 ? 'KEY-VALUE PAIRS' : ''}
                          </div>
                          <div
                            style={{
                              ...styles.editFieldContainer,
                              marginLeft: 20,
                              flex: '6 1 1%',
                              display: 'flex',
                              flexDirection: 'row',
                            }}
                          >
                            <Form.Item
                              validateStatus={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' +
                                    [index] +
                                    '].keyValuePair[' +
                                    [keyValueIndex] +
                                    '].key'
                                )
                                  ? 'error'
                                  : null
                              }
                              help={errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' +
                                  [index] +
                                  '].keyValuePair[' +
                                  [keyValueIndex] +
                                  '].key'
                              )}
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' +
                                    [index] +
                                    '].keyValuePair[' +
                                    [keyValueIndex] +
                                    '].key'
                                )
                                  ? 'error'
                                  : null
                              }
                            >
                              <Input
                                data-cy={keyCyData}
                                id={
                                  errorHandling(
                                    this.props.errorUpdateMessageSubmit,
                                    'variations[' +
                                      [index] +
                                      '].keyValuePair[' +
                                      [keyValueIndex] +
                                      '].key'
                                  )
                                    ? 'error'
                                    : null
                                }
                                disabled={this.isEditDisable()}
                                value={item && item.key ? item.key : ''}
                                onChange={(e) =>
                                  this.handleChangeKeyValueKey(
                                    index,
                                    keyValueIndex,
                                    e.target.value
                                  )
                                }
                                placeholder="Key"
                                size="large"
                                style={{
                                  ...styles.editField,
                                  width: 150,
                                  height: 50,
                                  color: '#3d404e',
                                  fontSize: 13,
                                }}
                              />
                            </Form.Item>
                            <span style={{ margin: '15px 10px' }}>=</span>
                            <Form.Item
                              validateStatus={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' +
                                    [index] +
                                    '].keyValuePair[' +
                                    [keyValueIndex] +
                                    '].value'
                                )
                                  ? 'error'
                                  : null
                              }
                              help={errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' +
                                  [index] +
                                  '].keyValuePair[' +
                                  [keyValueIndex] +
                                  '].value'
                              )}
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' +
                                    [index] +
                                    '].keyValuePair[' +
                                    [keyValueIndex] +
                                    '].value'
                                )
                                  ? 'error'
                                  : null
                              }
                              style={{
                                width: 310,
                              }}
                            >
                              <InputSelector
                                type="richInline"
                                index={index}
                                dataCy={valueCyData}
                                disabled={this.isEditDisable()}
                                hideEmojiPicker
                                attributes={this.props.attributes}
                                events={this.props.events}
                                currentType={this.props.currentMessage?.type}
                                currentEvent={this.props.currentMessage?.event}
                                journeySteps={
                                  this.props.journeyStepsForVariable
                                }
                                businessEvents={this.props.businessEvents}
                                id={'key-value-' + keyValueIndex}
                                className={'key-value-push'}
                                value={item && item.value ? item.value : ''}
                                onChange={(value) =>
                                  this.handleChangeKeyValueValue(
                                    index,
                                    keyValueIndex,
                                    value
                                  )
                                }
                                placeholder="Value"
                                size="large"
                              />
                            </Form.Item>
                            {!this.isEditDisable() && (
                              <i
                                data-cy={removeKeyValueCyData}
                                onClick={() =>
                                  this.handleRemoveKeyValue(
                                    index,
                                    keyValueIndex
                                  )
                                }
                                className="fl-dark fl-delete cursor-pointer"
                                style={{
                                  fontSize: 24,
                                  color: 'rgb(187, 188, 193)',
                                  margin: '15px 10px',
                                }}
                              ></i>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              <div style={styles.dataRowFirst}>
                <div style={styles.editContainer}>
                  <div
                    style={{
                      ...styles.editFieldContainer,
                      marginLeft: 15,
                      flex: 3,
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <div style={{ paddingTop: 20 }}>
                      <Button
                        data-cy="add-pair-button"
                        disabled={this.isEditDisable()}
                        type="primary"
                        shape="round"
                        size={'large'}
                        ghost
                        style={styles.addNewSlotButton}
                        onClick={() => this.addKeyValuePair(index)}
                      >
                        Add Pair
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  };

  renderAdvanceWebPush = (index) => {
    return (
      <Card
        styles={{
          marginTop: 40,
        }}
      >
        <div style={styles.infoBoxHeader}>
          <div style={styles.headTitleContainer}>
            <span>Advanced Options</span>
            <Switch
              disabled={this.isEditDisable()}
              checked={
                this.state.variations[index] &&
                this.state.variations[index].showWebPushAdvance
              }
              onChange={(value) =>
                this.handleChangeVariations(index, 'showWebPushAdvance', value)
              }
              style={{ position: 'relative', top: 5, left: 10 }}
            />
          </div>
        </div>
        {this.state.variations[index] &&
          this.state.variations[index].showWebPushAdvance && (
            <div style={styles.dataRowContainer}>
              <div style={styles.dataRowFirst}>
                <div style={styles.editContainer}>
                  <div style={{ ...styles.editLabel, position: 'relative' }}>
                    Auto-Hide
                  </div>
                  <div
                    style={{
                      ...styles.editFieldContainer,
                      marginLeft: 20,
                      flex: 3,
                    }}
                  >
                    <Checkbox
                      checked={
                        !(
                          this.state.variations[index] &&
                          this.state.variations[index].autoHide
                        )
                      }
                      onChange={(e) =>
                        this.handleChangeVariations(
                          index,
                          'autoHide',
                          !e.target.checked
                        )
                      }
                    >
                      <span style={{ fontSize: 12 }}>
                        Do not auto-hide notification. Continue to show until
                        user clicks or dismisses the notification
                      </span>
                    </Checkbox>
                  </div>
                </div>
              </div>
            </div>
          )}
      </Card>
    );
  };

  renderAndroidPushButton = (index) => {
    return (
      <Card
        styles={{
          marginTop: 40,
        }}
      >
        <div style={styles.infoBoxHeader}>
          <div style={styles.headTitleContainer}>
            {this.channel === 'PUSH' && <span>Advanced Options</span>}
            {this.channel === 'WEB_PUSH' && <span>Buttons</span>}
            {this.channel === 'PUSH' && (
              <Switch
                data-cy="push-advanced-options-switch"
                disabled={this.isEditDisable()}
                checked={
                  this.state.variations[index] &&
                  this.state.variations[index].showAndroidAdvance
                }
                onChange={(value) =>
                  this.handleChangeVariations(
                    index,
                    'showAndroidAdvance',
                    value
                  )
                }
                style={{ position: 'relative', top: 5, left: 10 }}
              />
            )}
            {this.channel === 'WEB_PUSH' && (
              <Switch
                disabled={this.isEditDisable()}
                checked={
                  this.state.variations[index] &&
                  this.state.variations[index].showAndroidPushButtons
                }
                onChange={() => this.handleChangeAndroidPushButtons(index)}
                style={{ position: 'relative', top: 5, left: 10 }}
              />
            )}
          </div>
        </div>
        {((this.channel === 'PUSH' &&
          this.state.variations[index] &&
          this.state.variations[index].showAndroidAdvance) ||
          (this.channel === 'WEB_PUSH' &&
            this.state.variations[index] &&
            this.state.variations[index].showAndroidPushButtons)) && (
          <div style={styles.dataRowContainer}>
            {this.channel === 'PUSH' && (
              <div style={styles.dataRowFirst}>
                <div style={styles.editContainer}>
                  <div
                    style={{
                      ...styles.editLabel,
                    }}
                  >
                    ON-CLICK ACTION
                  </div>
                  <div
                    style={{
                      ...styles.editFieldContainer,
                      marginLeft: 20,
                      flex: 3,
                    }}
                  >
                    <InputSelector
                      dataCy="onclick-action-url"
                      type="richInline"
                      index={index}
                      journeySteps={this.props.journeyStepsForVariable}
                      disabled={this.isEditDisable()}
                      id="deep-link-url"
                      attributes={this.props.attributes}
                      events={this.props.events}
                      currentType={this.props.currentMessage?.type}
                      currentEvent={this.props.currentMessage?.event}
                      businessEvents={this.props.businessEvents}
                      hideEmojiPicker
                      placeholder="Deeplink or URL"
                      value={
                        this.state.variations[index] &&
                        this.state.variations[index].androidOnClickAction
                          ? this.state.variations[index].androidOnClickAction
                          : ''
                      }
                      onChange={(value) =>
                        this.handleChangeVariations(
                          index,
                          'androidOnClickAction',
                          value
                        )
                      }
                      size="large"
                    />
                    <span
                      style={{
                        color: '#94969e',
                        fontSize: '10px',
                        paddingLeft: '5px',
                        paddingTop: '5px',
                        display: 'block',
                      }}
                    >
                      {
                        'Deeplink can be any URI (eg. myapp://productdetails/item/abc). URL can be HTTP or HTTPS (eg. https://www.abc.com)'
                      }
                    </span>
                  </div>
                </div>
              </div>
            )}
            {this.channel === 'PUSH' &&
              this.state.variations[index].pushType !== 'TIMER' && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 24,
                    marginBlock: 24,
                  }}
                >
                  <Checkbox
                    style={{ display: 'flex', alignItems: 'center' }}
                    disabled={this.state.variations[index].pushType === 'TIMER'}
                    checked={
                      this.state.variations[index] &&
                      this.state.variations[index].sticky
                    }
                    onChange={(event) =>
                      this.handleChangeVariations(
                        index,
                        'sticky',
                        event.target.checked
                      )
                    }
                  >
                    <span style={styles.editLabel}>Sticky Push</span>
                    <Tooltip
                      title={
                        <div style={{ display: 'flex', gap: 2 }}>
                          <span style={{ fontSize: 12 }}>
                            Sticky notifications may not work on all Android
                            devices. From Android 14 onward, Users can dismiss
                            sticky notifications too by swiping them .
                            <a
                              style={{ paddingInline: 2 }}
                              rel="noreferrer"
                              target="_blank"
                              href="https://developer.android.com/about/versions/14/behavior-changes-all#non-dismissable-notifications"
                            >
                              Learn more
                            </a>
                          </span>
                        </div>
                      }
                    >
                      <InfoCircleFilled
                        style={{
                          color: 'gray',
                          fontSize: 16,
                        }}
                      />
                    </Tooltip>
                  </Checkbox>
                  <Checkbox
                    disabled={!this.state.variations[index]?.sticky}
                    checked={
                      this.state.variations[index]?.sticky
                        ? this.state.variations[index] &&
                          this.state.variations[index].autoDismiss
                        : false
                    }
                    onChange={(event) => {
                      this.handleChangeVariations(
                        index,
                        'autoDismiss',
                        event.target.checked
                      );
                      if (!event.target.checked) {
                        this.handleChangeVariations(
                          index,
                          'autoDismissDuration',
                          null
                        );
                      }
                    }}
                  >
                    <span style={styles.editLabel}>
                      Auto-Dismiss Notifications
                    </span>
                  </Checkbox>
                  {this.state.variations[index]?.autoDismiss && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        marginInlineStart: 18,
                      }}
                    >
                      <InputNumber
                        placeholder="Duration"
                        value={
                          this.state.variations[index]?.autoDismissDuration
                        }
                        onChange={(val) =>
                          this.handleChangeVariations(
                            index,
                            'autoDismissDuration',
                            val
                          )
                        }
                        style={{ width: 120 }}
                      />
                      <div className="push-timer-mode-wrapper">
                        <div
                          className="push-timer-item"
                          onClick={() =>
                            this.setState({ pushTimerDurationMode: 'MIN' })
                          }
                          style={{
                            color:
                              this.state.pushTimerDurationMode === 'MIN'
                                ? '#fff'
                                : '#000',
                            background:
                              this.state.pushTimerDurationMode === 'MIN'
                                ? '#1d88f6'
                                : '#fff',
                          }}
                        >
                          Min
                        </div>
                        <div
                          style={{
                            width: 1,
                            height: '100%',
                            background: '#d9d9d9',
                          }}
                        />
                        <div
                          className="push-timer-item"
                          onClick={() =>
                            this.setState({ pushTimerDurationMode: 'HOUR' })
                          }
                          style={{
                            color:
                              this.state.pushTimerDurationMode === 'HOUR'
                                ? '#fff'
                                : '#000',
                            background:
                              this.state.pushTimerDurationMode === 'HOUR'
                                ? '#1d88f6'
                                : '#fff',
                          }}
                        >
                          HR
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            {this.channel === 'PUSH' && (
              <div style={styles.dataRow}>
                <div style={styles.editContainer}>
                  <div
                    style={{
                      ...styles.editLabel,
                      position: 'relative',
                    }}
                  >
                    Buttons
                  </div>
                  <div style={{ marginLeft: 20, flex: 3 }}>
                    <Switch
                      data-cy="push-buttons-switch"
                      disabled={this.isEditDisable()}
                      checked={
                        this.state.variations[index] &&
                        this.state.variations[index].showAndroidPushButtons
                      }
                      onChange={() =>
                        this.handleChangeAndroidPushButtons(index)
                      }
                    />
                  </div>
                </div>
              </div>
            )}
            {this.state.variations[index] &&
              this.state.variations[index].androidButtons.map(
                (item, androidButtonIndex) => {
                  const buttonIndex = androidButtonIndex + 1;
                  const labelButtonIndex = 'push-label-button-' + buttonIndex;
                  const onClickActionButtonIndex =
                    'push-onclick-action-button-' + buttonIndex;
                  const removeButtonCy =
                    'remove-button-' + (androidButtonIndex + 1);

                  return (
                    <div
                      key={androidButtonIndex}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: 20,
                      }}
                    >
                      <div
                        style={{
                          boxShadow: 'inset 0 0 6px 0 #e7e8e9',
                          borderRadius: 5,
                          border: '1px solid #e2e2e2',
                          display: 'flex',
                          flexDirection: 'column',
                          flex: 1,
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 600,
                            opacity: '0.75',
                            marginLeft: 20,
                            marginRight: 20,
                            borderBottom: '1px solid #e7e8e9',
                            paddingTop: 15,
                            paddingBottom: 15,
                          }}
                        >
                          {'Button ' + buttonIndex}
                        </div>
                        <div style={{ margin: 20 }}>
                          <div style={styles.dataRowFirst}>
                            <div style={styles.editContainer}>
                              <div
                                style={{
                                  ...styles.editLabel,
                                  position: 'relative',
                                  top: -10,
                                }}
                              >
                                LABEL
                              </div>
                              <div
                                style={{
                                  ...styles.editFieldContainer,
                                  marginLeft: 20,
                                  flex: 3,
                                }}
                              >
                                <Form.Item
                                  validateStatus={
                                    errorHandling(
                                      this.props.errorUpdateMessageSubmit,
                                      'variations[' +
                                        [index] +
                                        '].androidButton1Label'
                                    ) || lodashIsEmpty(item.label)
                                      ? 'error'
                                      : null
                                  }
                                  id={
                                    errorHandling(
                                      this.props.errorUpdateMessageSubmit,
                                      'variations[' +
                                        [index] +
                                        '].androidButton1Label'
                                    )
                                      ? 'error'
                                      : null
                                  }
                                  help={
                                    errorHandling(
                                      this.props.errorUpdateMessageSubmit,
                                      'variations[' +
                                        [index] +
                                        '].androidButton1Label'
                                    )
                                      ? 'error'
                                      : lodashIsEmpty(item.label)
                                      ? 'required'
                                      : null
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: 'This field is required',
                                    },
                                  ]}
                                >
                                  <InputSelector
                                    dataCy={labelButtonIndex}
                                    type="richInline"
                                    index={index}
                                    disabled={this.isEditDisable()}
                                    readOnly={this.props.readOnly}
                                    id={`deep-link-url-label-${buttonIndex}`}
                                    attributes={this.props.attributes}
                                    events={this.props.events}
                                    currentType={
                                      this.props.currentMessage?.type
                                    }
                                    currentEvent={
                                      this.props.currentMessage?.event
                                    }
                                    businessEvents={this.props.businessEvents}
                                    journeySteps={
                                      this.props.journeyStepsForVariable
                                    }
                                    placeholder="Label"
                                    value={
                                      !lodashIsEmpty(item.label)
                                        ? item.label
                                        : ''
                                    }
                                    onChange={(value) => {
                                      this.handleChangeButtonsAttribute(
                                        index,
                                        'androidButtons',
                                        androidButtonIndex,
                                        'label',
                                        value
                                      );
                                    }}
                                    size="large"
                                  />
                                </Form.Item>
                                {this.channel === 'PUSH' && (
                                  <span
                                    style={{
                                      color: '#94969e',
                                      fontSize: '10px',
                                      paddingLeft: '5px',
                                      paddingTop: '5px',
                                      display: 'block',
                                    }}
                                  >
                                    {`Recommended maximum length: 12 characters. Current count: ${
                                      this.state.variations[index]
                                        .androidButtons[androidButtonIndex]
                                        ?.label.length || 0
                                    }`}
                                  </span>
                                )}
                                {this.channel === 'WEB_PUSH' && (
                                  <span
                                    style={{
                                      color: '#94969e',
                                      fontSize: '10px',
                                      paddingLeft: '5px',
                                      paddingTop: '5px',
                                      display: 'block',
                                    }}
                                  >
                                    {`Recommended maximum length: 22 characters. Current count: ${
                                      this.state.variations[index]
                                        .androidButtons[androidButtonIndex]
                                        ?.label.length || 0
                                    }`}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div style={styles.dataRow}>
                            <div style={styles.editContainer}>
                              <div
                                style={{
                                  ...styles.editLabel,
                                  position: 'relative',
                                  top: -10,
                                }}
                              >
                                ON-CLICK ACTION
                              </div>
                              <div
                                style={{
                                  ...styles.editFieldContainer,
                                  marginLeft: 20,
                                  flex: 3,
                                }}
                              >
                                <InputSelector
                                  dataCy={onClickActionButtonIndex}
                                  type="richInline"
                                  index={index}
                                  disabled={this.isEditDisable()}
                                  readOnly={this.props.readOnly}
                                  id={`deep-link-url-onclick-${buttonIndex}`}
                                  attributes={this.props.attributes}
                                  events={this.props.events}
                                  currentType={this.props.currentMessage?.type}
                                  currentEvent={
                                    this.props.currentMessage?.event
                                  }
                                  businessEvents={this.props.businessEvents}
                                  journeySteps={
                                    this.props.journeyStepsForVariable
                                  }
                                  hideEmojiPicker
                                  placeholder="Deeplink or URL"
                                  value={
                                    !lodashIsEmpty(item.onClick)
                                      ? item.onClick
                                      : ''
                                  }
                                  onChange={(value) => {
                                    this.handleChangeButtonsAttribute(
                                      index,
                                      'androidButtons',
                                      androidButtonIndex,
                                      'onClick',
                                      value
                                    );
                                  }}
                                  size="large"
                                />
                                <span
                                  style={{
                                    color: '#94969e',
                                    fontSize: '10px',
                                    paddingLeft: '5px',
                                    paddingTop: '5px',
                                    display: 'block',
                                  }}
                                >
                                  {
                                    'Deeplink can be any URI (eg. myapp://productdetails/itemabc). URL can be HTTP or HTTPS (eg. https://www.abc.com)'
                                  }
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {!this.isEditDisable() && !this.props.readOnly && (
                        <div>
                          <MinusCircleOutlined
                            data-cy={removeButtonCy}
                            onClick={() =>
                              this.handleRemoveButtons(
                                index,
                                'androidButtons',
                                androidButtonIndex
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              margin: 10,
                              fontSize: 16,
                              color: '#bbbcc1',
                            }}
                          />
                        </div>
                      )}
                    </div>
                  );
                }
              )}

            {this.state.variations[index] &&
              this.state.variations[index].androidDismissButtonLabel !==
                null && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: 20,
                  }}
                >
                  <div
                    style={{
                      boxShadow: 'inset 0 0 6px 0 #e7e8e9',
                      borderRadius: 5,
                      border: '1px solid #e2e2e2',
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        opacity: '0.75',
                        marginLeft: 20,
                        marginRight: 20,
                        borderBottom: '1px solid #e7e8e9',
                        paddingTop: 15,
                        paddingBottom: 15,
                      }}
                    >
                      {'Dismiss Button'}
                    </div>
                    <div style={{ margin: 20 }}>
                      <div style={styles.dataRowFirst}>
                        <div style={styles.editContainer}>
                          <div
                            style={{
                              ...styles.editLabel,
                              position: 'relative',
                              top: -10,
                            }}
                          >
                            LABEL
                          </div>
                          <div
                            style={{
                              ...styles.editFieldContainer,
                              marginLeft: 20,
                              flex: 3,
                            }}
                          >
                            <Form.Item
                              validateStatus={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' +
                                    [index] +
                                    '].androidDismissButtonLabel'
                                )
                                  ? 'error'
                                  : !this.state.variations[index]
                                      ?.androidDismissButtonLabel
                                  ? 'error'
                                  : null
                              }
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' +
                                    [index] +
                                    '].androidDismissButtonLabel'
                                )
                                  ? 'error'
                                  : null
                              }
                              help={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' +
                                    [index] +
                                    '].androidDismissButtonLabel'
                                )
                                  ? 'error'
                                  : !this.state.variations[index]
                                      ?.androidDismissButtonLabel
                                  ? 'required'
                                  : null
                              }
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required',
                                },
                              ]}
                            >
                              <InputSelector
                                type="richInline"
                                index={index}
                                disabled={this.isEditDisable()}
                                readOnly={this.props.readOnly}
                                id={`deep-link-url-label-dismiss`}
                                attributes={this.props.attributes}
                                events={this.props.events}
                                currentType={this.props.currentMessage?.type}
                                currentEvent={this.props.currentMessage?.event}
                                businessEvents={this.props.businessEvents}
                                journeySteps={
                                  this.props.journeyStepsForVariable
                                }
                                placeholder="Label"
                                value={
                                  this.state.variations[index]
                                    .androidDismissButtonLabel || ''
                                }
                                onChange={(value) => {
                                  this.handleChangeVariations(
                                    index,
                                    'androidDismissButtonLabel',
                                    value
                                  );
                                }}
                                size="large"
                              />
                            </Form.Item>
                            {this.channel === 'PUSH' && (
                              <span
                                style={{
                                  color: '#94969e',
                                  fontSize: '10px',
                                  paddingLeft: '5px',
                                  paddingTop: '5px',
                                  display: 'block',
                                }}
                              >
                                {`Recommended maximum length: 12 characters. Current count: ${
                                  this.state.variations[index]
                                    ?.androidDismissButtonLabel?.length || 0
                                }`}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div style={styles.dataRow}>
                        <div style={styles.editContainer}>
                          <div
                            style={{
                              ...styles.editLabel,
                              position: 'relative',
                              top: -10,
                            }}
                          >
                            ON-CLICK ACTION
                          </div>
                          <div
                            style={{
                              ...styles.editFieldContainer,
                              marginLeft: 20,
                              flex: 3,
                            }}
                          >
                            <InputSelector
                              index={index}
                              disabled
                              id={`deep-link-url-onclick-dismiss`}
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              businessEvents={this.props.businessEvents}
                              journeySteps={this.props.journeyStepsForVariable}
                              hideEmojiPicker
                              hideAttributePicker
                              placeholder="Deeplink or URL"
                              value={'Dismiss The Notification'}
                              size="large"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!this.isEditDisable() && !this.props.readOnly && (
                    <div>
                      <MinusCircleOutlined
                        onClick={() =>
                          this.handleChangeVariations(
                            index,
                            'androidDismissButtonLabel',
                            null
                          )
                        }
                        style={{
                          cursor: 'pointer',
                          margin: 10,
                          fontSize: 16,
                          color: '#bbbcc1',
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            <div
              style={{
                ...styles.dataRowFirst,
                marginTop: 8,
                justifyContent: 'flex-start',
                gap: 8,
              }}
            >
              {this.state.variations[index] &&
                this.state.variations[index].androidButtons.length < 2 &&
                this.state.variations[index].showAndroidPushButtons && (
                  <Button
                    data-cy="push-add-button"
                    disabled={this.isEditDisable() || this.props.readOnly}
                    type="primary"
                    size={'large'}
                    style={styles.addNewSlotButton}
                    onClick={() => this.addAndroidButton(index)}
                  >
                    Add Button
                  </Button>
                )}
              {this.channel === 'PUSH' &&
                this.state.variations[index].showAndroidPushButtons &&
                this.state.variations[index]?.sticky &&
                this.state.variations[index].androidDismissButtonLabel ===
                  null && (
                  <Button
                    data-cy="push-add-button"
                    disabled={this.isEditDisable() || this.props.readOnly}
                    type="primary"
                    size="large"
                    style={styles.addNewSlotButton}
                    onClick={() => this.addDismissButton(index)}
                  >
                    Dissmiss Button
                  </Button>
                )}
            </div>
          </div>
        )}
      </Card>
    );
  };

  renderPushType = (index) => {
    if (this.state.variations[index] && this.state.variations[index].pushType) {
      return getPushLayout(this.state.variations[index].pushType);
    }
    return null;
  };

  renderInAppType = (index) => {
    if (
      this.state.variations[index] &&
      this.state.variations[index]?.inAppLayoutType
    ) {
      return getInAppLayout(this.state.variations[index]?.inAppLayoutType);
    }
    return null;
  };

  renderOnSiteLayoutPositions = (index) => {
    switch (this.state?.variations[index]?.onSiteLayoutType) {
      case 'TEXT':
      case 'IMAGE':
        return <span>Center</span>;
      case 'COUPON':
        return (
          <Radio.Group
            value={this.layoutPositionValue(index)}
            onChange={(event) =>
              this.handleChangeVariations(index, 'configuration', {
                position: event.target.value,
              })
            }
          >
            <Space direction="vertical" size={16}>
              <Radio value="CENTER">Center</Radio>
              <Radio value="BOTTOM_START">Bottom Start</Radio>
              <Radio value="BOTTOM_END">Bottom End</Radio>
            </Space>
          </Radio.Group>
        );
      default:
        return null;
    }
  };

  renderInAppLayoutPositions = (index) => {
    switch (this.state?.variations[index]?.inAppLayoutType) {
      case 'MODAL':
      case 'CARD':
        return <span>Center</span>;
      case 'IMAGE_ONLY':
        return (
          <Radio.Group
            value={this.layoutPositionValue(index)}
            onChange={(event) =>
              this.handleChangeVariations(index, 'configuration', {
                position: event.target.value,
              })
            }
          >
            <Space direction="vertical" size={16}>
              <Radio value="CENTER_TOP">Top</Radio>
              <Radio value="CENTER">Center</Radio>
              <Radio value="CENTER_BOTTOM">Bottom</Radio>
            </Space>
          </Radio.Group>
        );
      case 'BANNER':
      case 'BANNER_RTL':
        return (
          <Radio.Group
            value={this.layoutPositionValue(index)}
            onChange={(event) =>
              this.handleChangeVariations(index, 'configuration', {
                position: event.target.value,
              })
            }
          >
            <Space direction="vertical" size={16}>
              <Radio value="CENTER_TOP">Top</Radio>
              <Radio value="CENTER_BOTTOM">Bottom</Radio>
            </Space>
          </Radio.Group>
        );
      case 'COUPON':
        return (
          <Radio.Group
            value={this.layoutPositionValue(index)}
            onChange={(event) =>
              this.handleChangeVariations(index, 'configuration', {
                position: event.target.value,
              })
            }
          >
            <Space direction="vertical" size={16}>
              <Radio value="CENTER">Center</Radio>
              <Radio value="CENTER_BOTTOM">Bottom</Radio>
            </Space>
          </Radio.Group>
        );
      default:
        return null;
    }
  };

  renderOnSiteType = (index) => {
    if (
      this.state.variations[index] &&
      this.state.variations[index].onSiteLayoutType
    ) {
      return getOnSiteLayout(this.state.variations[index].onSiteLayoutType);
    }
    return null;
  };

  renderSubject = (index) => {
    if (this.state.variations[index] && this.state.variations[index].subject) {
      return this.state.variations[index].subject;
    }
    return null;
  };

  layoutPositionValue = (index) => {
    if (
      this.state.variations[index] &&
      this.state.variations[index].configuration
    ) {
      return this.state.variations[index].configuration?.position;
    }
    return null;
  };

  parseOnSiteConfiguration = (variation) => {
    const config = variation.configuration;
    const layout = variation.onSiteLayoutType;

    const withPersistedMetrics = (output) => {
      // Always stamp effective sizeMode so legacy campaigns (metrics only)
      // keep Custom after save/reload instead of falling back to Auto defaults.
      output.sizeMode = getEffectiveSizeMode(config || {});
      if (config?.sizePreset) {
        output.sizePreset = config.sizePreset;
      } else if (output.sizeMode === ONSITE_SIZE_MODES.PRESET) {
        output.sizePreset = getEffectiveSizePreset(config || {});
      }
      if (config?.fallbackMetric) {
        output.fallbackMetric = { ...config.fallbackMetric };
      }
      if (config?.responsiveMetrics) {
        output.responsiveMetrics =
          output.sizeMode === ONSITE_SIZE_MODES.CUSTOM
            ? config.responsiveMetrics
            : completeMobileBreakpoint(config.responsiveMetrics);
      }
      if (
        output.sizeMode === ONSITE_SIZE_MODES.AUTO ||
        output.sizeMode === ONSITE_SIZE_MODES.PRESET
      ) {
        if (output.fallbackMetric && 'height' in output.fallbackMetric) {
          delete output.fallbackMetric.height;
        }
      }
      return output;
    };

    switch (layout) {
      case 'TEXT':
      case 'TEXT_AND_IMAGE':
      case 'IMAGE': {
        return withPersistedMetrics({
          position: config?.position,
        });
      }

      case 'COUPON': {
        // bottom / start / end offsets intentionally omitted (same as before)
        return withPersistedMetrics({
          position: config?.position,
        });
      }
    }
  };

  parseInAppConfiguration = (variation) => {
    const config = variation.configuration;
    const layout = variation.inAppLayoutType;

    // Same persistence as OnSite: never strip size metrics on save.
    const withPersistedMetrics = (output) => {
      output.sizeMode = getEffectiveSizeMode(config || {});
      if (config?.sizePreset) {
        output.sizePreset = config.sizePreset;
      } else if (output.sizeMode === ONSITE_SIZE_MODES.PRESET) {
        output.sizePreset = getEffectiveSizePreset(config || {});
      }
      if (config?.fallbackMetric) {
        output.fallbackMetric = { ...config.fallbackMetric };
      }
      if (config?.responsiveMetrics) {
        output.responsiveMetrics =
          output.sizeMode === ONSITE_SIZE_MODES.CUSTOM
            ? config.responsiveMetrics
            : completeMobileBreakpoint(config.responsiveMetrics);
      }
      if (
        output.sizeMode === ONSITE_SIZE_MODES.AUTO ||
        output.sizeMode === ONSITE_SIZE_MODES.PRESET
      ) {
        if (output.fallbackMetric && 'height' in output.fallbackMetric) {
          delete output.fallbackMetric.height;
        }
      }
      return output;
    };

    switch (layout) {
      case 'CARD':
      case 'MODAL': {
        return withPersistedMetrics({
          position: config?.position,
        });
      }
      case 'IMAGE_ONLY': {
        return withPersistedMetrics({
          position: config?.position,
        });
      }

      case 'BANNER_RTL':
      case 'BANNER': {
        return withPersistedMetrics({
          position: config?.position,
        });
      }

      case 'COUPON': {
        return withPersistedMetrics({
          position: config?.position,
        });
      }
    }
  };

  renderLabel = (index) => {
    if (this.state.variations[index] && this.state.variations[index].label) {
      return this.state.variations[index].label;
    }
    return null;
  };

  renderPushSectionLayoutMessage = (index) => {
    if (this.channel === 'PUSH') {
      return (
        <React.Fragment>
          <Form ref={this.formRef} layout="vertical">
            {this.props.currentMessage?.type === 'TRANSACTIONAL' && (
              <Card
                styles={{
                  marginBottom: 40,
                }}
              >
                <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                  <div style={styles.headTitleContainer}>
                    Personalizing Content in Transactional Campaigns
                  </div>
                </div>
                <div style={{ ...styles.dataRowContainer, paddingBottom: 0 }}>
                  You can use any variable to personalize any of the fields in
                  the message below. Eg. To include order_id in the order
                  confirmation message, please specify the order_id variable in
                  the message as <span>{'{{token.order_id }}'}</span> . Please
                  also ensure that your variables are prefixed with the keyword
                  token. Once you launch this campaign, send the token as token:{' '}
                  <span>{'{ "order_id" : "abc123" }'}</span> in the{' '}
                  <a href={texts.campaignApi} target={'blank'}>
                    transactional campaign API call{' '}
                  </a>{' '}
                  for each order confirmation, so that the message gets
                  personalized.
                </div>
                <div style={styles.dataRowContainer}>
                  Please refer to our{' '}
                  <a href={texts.campaignApi} target={'blank'}>
                    documentation
                  </a>{' '}
                  for more details on transactional campaigns.
                </div>
              </Card>
            )}
            <Card>
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Layout</div>
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: 36,
                  alignItems: 'center',
                  padding: 24,
                }}
              >
                <span style={styles.layoutSelector}>Layout</span>
                <div
                  onClick={() => this.setState({ isLayoutSelectorOpen: true })}
                  style={styles.selectedLayout}
                >
                  <span>{this.renderPushType(index) || '--'}</span>
                  <FormOutlined />
                </div>
              </div>
            </Card>

            {this.state.variations[index]?.pushType === 'TIMER' && (
              <Card styles={{ marginTop: 40 }}>
                <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                  <div style={styles.headTitleContainer}>Timer Template</div>
                </div>
                <div style={styles.dataRowContainer}>
                  <StickyCountdown
                    value={this.state.variations[index].timerTemplate ?? {}}
                    onChange={(name, value, countDownType) =>
                      this.handleChangeStickyCountdown(
                        index,
                        name,
                        value,
                        countDownType
                      )
                    }
                  />
                </div>
              </Card>
            )}
            <Card
              styles={{
                marginTop: 40,
              }}
            >
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Basic</div>
              </div>
              <div style={styles.dataRowContainer}>
                <div style={styles.dataRowFirst}>
                  <div style={styles.editContainer}>
                    <div
                      style={{
                        ...styles.editLabel,
                      }}
                    >
                      TITLE
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                      }}
                    >
                      <Form.Item
                        data-cy="push_title"
                        validateStatus={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].subject'
                          )
                            ? 'error'
                            : null
                        }
                        help={errorHandling(
                          this.props.errorUpdateMessageSubmit,
                          'variations[' + [index] + '].subject'
                        )}
                        id={
                          errorHandling(
                            this.props.errorUpdateMessageSubmit,
                            'variations[' + [index] + '].subject'
                          )
                            ? 'error'
                            : null
                        }
                      >
                        <InputSelector
                          type="richInline"
                          index={index}
                          id={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].subject'
                            )
                              ? 'error'
                              : null
                          }
                          journeySteps={this.props.journeyStepsForVariable}
                          disabled={this.isEditDisable()}
                          attributes={this.props.attributes}
                          events={this.props.events}
                          currentType={this.props.currentMessage?.type}
                          currentEvent={this.props.currentMessage?.event}
                          businessEvents={this.props.businessEvents}
                          value={this.renderSubject(index)}
                          readOnly={this.props.readOnly}
                          onChange={(value) =>
                            this.handleChangeVariations(index, 'subject', value)
                          }
                        />
                      </Form.Item>
                      <span
                        style={{
                          color: '#94969e',
                          fontSize: '10px',
                          paddingLeft: '5px',
                          paddingTop: '5px',
                          display: 'block',
                        }}
                      >
                        {'Recommended maximum length: 36 characters. Current count:' +
                          (this.state.variations[index] &&
                          this.state.variations[index].subject
                            ? this.state.variations[index].subject.length
                            : 0)}
                      </span>
                    </div>
                  </div>
                </div>
                <div style={styles.dataRow}>
                  {this.inputGenerator('message', index)}
                </div>
              </div>
            </Card>
            {this.state.variations[index] &&
              this.state.variations[index].pushType === 'BANNER' && (
                <Card
                  styles={{
                    marginTop: 40,
                  }}
                >
                  <div
                    style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}
                  >
                    <div style={styles.headTitleContainer}>
                      <span>Image</span>
                    </div>
                  </div>
                  <div style={styles.dataRowContainer}>
                    <div style={styles.dataRowFirst}>
                      {this.inputGenerator('image', index)}
                    </div>
                  </div>
                </Card>
              )}
            {this.showAndroidIosPreview() &&
              this.renderAndroidPushButton(index)}
            {/* {this.showAndroidIosPreview('IOS') && this.renderIosPushButton(index)} */}
            {this.renderKeyValuePairs(index)}
            {this.renderPushModalVisible(index)}
          </Form>
        </React.Fragment>
      );
    }
    return null;
  };

  renderInAppSectionLayoutMessage = (index) => {
    if (this.channel === 'IN_APP') {
      const layoutType = this.state?.variations[index]?.inAppLayoutType;
      const handleChangeProps = (value, index) => {
        const { variations } = this.state;
        variations[index].theme = value;
        this.setState({ variations });
      };

      return (
        <React.Fragment>
          <Modal
            open={this.state.isLayoutSelectorOpen}
            onCancel={() => this.setState({ isLayoutSelectorOpen: false })}
            footer={null}
            width={1000}
            title="Select a Layout"
            bodyStyle={{ padding: 0 }}
          >
            <div style={styles.layoutModalContent}>
              <div style={styles.dataRowFirst}>
                <div style={{ ...styles.editContainer, width: '100%' }}>
                  <Row gutter={[16, 16]}>
                    <Col
                      span={8}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      {this.renderHTMLInAppAndOnSiteLayoutSelectorCard(
                        index,
                        'Modal',
                        'MODAL',
                        layoutType === 'MODAL',
                        () => this.selectInAppType(index, 'MODAL')
                      )}
                    </Col>
                    <Col
                      span={8}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      {this.renderHTMLInAppAndOnSiteLayoutSelectorCard(
                        index,
                        'Card',
                        'CARD',
                        layoutType === 'CARD',
                        () => this.selectInAppType(index, 'CARD')
                      )}
                    </Col>
                    <Col
                      span={8}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      {this.renderHTMLInAppAndOnSiteLayoutSelectorCard(
                        index,
                        'Image',
                        'IMAGE_ONLY',
                        layoutType === 'IMAGE_ONLY',
                        () => this.selectInAppType(index, 'IMAGE_ONLY')
                      )}
                    </Col>
                    <Col
                      span={8}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      {this.renderHTMLInAppAndOnSiteLayoutSelectorCard(
                        index,
                        'LTR Banner',
                        'BANNER',
                        layoutType === 'BANNER',
                        () => this.selectInAppType(index, 'BANNER')
                      )}
                    </Col>
                    <Col
                      span={8}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      {this.renderHTMLInAppAndOnSiteLayoutSelectorCard(
                        index,
                        'RTL Banner',
                        'BANNER_RTL',
                        layoutType === 'BANNER_RTL',
                        () => this.selectInAppType(index, 'BANNER_RTL')
                      )}
                    </Col>
                    <Col
                      span={8}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      {this.renderHTMLInAppAndOnSiteLayoutSelectorCard(
                        index,
                        'Coupon',
                        'COUPON',
                        layoutType === 'COUPON',
                        () => this.selectInAppType(index, 'COUPON')
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Modal>
          <Form ref={this.formRef} layout="vertical">
            <Card>
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Layout</div>
              </div>

              <div
                style={{
                  display: 'flex',
                  gap: 36,
                  alignItems: 'center',
                  padding: 24,
                }}
              >
                <span style={styles.layoutSelector}>Select a Layout</span>
                <div
                  onClick={() => this.setState({ isLayoutSelectorOpen: true })}
                  style={styles.selectedLayout}
                >
                  <span>
                    {this.state.variations[index]?.inAppLayoutType || '--'}
                  </span>
                  <FormOutlined />
                </div>
              </div>
            </Card>

            <Card styles={{ marginTop: 40 }}>
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Basic</div>
              </div>
              <div style={styles.dataRowContainer}>
                {layoutType !== 'IMAGE_ONLY' && (
                  <>
                    <div style={styles.dataRowFirst}>
                      <div style={styles.editContainer}>
                        <div
                          style={{
                            ...styles.editLabel,
                            position: 'relative',
                            top: -10,
                          }}
                        >
                          TITLE
                        </div>
                        <div
                          style={{
                            ...styles.editFieldContainer,
                            marginLeft: 20,
                            flex: 3,
                          }}
                        >
                          {false && (
                            <InlineThemePicker
                              name="title"
                              channel={this.channel}
                              variation={this.state.variations[index]}
                              customFonts={this.props.uploadedFonts}
                              onChange={(theme) => {
                                this.handleChangeVariations(
                                  index,
                                  'theme',
                                  theme
                                );
                              }}
                            />
                          )}

                          <Form.Item
                            validateStatus={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].subject'
                              )
                                ? 'error'
                                : !this.renderSubject(index)
                                ? 'error'
                                : null
                            }
                            help={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].subject'
                              )
                                ? 'error'
                                : !this.state?.variations[index]?.subject
                                ? 'required'
                                : null
                            }
                            id={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].subject'
                              )
                                ? 'error'
                                : null
                            }
                            rules={[
                              {
                                required: true,
                                message: 'This field is required',
                              },
                            ]}
                          >
                            <InputSelector
                              type="richInline"
                              style={{ maxWidth: '100%' }}
                              index={index}
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].subject'
                                )
                                  ? 'error'
                                  : null
                              }
                              journeySteps={this.props.journeyStepsForVariable}
                              disabled={this.isEditDisable()}
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              value={this.renderSubject(index)}
                              channel={this.channel}
                              businessEvents={this.props.businessEvents}
                              readOnly={this.props.readOnly}
                              onChange={(value) =>
                                this.handleChangeVariations(
                                  index,
                                  'subject',
                                  value
                                )
                              }
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <div style={styles.dataRow}>
                      {/* {this.inputGenerator('message', index)} */}
                      <div style={styles.editContainer}>
                        <div style={styles.editLabel}>MESSAGE</div>
                        <div
                          style={{
                            ...styles.editFieldContainer,
                            marginLeft: 20,
                            flex: 3,
                          }}
                        >
                          {false && (
                            <InlineThemePicker
                              name="message"
                              channel={this.channel}
                              variation={this.state.variations[index]}
                              customFonts={this.props.uploadedFonts}
                              onChange={(theme) => {
                                this.handleChangeVariations(
                                  index,
                                  'theme',
                                  theme
                                );
                              }}
                            />
                          )}

                          <Form.Item
                            validateStatus={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].message'
                              )
                                ? 'error'
                                : !this.state?.variations[index]?.message
                                ? 'error'
                                : null
                            }
                            help={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].message'
                              )
                                ? 'error'
                                : !this.state?.variations[index]?.message
                                ? 'required'
                                : null
                            }
                            id={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].message'
                              )
                                ? 'error'
                                : null
                            }
                            rules={[
                              {
                                required: true,
                                message: 'This field is required',
                              },
                            ]}
                          >
                            <InputSelector
                              type="richTextArea"
                              index={index}
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].message'
                                )
                                  ? 'error'
                                  : null
                              }
                              journeySteps={this.props.journeyStepsForVariable}
                              disabled={this.isEditDisable()}
                              textArea
                              className={'not-resizable'}
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              channel={this.channel}
                              businessEvents={this.props.businessEvents}
                              style={{
                                paddingRight: 58,
                                color: 'rgb(61, 64, 78)',
                                fontFamily: 'monospace',
                                fontSize: 13,
                                fontWeight: 400,
                                width: '100%',
                              }}
                              autoSize={{ maxRows: 3, minRows: 3 }}
                              rows={3}
                              value={
                                this.state.variations[index] &&
                                this.state.variations[index].message
                                  ? this.state.variations[index].message
                                  : ''
                              }
                              onChange={(value) =>
                                this.handleChangeVariations(
                                  index,
                                  'message',
                                  value
                                )
                              }
                              size="large"
                            />
                          </Form.Item>
                          {/* <span
                            style={{
                              color: '#94969e',
                              fontSize: '10px',
                              paddingLeft: '5px',
                              paddingTop: '5px',
                              display: 'block',
                            }}
                          >
                            {'Recommended maximum length: ' +
                              (this.state.variations[index] &&
                              this.state.variations[index].pushType === 'BANNER'
                                ? 36
                                : 180) +
                              ' characters. Current count:' +
                              (this.state.variations[index] &&
                              this.state.variations[index].message
                                ? this.state.variations[index].message.length
                                : 0)}
                          </span> */}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div style={styles.dataRow}>
                  <div style={styles.editContainer}>
                    <div style={styles.editLabel}>IMAGE</div>
                    <div
                      style={{
                        marginLeft: 20,
                        flex: 3,
                        fontSize: 13,
                        lineHeight: 1.43,
                        color: '#3d404e',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Form.Item
                          style={{
                            margin: 0,
                            width: '100%',
                          }}
                          validateStatus={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].image'
                            )
                              ? 'error'
                              : ['IMAGE_ONLY', 'CARD'].includes(
                                  this.state?.variations[index]?.inAppLayoutType
                                ) && !this.state?.variations[index]?.image
                              ? 'error'
                              : null
                          }
                          help={
                            ['IMAGE_ONLY', 'CARD'].includes(
                              this.state?.variations[index]?.inAppLayoutType
                            ) && !this.state?.variations[index]?.image
                              ? 'required'
                              : null
                          }
                          id={
                            errorHandling(
                              this.props.errorUpdateMessageSubmit,
                              'variations[' + [index] + '].image'
                            )
                              ? 'error'
                              : this.state.imageUrlFormatError
                              ? 'error'
                              : null
                          }
                        >
                          <InputSelector
                            index={index}
                            dataCy="image-url"
                            id={'variations[' + [index] + '].image'}
                            disabled={this.isEditDisable()}
                            attributes={this.props.attributes}
                            events={this.props.events}
                            currentType={this.props.currentMessage?.type}
                            currentEvent={this.props.currentMessage?.event}
                            journeySteps={this.props.journeyStepsForVariable}
                            channel={this.channel}
                            businessEvents={this.props.businessEvents}
                            hideEmojiPicker
                            hideAttributePicker
                            placeholder="https://www.abc.com/image.png"
                            value={
                              this.state.variations[index] &&
                              this.state.variations[index].image
                                ? this.state.variations[index].image
                                : ''
                            }
                            onChange={(value) => {
                              this.handleChangeVariations(
                                index,
                                'image',
                                value
                              );
                            }}
                            size="large"
                            style={{ ...styles.editField, width: '100%' }}
                          />
                        </Form.Item>
                        {!isNil(this.state.variations[index].image) &&
                        this.state.variations[index].image.length > 0 ? (
                          <Button
                            disabled={this.isEditDisable()}
                            type="primary"
                            shape="round"
                            ghost
                            onClick={() =>
                              this.handleChangeVariations(index, 'image', null)
                            }
                            size={'small'}
                            style={{
                              marginLeft: 15,
                            }}
                          >
                            Reset
                          </Button>
                        ) : (
                          <React.Fragment>
                            <span style={{ marginInline: 8 }}>or</span>
                            {this.renderPushUploader('image', index)}
                          </React.Fragment>
                        )}
                      </div>
                      {layoutType === 'COUPON' ? (
                        <div
                          style={{
                            color: '#94969e',
                            fontSize: '10px',
                            paddingLeft: '5px',
                            paddingTop: '5px',
                            display: 'block',
                          }}
                        >
                          {
                            'Recommended size: 560 px x 320 px. Aspect ratio (width:height): 1.75:1. Actual rendering depends on screen size. JPG, JPEG, PNG formats only. GIF format also available but for iOS 10+ only. Less than 1 MB in size. URL must begin with HTTP.'
                          }
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            <InAppActions
              disabled={this.isEditDisable()}
              readOnly={this.props.readOnly}
              variation={this.state.variations[index]}
              index={index}
              handleChange={(prop, value) => {
                this.handleChangeVariations(index, prop, value);
              }}
              journeySteps={this.props.journeyStepsForVariable}
              attributes={this.props.attributes}
              events={this.props.events}
              customFonts={this.props.uploadedFonts}
              businessEvents={this.props.businessEvents}
              channel={this.channel}
            />

            {!['IN_APP', 'ON_SITE'].includes(this.channel) && (
              <InAppThemeOptions
                disabled={this.isEditDisable()}
                variation={this.state.variations[index]}
                handleChange={(theme) => {
                  this.handleChangeVariations(index, 'theme', theme);
                }}
                channel={this.channel}
                customFonts={this.props.uploadedFonts}
              />
            )}

            <Card styles={{ marginTop: 40 }}>
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Layout Positions</div>
              </div>
              <div style={styles.dataRowContainer}>
                <div style={styles.dataRowFirst}>
                  <div style={styles.editContainer}>
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                      }}
                    >
                      Layout Name
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                      }}
                    >
                      {this.renderInAppType(index)}
                    </div>
                  </div>
                </div>
                <div style={{ ...styles.dataRowFirst, marginTop: 40 }}>
                  <div style={styles.editContainer}>
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                      }}
                    >
                      Positions
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                      }}
                    >
                      {this.renderInAppLayoutPositions(index)}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            {['IN_APP'].includes(this.channel) && (
              <Card
                styles={{
                  marginTop: 40,
                }}
              >
                <div style={styles.infoBoxHeader}>
                  <div style={styles.headTitleContainer}>
                    <span>Theme Options</span>
                  </div>
                </div>
                <div style={styles.dataRowContainer}>
                  <div
                    style={{ ...styles.editContainer, justifyContent: 'left' }}
                  >
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                        flex: 'unset',
                        width: 145,
                      }}
                    >
                      Layout Name
                    </div>
                    <span>
                      {this.state.variations[index]?.inAppLayoutType || '--'}
                    </span>
                  </div>
                  <ThemeAttributes
                    value={this.state.variations[index].theme}
                    //handleCancel={handleCancel}
                    theme={this.state.theme}
                    handleChangeProps={(val) => handleChangeProps(val, index)}
                    layoutType={layoutType}
                    channel={this.channel}
                    isBasicAttributesVisible={
                      this.state.isBasicAttributesVisible
                    }
                    setIsBasicAttributesVisible={(val) => {
                      this.setState({ isBasicAttributesVisible: val });
                    }}
                    enabledCSS={this.state.enabledCSS}
                    setEnabledCSS={(val) => {
                      this.setState({ enabledCSS: val });
                    }}
                    css={cssInAppSelectors}
                    readOnly={this.isEditDisable()}
                  />
                </div>
              </Card>
            )}
          </Form>
        </React.Fragment>
      );
    }
    return null;
  };

  renderHTMLInAppAndOnSiteLayoutSelectorCard = (
    index,
    title,
    name,
    isSelected,
    onClick
  ) => {
    const baseStyle = {
      padding: 20,
      cursor: 'pointer',
      minHeight: 320,
      maxWidth: 300,
      borderRadius: 15,
      boxSizing: 'border-box',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
    };

    const layoutSelectorStyle = {
      ...baseStyle,
      backgroundColor: 'rgb(246, 246, 246)',
      border: '2px solid rgb(246, 246, 246)',
    };

    const layoutSelectorStyleSelected = {
      ...baseStyle,
      backgroundColor: 'rgb(227, 242, 253)',
      borderRadius: 15,
      border: '2px solid rgb(0, 130, 207)',
    };

    const imageStyle = {
      maxWidth: '100%',
      // maxHeight: '200px',
      width: '100%',
      height: 'auto',
      borderRadius: 3,
    };

    const textStyle = {
      color: 'rgb(136, 139, 146)',
      fontSize: 18,
      display: 'flex',
      justifyContent: 'center',
    };

    const containerStyle = {
      backgroundColor: '#fff',
      borderRadius: 8,
      boxShadow: '0px 0px 6px -1px #cecece',
      textAlign: 'center',
      padding: 10,
      overflow: 'hidden',
    };

    const blackButton = (
      <Button
        disabled
        type="text"
        size={'small'}
        style={{
          backgroundColor: '#000',
          color: '#fff',
          borderRadius: 5,
        }}
      >
        Button
      </Button>
    );

    const messageTitle = (
      <div
        style={{
          fontSize: 12,
          fontWeight: 'bold',
        }}
      >
        Message Title
      </div>
    );
    const messageBody = (
      <div
        style={{
          fontSize: 11,
        }}
      >
        Message Body
      </div>
    );
    return (
      <div
        className={styles.content}
        style={isSelected ? layoutSelectorStyleSelected : layoutSelectorStyle}
        onClick={onClick}
      >
        <div
          style={{
            position: 'relative',
          }}
        >
          {(name === 'MODAL' ||
            name === 'IMAGE_ONLY' ||
            name === 'COUPON' ||
            name === 'IMAGE' ||
            name === 'TEXT' ||
            name === 'CARD') && (
            <CloseOutlined
              className="inAppPreview__close"
              style={{
                right: '-10px',
                zIndex: 1,
              }}
            />
          )}

          {name === 'MODAL' && (
            <div style={containerStyle}>
              {messageTitle}
              <div
                style={{
                  margin: '10px 0',
                }}
              >
                <img
                  src={inAppNewLayoutBanner}
                  alt={title}
                  style={imageStyle}
                />
              </div>
              {messageBody}
              <div
                style={{
                  marginTop: 10,
                }}
              >
                {blackButton}
              </div>
            </div>
          )}

          {(name === 'CARD' || name === 'TEXT') && (
            <div
              style={{
                ...containerStyle,
                padding: 0,
              }}
            >
              <div>
                <img
                  src={inAppNewLayoutBanner}
                  alt={title}
                  style={{
                    ...imageStyle,
                    borderRadius: 0,
                  }}
                />
              </div>

              <div
                style={{
                  textAlign: name === 'CARD' ? 'left' : '',
                  padding: 10,
                }}
              >
                {messageTitle}
                {messageBody}
              </div>

              <div
                style={{
                  textAlign: name === 'CARD' ? 'right' : '',
                  padding: 10,
                }}
              >
                {name === 'CARD' && (
                  <Button
                    disabled
                    type="text"
                    size={'small'}
                    style={{
                      backgroundColor: '#fff',
                      color: '#ddd',
                      borderRadius: 5,
                    }}
                  >
                    Cancel
                  </Button>
                )}

                {blackButton}
              </div>
            </div>
          )}

          {(name === 'IMAGE_ONLY' || name === 'IMAGE' || name === 'COUPON') && (
            <div
              style={{
                ...containerStyle,
                padding: 0,
              }}
            >
              <div
                style={{
                  position: 'relative',
                }}
              >
                <img
                  src={inAppNewLayoutBanner}
                  alt={title}
                  style={{
                    ...imageStyle,
                    borderRadius: 0,
                  }}
                />

                {name === 'COUPON' && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '10%',
                      width: '100%',
                      padding: 10,
                      color: '#fff',
                    }}
                  >
                    {messageTitle}
                    {messageBody}

                    <div
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 3,
                        padding: 5,
                        textAlign: 'right',
                        marginTop: 10,
                      }}
                    >
                      <SearchOutlined style={{ color: '#3188f6' }} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {(name === 'BANNER' || name === 'BANNER_RTL') && (
            <div
              style={{
                ...containerStyle,
                display: 'flex',
                gap: 10,
                direction: name === 'BANNER_RTL' ? 'rtl' : 'ltr',
              }}
            >
              <div>
                <img
                  src={inAppNewLayoutBanner}
                  alt={title}
                  style={{
                    ...imageStyle,
                    width: '70px',
                  }}
                />
              </div>
              <div
                style={{
                  textAlign: name === 'BANNER_RTL' ? 'right' : 'left',
                }}
              >
                {messageTitle}
                {messageBody}
              </div>
            </div>
          )}
        </div>

        <div style={textStyle}>{title}</div>
      </div>
    );
  };

  renderOnSiteSectionLayoutMessage = (index) => {
    if (
      this.channel === 'ON_SITE' &&
      !this.props.currentMessage?.variationType &&
      !this.props.pathname.includes('survey')
    ) {
      const onSiteLayoutType = this.state?.variations[index]?.onSiteLayoutType;

      const isNotValid =
        (this.state?.variations[index].androidButton1Label &&
          !this.state?.variations[index].androidButton1OnClickAction) ||
        (this.state?.variations[index].androidButton1OnClickAction &&
          !this.state?.variations[index].androidButton1Label);

      const handleChangeProps = (value, index) => {
        const { variations } = this.state;
        variations[index].theme = value;
        this.setState({ variations });
      };
      return (
        <React.Fragment>
          <Modal
            open={this.state.isLayoutSelectorOpen}
            onCancel={() => this.setState({ isLayoutSelectorOpen: false })}
            width={1000}
            footer={null}
            title="Select a Layout"
          >
            <OnSiteLayoutGallery
              selectedType={onSiteLayoutType}
              onSelect={(type) => this.selectOnSiteType(index, type)}
            />
          </Modal>
          <Form ref={this.formRef} layout="vertical">
            <Card>
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Layout</div>
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: 36,
                  alignItems: 'center',
                  padding: 24,
                }}
              >
                <span style={styles.layoutSelector}>Select a Layout</span>
                <div
                  onClick={() => {
                    if (this.isEditDisable()) return false;
                    return this.setState({ isLayoutSelectorOpen: true });
                  }}
                  style={styles.selectedLayout}
                >
                  <span>
                    {this.state.variations[index]?.onSiteLayoutType
                      ? getOnSiteLayout(
                          this.state.variations[index].onSiteLayoutType
                        )
                      : '--'}
                  </span>
                  <FormOutlined />
                </div>
              </div>
            </Card>
            <Card
              styles={{
                marginTop: 40,
              }}
            >
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Basic</div>
              </div>
              <div style={styles.dataRowContainer}>
                {onSiteLayoutType !== 'IMAGE' && (
                  <>
                    <div style={styles.dataRow}>
                      <div style={styles.editContainer}>
                        <div
                          style={{
                            ...styles.editLabel,
                            position: 'relative',
                            top: -10,
                          }}
                        >
                          TITLE
                        </div>
                        <div
                          style={{
                            ...styles.editFieldContainer,
                            marginLeft: 20,
                            flex: 3,
                            maxWidth: 800,
                          }}
                        >
                          {false && (
                            <InlineThemePicker
                              name="title"
                              channel={this.channel}
                              variation={this.state.variations[index]}
                              customFonts={this.props.uploadedFonts}
                              onChange={(theme) => {
                                this.handleChangeVariations(
                                  index,
                                  'theme',
                                  theme
                                );
                              }}
                            />
                          )}
                          <Form.Item
                            validateStatus={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].subject'
                              )
                                ? 'error'
                                : !this.state?.variations[index]?.subject
                                ? 'error'
                                : null
                            }
                            help={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].subject'
                              )
                                ? 'error'
                                : !this.state?.variations[index]?.subject
                                ? 'required'
                                : null
                            }
                            id={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].subject'
                              )
                                ? 'error'
                                : null
                            }
                          >
                            <InputSelector
                              isRich
                              type="rich"
                              showAttributePicker
                              showEmojiPicker
                              style={{ maxWidth: '100%' }}
                              index={index}
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].subject'
                                )
                                  ? 'error'
                                  : null
                              }
                              journeySteps={this.props.journeyStepsForVariable}
                              disabled={this.isEditDisable()}
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              businessEvents={this.props.businessEvents}
                              channel={this.channel}
                              value={this.renderSubject(index)}
                              readOnly={this.props.readOnly}
                              onChange={(value) =>
                                this.handleChangeVariations(
                                  index,
                                  'subject',
                                  value
                                )
                              }
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <div style={styles.dataRow}>
                      <div style={styles.editContainer}>
                        <div style={styles.editLabel}>MESSAGE</div>
                        <div
                          style={{
                            ...styles.editFieldContainer,
                            marginLeft: 20,
                            flex: 3,
                            maxWidth: 800,
                          }}
                        >
                          {false && (
                            <InlineThemePicker
                              name="message"
                              channel={this.channel}
                              variation={this.state.variations[index]}
                              customFonts={this.props.uploadedFonts}
                              onChange={(theme) => {
                                this.handleChangeVariations(
                                  index,
                                  'theme',
                                  theme
                                );
                              }}
                            />
                          )}
                          <Form.Item
                            validateStatus={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].message'
                              )
                                ? 'error'
                                : null
                            }
                            help={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].message'
                              )
                                ? 'error'
                                : null
                            }
                            id={
                              errorHandling(
                                this.props.errorUpdateMessageSubmit,
                                'variations[' + [index] + '].message'
                              )
                                ? 'error'
                                : null
                            }
                          >
                            <InputSelector
                              isRich
                              type="rich"
                              showAttributePicker
                              showEmojiPicker
                              index={index}
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].message'
                                )
                                  ? 'error'
                                  : null
                              }
                              journeySteps={this.props.journeyStepsForVariable}
                              disabled={this.isEditDisable()}
                              textArea
                              className={'not-resizable'}
                              attributes={this.props.attributes}
                              events={this.props.events}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              channel={this.channel}
                              businessEvents={this.props.businessEvents}
                              style={{
                                color: 'rgb(61, 64, 78)',
                                fontFamily: 'monospace',
                                fontSize: 13,
                                fontWeight: 400,
                                width: '100%',
                              }}
                              autoSize={{ maxRows: 3, minRows: 3 }}
                              rows={3}
                              value={
                                this.state.variations[index] &&
                                this.state.variations[index].message
                                  ? this.state.variations[index].message
                                  : ''
                              }
                              onChange={(value) =>
                                this.handleChangeVariations(
                                  index,
                                  'message',
                                  value
                                )
                              }
                              size="large"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div style={styles.dataRow}>
                      <div style={styles.editContainer}>
                        <div style={styles.editLabel}>IMAGE</div>
                        <div
                          style={{
                            marginLeft: 20,
                            flex: 3,
                            fontSize: 13,
                            lineHeight: 1.43,
                            color: '#3d404e',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <Form.Item
                              style={{
                                margin: 0,
                                width: '100%',
                              }}
                              validateStatus={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].image'
                                )
                                  ? 'error'
                                  : this.state?.variations[index]
                                      .onSiteLayoutType === 'IMAGE' &&
                                    !this.state?.variations[index]?.image
                                  ? 'error'
                                  : null
                              }
                              help={
                                this.state?.variations[index]
                                  .onSiteLayoutType === 'IMAGE' &&
                                !this.state?.variations[index]?.image
                                  ? 'required'
                                  : null
                              }
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].image'
                                )
                                  ? 'error'
                                  : this.state.imageUrlFormatError
                                  ? 'error'
                                  : null
                              }
                            >
                              <InputSelector
                                index={index}
                                dataCy="image-url"
                                id={'variations[' + [index] + '].image'}
                                disabled={this.isEditDisable()}
                                attributes={this.props.attributes}
                                events={this.props.events}
                                currentType={this.props.currentMessage?.type}
                                currentEvent={this.props.currentMessage?.event}
                                journeySteps={
                                  this.props.journeyStepsForVariable
                                }
                                channel={this.channel}
                                businessEvents={this.props.businessEvents}
                                hideEmojiPicker
                                hideAttributePicker
                                placeholder="https://www.abc.com/image.png"
                                value={
                                  this.state?.variations[index] &&
                                  this.state?.variations[index].image
                                    ? this.state?.variations[index].image
                                    : ''
                                }
                                onChange={(value) =>
                                  this.handleChangeVariations(
                                    index,
                                    'image',
                                    value
                                  )
                                }
                                size="large"
                                style={{ ...styles.editField, width: '100%' }}
                              />
                            </Form.Item>
                            {!isNil(this.state.variations[index].image) &&
                            this.state.variations[index].image.length > 0 ? (
                              <Button
                                disabled={this.isEditDisable()}
                                type="primary"
                                shape="round"
                                ghost
                                onClick={() =>
                                  this.handleChangeVariations(
                                    index,
                                    'image',
                                    null
                                  )
                                }
                                size={'small'}
                                style={{
                                  marginLeft: 15,
                                }}
                              >
                                Reset
                              </Button>
                            ) : (
                              <React.Fragment>
                                <span style={{ marginInline: 8 }}>or</span>
                                {this.renderPushUploader('image', index)}
                              </React.Fragment>
                            )}
                          </div>
                          {onSiteLayoutType === 'TEXT' ? (
                            <div
                              style={{
                                color: '#94969e',
                                fontSize: '10px',
                                paddingLeft: '5px',
                                paddingTop: '5px',
                                display: 'block',
                                lineHeight: 1.5,
                              }}
                            >
                              Recommended size: 560 × 250 px (≈2.24:1). The
                              layout reserves that image area — larger or
                              differently shaped images are scaled to fit and
                              will not stretch the card. Mismatched sizes may
                              letterbox; you are responsible for the result.
                              Adjust the reserved area under Advanced Styling if
                              needed.
                            </div>
                          ) : onSiteLayoutType === 'COUPON' ? (
                            <div
                              style={{
                                color: '#94969e',
                                fontSize: '10px',
                                paddingLeft: '5px',
                                paddingTop: '5px',
                                display: 'block',
                                lineHeight: 1.5,
                              }}
                            >
                              Recommended size: 560 × 320 px (≈1.75:1). The
                              image fills the coupon card (cover). Mismatched
                              sizes may crop; you are responsible for the
                              result. Adjust under Advanced Styling if needed.
                            </div>
                          ) : onSiteLayoutType === 'IMAGE' ? (
                            <div
                              style={{
                                color: '#94969e',
                                fontSize: '10px',
                                paddingLeft: '5px',
                                paddingTop: '5px',
                                display: 'block',
                                lineHeight: 1.5,
                              }}
                            >
                              Recommended size: 560 × 320 px (≈1.75:1). The
                              layout reserves that image area — larger images
                              scale to fit and will not break the card. You are
                              responsible for the result; adjust under Advanced
                              Styling if needed.
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                    {false && (
                      <div style={styles.dataRow}>
                        <div style={styles.editContainer}>
                          <div style={styles.editLabel}>BORDER RADIUS</div>
                          <BorderRadiusInput
                            variation={this.state.variations[index]}
                            onChange={(theme) =>
                              this.handleChangeVariations(index, 'theme', theme)
                            }
                          />
                        </div>
                      </div>
                    )}
                    {onSiteLayoutType === 'COUPON' && (
                      <div style={styles.dataRow}>
                        <div style={styles.editContainer}>
                          <div
                            style={{
                              ...styles.editLabel,
                              position: 'relative',
                              top: -10,
                            }}
                          >
                            Coupon Code
                          </div>
                          <div
                            style={{
                              ...styles.editFieldContainer,
                              marginLeft: 20,
                              flex: 3,
                            }}
                          >
                            {false && (
                              <InlineThemePicker
                                name="coupon"
                                channel={this.channel}
                                variation={this.state.variations[index]}
                                customFonts={this.props.uploadedFonts}
                                onChange={(theme) => {
                                  this.handleChangeVariations(
                                    index,
                                    'theme',
                                    theme
                                  );
                                }}
                              />
                            )}
                            <Form.Item
                              validateStatus={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].subject'
                                )
                                  ? 'error'
                                  : !this.state?.variations[index]?.couponCode
                                  ? 'error'
                                  : null
                              }
                              help={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].couponCode'
                                )
                                  ? 'error'
                                  : !this.state?.variations[index]?.couponCode
                                  ? 'required'
                                  : null
                              }
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].couponCode'
                                )
                                  ? 'error'
                                  : null
                              }
                            >
                              <InputSelector
                                type="richInline"
                                style={{ maxWidth: '100%' }}
                                index={index}
                                id={
                                  errorHandling(
                                    this.props.errorUpdateMessageSubmit,
                                    'variations[' + [index] + '].couponCode'
                                  )
                                    ? 'error'
                                    : null
                                }
                                journeySteps={
                                  this.props.journeyStepsForVariable
                                }
                                disabled={this.isEditDisable()}
                                attributes={this.props.attributes}
                                events={this.props.events}
                                currentType={this.props.currentMessage?.type}
                                currentEvent={this.props.currentMessage?.event}
                                businessEvents={this.props.businessEvents}
                                channel={this.channel}
                                value={
                                  this.state.variations[index] &&
                                  this.state.variations[index].couponCode
                                    ? this.state.variations[index].couponCode
                                    : ''
                                }
                                readOnly={this.props.readOnly}
                                onChange={(value) =>
                                  this.handleChangeVariations(
                                    index,
                                    'couponCode',
                                    value
                                  )
                                }
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {onSiteLayoutType === 'IMAGE' && (
                  <>
                    <div style={styles.dataRow}>
                      <div style={styles.editContainer}>
                        <div style={styles.editLabel}>IMAGE</div>
                        <div
                          style={{
                            marginLeft: 20,
                            flex: 3,
                            fontSize: 13,
                            lineHeight: 1.43,
                            color: '#3d404e',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <Form.Item
                              style={{
                                margin: 0,
                                width: '100%',
                              }}
                              validateStatus={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].image'
                                )
                                  ? 'error'
                                  : this.state.imageUrlFormatError
                                  ? 'error'
                                  : this.state?.variations[index]
                                      .onSiteLayoutType === 'IMAGE' &&
                                    !this.state?.variations[index]?.image
                                  ? 'error'
                                  : null
                              }
                              help={
                                this.state?.variations[index]
                                  .onSiteLayoutType === 'IMAGE' &&
                                !this.state?.variations[index]?.image
                                  ? 'required'
                                  : null
                              }
                              id={
                                errorHandling(
                                  this.props.errorUpdateMessageSubmit,
                                  'variations[' + [index] + '].image'
                                )
                                  ? 'error'
                                  : this.state.imageUrlFormatError
                                  ? 'error'
                                  : null
                              }
                            >
                              <InputSelector
                                index={index}
                                dataCy="image-url"
                                id={'variations[' + [index] + '].image'}
                                disabled={this.isEditDisable()}
                                events={this.props.events}
                                currentType={this.props.currentMessage?.type}
                                currentEvent={this.props.currentMessage?.event}
                                journeySteps={
                                  this.props.journeyStepsForVariable
                                }
                                channel={this.channel}
                                businessEvents={this.props.businessEvents}
                                hideEmojiPicker
                                hideAttributePicker
                                placeholder="https://www.abc.com/image.png"
                                value={
                                  this.state.variations[index] &&
                                  this.state.variations[index].image
                                    ? this.state.variations[index].image
                                    : ''
                                }
                                onChange={(value) =>
                                  this.handleChangeVariations(
                                    index,
                                    'image',
                                    value
                                  )
                                }
                                size="large"
                                style={{ ...styles.editField, width: '100%' }}
                              />
                            </Form.Item>
                            {!isNil(this.state.variations[index].image) &&
                            this.state.variations[index].image.length > 0 ? (
                              <Button
                                disabled={this.isEditDisable()}
                                type="primary"
                                shape="round"
                                ghost
                                onClick={() =>
                                  this.handleChangeVariations(
                                    index,
                                    'image',
                                    null
                                  )
                                }
                                size={'small'}
                                style={{
                                  marginLeft: 15,
                                }}
                              >
                                Reset
                              </Button>
                            ) : (
                              <React.Fragment>
                                <span style={{ marginInline: 8 }}>or</span>
                                {this.renderPushUploader('image', index)}
                              </React.Fragment>
                            )}
                          </div>
                          <div
                            style={{
                              color: '#94969e',
                              fontSize: '10px',
                              paddingLeft: '5px',
                              paddingTop: '5px',
                              display: 'block',
                            }}
                          >
                            {
                              'Width of the picture is fixed to 560px; height could be any desired. Any picture will be resized to a one with width of 560px. Actual rendering depends on screen size. JPG, JPEG, PNG formats only. GIF format also available but for iOS 10+ only. Less than 1 MB in size. URL must begin with HTTP.'
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.dataRow}>
                      <div style={styles.editContainer}>
                        <span style={styles.editLabel}>BORDER RADIUS</span>
                        <BorderRadiusInput
                          variation={this.state.variations[index]}
                          onChange={(theme) =>
                            this.handleChangeVariations(index, 'theme', theme)
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Card>
            {onSiteLayoutType !== 'COUPON' && (
              <OnSiteActions
                disabled={this.isEditDisable()}
                readOnly={this.props.readOnly}
                variation={this.state.variations[index]}
                handleChange={(prop, value) => {
                  this.handleChangeVariations(index, prop, value);
                }}
                journeySteps={this.props.journeyStepsForVariable}
                attributes={this.props.attributes}
                events={this.props.events}
                businessEvents={this.props.businessEvents}
                customFonts={this.props.uploadedFonts}
                isNotValid={isNotValid}
                index={index}
              />
            )}
            <Card styles={{ marginTop: 40 }}>
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>Layout Positions</div>
              </div>
              <div style={styles.dataRowContainer}>
                <div style={styles.dataRowFirst}>
                  <div style={styles.editContainer}>
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                      }}
                    >
                      Layout Name
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                      }}
                    >
                      {this.renderOnSiteType(index)}
                    </div>
                  </div>
                </div>
                <div style={{ ...styles.dataRowFirst, marginTop: 40 }}>
                  <div style={styles.editContainer}>
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                      }}
                    >
                      Positions
                    </div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        marginLeft: 20,
                        flex: 3,
                      }}
                    >
                      {this.renderOnSiteLayoutPositions(index)}
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: 40 }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 16,
                      maxWidth: '50%',
                      width: '100%',
                    }}
                  >
                    {(() => {
                      const config =
                        this.state.variations[index]?.configuration || {};
                      const sizeMode = getEffectiveSizeMode(config);
                      const sizePreset = getEffectiveSizePreset(config);
                      const disabled = this.isEditDisable();

                      return (
                        <>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 8,
                            }}
                          >
                            <span style={styles.editLabel}>Size</span>
                            <Radio.Group
                              disabled={disabled}
                              value={sizeMode}
                              onChange={(event) =>
                                this.applyOnSiteSizeConfig(index, {
                                  sizeMode: event.target.value,
                                  sizePreset,
                                })
                              }
                              options={[
                                {
                                  value: ONSITE_SIZE_MODES.AUTO,
                                  label: 'Auto',
                                },
                                {
                                  value: ONSITE_SIZE_MODES.PRESET,
                                  label: 'Preset',
                                },
                                {
                                  value: ONSITE_SIZE_MODES.CUSTOM,
                                  label: 'Custom',
                                },
                              ]}
                            />
                          </div>

                          {sizeMode === ONSITE_SIZE_MODES.AUTO && (
                            <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                              Fits phone and desktop (mobile adapts below{' '}
                              {MOBILE_BREAKPOINT}px)
                            </span>
                          )}

                          {sizeMode === ONSITE_SIZE_MODES.PRESET && (
                            <Radio.Group
                              disabled={disabled}
                              value={sizePreset}
                              onChange={(event) =>
                                this.applyOnSiteSizeConfig(index, {
                                  sizeMode: ONSITE_SIZE_MODES.PRESET,
                                  sizePreset: event.target.value,
                                })
                              }
                              options={Object.keys(ONSITE_SIZE_PRESETS).map(
                                (key) => ({
                                  value: key,
                                  label: `${key} (${ONSITE_SIZE_PRESETS[key]}px)`,
                                })
                              )}
                            />
                          )}

                          {sizeMode === ONSITE_SIZE_MODES.CUSTOM && (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 12,
                              }}
                            >
                              <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                                Desktop
                              </span>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Input
                                  disabled={disabled}
                                  placeholder="Height"
                                  type="number"
                                  value={
                                    config?.fallbackMetric?.height?.value || ''
                                  }
                                  onChange={(e) => {
                                    const raw = e.target.value;
                                    if (raw === '') return;
                                    const value = parseFloat(raw);
                                    if (isNaN(value)) return;

                                    const currentMetric =
                                      config?.fallbackMetric || {};
                                    const unit =
                                      currentMetric?.height?.unit || 'PX';

                                    this.handleChangeVariations(
                                      index,
                                      'fallbackMetric',
                                      {
                                        ...currentMetric,
                                        height: { value, unit },
                                      }
                                    );
                                  }}
                                />

                                <Radio.Group
                                  disabled={disabled}
                                  defaultValue={'PX'}
                                  style={{
                                    marginLeft: 18,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: 12,
                                  }}
                                  value={config?.fallbackMetric?.height?.unit}
                                  onChange={(event) => {
                                    const unit = event.target.value;
                                    const fallbackMetric =
                                      config?.fallbackMetric || {};
                                    this.handleChangeVariations(
                                      index,
                                      'fallbackMetric',
                                      {
                                        width: {
                                          ...fallbackMetric.width,
                                        },
                                        height: {
                                          ...fallbackMetric.height,
                                          unit,
                                        },
                                      }
                                    );
                                  }}
                                  options={[
                                    { value: 'PX', label: 'PX' },
                                    { value: 'PERCENT', label: '%' },
                                  ]}
                                />
                              </div>

                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Input
                                  disabled={disabled}
                                  placeholder="Width"
                                  type="number"
                                  value={
                                    config?.fallbackMetric?.width?.value ?? ''
                                  }
                                  onChange={(e) => {
                                    const raw = e.target.value;
                                    if (raw === '') return;
                                    const value = parseFloat(raw);
                                    if (isNaN(value)) return;
                                    const current =
                                      config?.fallbackMetric || {};
                                    const unit = current?.width?.unit || 'PX';
                                    this.handleChangeVariations(
                                      index,
                                      'fallbackMetric',
                                      {
                                        width: { value, unit },
                                        height: current.height || {},
                                      }
                                    );
                                  }}
                                />
                                <Radio.Group
                                  disabled={disabled}
                                  defaultValue={'PX'}
                                  style={{
                                    marginLeft: 18,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: 12,
                                  }}
                                  value={config?.fallbackMetric?.width?.unit}
                                  onChange={(event) => {
                                    const unit = event.target.value;
                                    const fallbackMetric =
                                      config?.fallbackMetric || {};
                                    this.handleChangeVariations(
                                      index,
                                      'fallbackMetric',
                                      {
                                        width: {
                                          ...fallbackMetric.width,
                                          unit,
                                        },
                                        height: {
                                          ...fallbackMetric.height,
                                        },
                                      }
                                    );
                                  }}
                                  options={[
                                    { value: 'PX', label: 'PX' },
                                    { value: 'PERCENT', label: '%' },
                                  ]}
                                />
                              </div>

                              <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                                Mobile (below {MOBILE_BREAKPOINT}px)
                              </span>
                              {['height', 'width'].map((key) => {
                                const mobileMetric =
                                  getMobileBreakpoint(
                                    config.responsiveMetrics
                                  ) || {};
                                const dimension = mobileMetric[key] || {};
                                return (
                                  <div
                                    key={key}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Input
                                      disabled={disabled}
                                      placeholder={
                                        key === 'height' ? 'Height' : 'Width'
                                      }
                                      type="number"
                                      value={dimension.value ?? ''}
                                      onChange={(e) => {
                                        const raw = e.target.value;
                                        if (raw === '') return;
                                        const value = parseFloat(raw);
                                        if (isNaN(value)) return;
                                        this.setOnSiteMobileDimension(
                                          index,
                                          key,
                                          {
                                            value,
                                            unit: dimension.unit || 'PX',
                                          }
                                        );
                                      }}
                                    />
                                    <Radio.Group
                                      disabled={disabled}
                                      style={{
                                        marginLeft: 18,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 12,
                                      }}
                                      value={dimension.unit}
                                      onChange={(event) => {
                                        this.setOnSiteMobileDimension(
                                          index,
                                          key,
                                          {
                                            ...dimension,
                                            unit: event.target.value,
                                          }
                                        );
                                      }}
                                      options={[
                                        { value: 'PX', label: 'PX' },
                                        { value: 'PERCENT', label: '%' },
                                      ]}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </Card>
            {!['IN_APP', 'ON_SITE'].includes(this.channel) && (
              <InAppThemeOptions
                disabled={this.isEditDisable()}
                variation={this.state.variations[index]}
                handleChange={(theme) => {
                  this.handleChangeVariations(index, 'theme', theme);
                }}
                channel={this.channel}
                customFonts={this.props.uploadedFonts}
              />
            )}
            {['ON_SITE'].includes(this.channel) && (
              <Card
                styles={{
                  marginTop: 40,
                }}
              >
                <div style={styles.infoBoxHeader}>
                  <div style={styles.headTitleContainer}>
                    <span>Theme Options</span>
                  </div>
                </div>

                <div style={styles.dataRowContainer}>
                  <div
                    style={{ ...styles.editContainer, justifyContent: 'left' }}
                  >
                    <div
                      style={{
                        ...styles.editLabel,
                        position: 'relative',
                        flex: 'unset',
                        width: 145,
                      }}
                    >
                      Layout Name
                    </div>
                    <span>
                      {this.state.variations[index]?.onSiteLayoutType || '--'}
                    </span>
                  </div>

                  <ThemeAttributes
                    value={this.state.variations[index].theme}
                    theme={this.state.theme}
                    handleChangeProps={(val) => handleChangeProps(val, index)}
                    layoutType={onSiteLayoutType}
                    channel={this.channel}
                    isBasicAttributesVisible={
                      this.state.isBasicAttributesVisible
                    }
                    setIsBasicAttributesVisible={(val) => {
                      this.setState({ isBasicAttributesVisible: val });
                    }}
                    enabledCSS={this.state.enabledCSS}
                    setEnabledCSS={(val) => {
                      this.setState({ enabledCSS: val });
                    }}
                    css={cssOnSiteSelectors}
                    readOnly={this.isEditDisable()}
                  />
                </div>
              </Card>
            )}
          </Form>
        </React.Fragment>
      );
    }
    return null;
  };

  renderWhatsAppSectionLayoutMessage = (index) => {
    const loadingSpin = <LoadingOutlined style={{ fontSize: 35 }} spin />;

    const regex = /\{\{[0-9]+\}\}+/g;
    const variablesCount =
      this.props.whatsAppTemplateObject[index]?.bodyText.match(regex) || [];
    const isDynamic = this.props.whatsAppTemplateObject[
      index
    ]?.templateButtons?.buttons?.some((item) => item?.url === 'DYNAMIC');
    if (this.channel === 'WHATSAPP') {
      return (
        <>
          <Card>
            <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
              <div style={styles.headTitleContainer}>Message Content</div>
            </div>
            {this.props.loadingWhatsAppTemplateObject ? (
              <div
                style={{
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  alignContent: 'center',
                  justifyContent: 'center',
                  paddingTop: 50,
                  paddingBottom: 50,
                }}
              >
                <Spin indicator={loadingSpin} />
              </div>
            ) : (
              <div style={styles.dataRowContainer}>
                <div style={styles.dataRowFirst}>
                  <div style={{ ...styles.editContainer }}>
                    <div style={{ ...styles.editLabel }}>TEMPLATE NAME</div>
                    <div
                      style={{
                        ...styles.editFieldContainer,
                        flex: 3,
                        marginLeft: 20,
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      {this.props.whatsAppTemplateObject[index]?.name}
                      {!this.isEditDisable() && (
                        <Tooltip placement={'top'} title={'Change Layout'}>
                          <i
                            data-cy="push-layout-type"
                            onClick={() =>
                              this.setState({ isLayoutSelectorOpen: true })
                            }
                            className="fl-edit"
                            style={{
                              color: '#bbbcc1',
                              marginLeft: 10,
                              border: '1px solid',
                              borderRadius: '50%',
                              fontSize: '28px',
                              lineHeight: '28px',
                            }}
                          ></i>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
                {this.props.whatsAppTemplateObject[index]?.bodyText && (
                  <div style={styles.dataRow}>
                    <div style={styles.editContainer}>
                      <div style={{ ...styles.editLabel }}>TEMPLATE TEXT</div>
                      <div
                        style={{
                          ...styles.editFieldContainer,
                          flex: 3,
                          marginLeft: 20,
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <div>
                          {this.props.whatsAppTemplateObject[index]?.bodyText
                            .split('\n')
                            .map((item, i) => (
                              <span key={i}>
                                {item}
                                <br />
                              </span>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {variablesCount.length > 1 && (
                  <div style={styles.dataRow}>
                    <div style={{ ...styles.editContainer }}>
                      <div style={{ ...styles.editLabel }}>VARIABLES</div>
                      <div
                        style={{
                          flex: 3,
                        }}
                      >
                        {variablesCount.map((variables, i) => {
                          return (
                            <div key={i} style={styles.editContainer}>
                              <div
                                style={{
                                  ...styles.editLabel,
                                }}
                              >
                                {variables}
                              </div>
                              <div
                                style={{
                                  ...styles.editFieldContainer,
                                  marginLeft: 20,
                                  flex: 3,
                                }}
                              >
                                <Form.Item>
                                  <InputSelector
                                    type="richInline"
                                    index={index}
                                    disabled={this.isEditDisable()}
                                    id="description-text-area"
                                    attributes={this.props.attributes}
                                    events={this.props.events}
                                    currentType={
                                      this.props.currentMessage?.type
                                    }
                                    currentEvent={
                                      this.props.currentMessage?.event
                                    }
                                    businessEvents={this.props.businessEvents}
                                    journeySteps={
                                      this.props.journeyStepsForVariable
                                    }
                                    value={
                                      this.state.variations[index] &&
                                      this.state.variations[index]
                                        .whatsAppVariables
                                        ? this.state.variations[index]
                                            .whatsAppVariables[variables]
                                        : ''
                                    }
                                    readOnly={this.props.readOnly}
                                    onChange={(value) => {
                                      this.handleChangeVariations(
                                        index,
                                        'whatsAppVariables',
                                        {
                                          ...(this.state.variations[index]
                                            .whatsAppVariables || {}),
                                          [variables]: value,
                                        }
                                      );
                                    }}
                                    hideEmojiPicker={true}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
                {isDynamic && (
                  <div style={styles.dataRow}>
                    <div style={styles.editContainer}>
                      <div style={{ ...styles.editLabel }}>
                        DYNAMIC URL SUFFIX
                      </div>
                      <div
                        style={{
                          ...styles.editFieldContainer,
                          flex: 3,
                          marginLeft: 20,
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Form.Item style={{ width: '100%' }}>
                          <InputSelector
                            type="richInline"
                            index={index}
                            disabled={this.isEditDisable()}
                            id="description-text-area"
                            attributes={this.props.attributes}
                            events={this.props.events}
                            currentType={this.props.currentMessage?.type}
                            currentEvent={this.props.currentMessage?.event}
                            businessEvents={this.props.businessEvents}
                            journeySteps={this.props.journeyStepsForVariable}
                            value={
                              this.state.variations[index] &&
                              this.state.variations[index].dynamicUrlSuffix
                                ? this.state.variations[index].dynamicUrlSuffix
                                : ''
                            }
                            readOnly={this.props.readOnly}
                            onChange={(value) => {
                              this.handleChangeVariations(
                                index,
                                'dynamicUrlSuffix',
                                value
                              );
                            }}
                            hideEmojiPicker={true}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </Card>
          {this.renderWhatsAppModalVisible(index)}
        </>
      );
    }
  };

  renderWebPushSectionPreview = (index) => {
    if (this.channel === 'WEB_PUSH') {
      return <WebpushPreview variation={this.state.variations[index] || {}} />;
    }

    return null;
  };

  renderWhatsAppSectionLayoutPreview = (index) => {
    if (this.channel === 'WHATSAPP') {
      return (
        <WhatsAppPreview
          variation={this.state.variations[index] || {}}
          whatsapp={this.props.whatsAppTemplateObject}
          index={index}
          loading={this.props.loadingWhatsAppTemplateObject}
        />
      );
    }
    return null;
  };

  renderWebPushSectionLayoutMessage = (index) => {
    if (this.channel === 'WEB_PUSH') {
      return (
        <React.Fragment>
          {this.props.currentMessage?.type === 'TRANSACTIONAL' && (
            <Card
              styles={{
                marginBottom: 40,
              }}
            >
              <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                <div style={styles.headTitleContainer}>
                  Personalizing Content in Transactional Campaigns
                </div>
              </div>
              <div style={{ ...styles.dataRowContainer, paddingBottom: 0 }}>
                You can use any variable to personalize any of the fields in the
                message below. Eg. To include order_id in the order confirmation
                message, please specify the order_id variable in the message as{' '}
                <span>{'{{token.order_id }}'}</span> . Please also ensure that
                your variables are prefixed with the keyword token. Once you
                launch this campaign, send the token as token:{' '}
                <span>{'{ "order_id" : "abc123" }'}</span> in the{' '}
                <a href={texts.campaignApi} target={'blank'}>
                  transactional campaign API call{' '}
                </a>{' '}
                for each order confirmation, so that the message gets
                personalized.
              </div>
              <div style={styles.dataRowContainer}>
                Please refer to our{' '}
                <a href={texts.campaignApi}>documentation</a> for more details
                on transactional campaigns.
              </div>
            </Card>
          )}
          <Card>
            <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
              <div style={styles.headTitleContainer}>Layout</div>
            </div>
            <div
              style={{
                display: 'flex',
                gap: 36,
                alignItems: 'center',
                padding: 24,
              }}
            >
              <span style={styles.layoutSelector}>Layout</span>
              <div
                onClick={() => this.setState({ isLayoutSelectorOpen: true })}
                style={styles.selectedLayout}
              >
                <span>{this.renderPushType(index) || '--'}</span>
                <FormOutlined />
              </div>
            </div>
          </Card>
          <Card
            styles={{
              marginTop: 40,
            }}
          >
            <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
              <div style={styles.headTitleContainer}>Basic</div>
            </div>
            <div style={styles.dataRowContainer}>
              <div style={styles.dataRowFirst}>
                <div style={styles.editContainer}>
                  <div
                    style={{
                      ...styles.editLabel,
                      position: 'relative',
                      top: -10,
                    }}
                  >
                    TITLE
                  </div>
                  <div
                    style={{
                      ...styles.editFieldContainer,
                      marginLeft: 20,
                      flex: 3,
                    }}
                  >
                    <InputSelector
                      type="richInline"
                      index={index}
                      disabled={this.isEditDisable()}
                      id="description-text-area"
                      attributes={this.props.attributes}
                      events={this.props.events}
                      currentType={this.props.currentMessage?.type}
                      currentEvent={this.props.currentMessage?.event}
                      businessEvents={this.props.businessEvents}
                      journeySteps={this.props.journeyStepsForVariable}
                      value={this.renderSubject(index)}
                      readOnly={this.props.readOnly}
                      onChange={(value) =>
                        this.handleChangeVariations(index, 'subject', value)
                      }
                    />
                    <span
                      style={{
                        color: '#94969e',
                        fontSize: '10px',
                        paddingLeft: '5px',
                        paddingTop: '5px',
                        display: 'block',
                      }}
                    >
                      {'Recommended maximum length: 32 characters. Current count:' +
                        (this.state.variations[index] &&
                        this.state.variations[index].subject
                          ? this.state.variations[index].subject.length
                          : 0)}
                    </span>
                  </div>
                </div>
              </div>
              <div style={styles.dataRow}>
                <div style={styles.editContainer}>
                  <div
                    style={{
                      ...styles.editLabel,
                    }}
                  >
                    MESSAGE
                  </div>
                  <div
                    style={{
                      ...styles.editFieldContainer,
                      marginLeft: 20,
                      flex: 3,
                    }}
                  >
                    <InputSelector
                      disabled={this.isEditDisable()}
                      textArea
                      type="richTextArea"
                      index={index}
                      id="message-text-area"
                      className={'not-resizable'}
                      attributes={this.props.attributes}
                      events={this.props.events}
                      currentType={this.props.currentMessage?.type}
                      currentEvent={this.props.currentMessage?.event}
                      businessEvents={this.props.businessEvents}
                      journeySteps={this.props.journeyStepsForVariable}
                      readOnly={this.props.readOnly}
                      style={{
                        paddingRight: 58,
                        color: 'rgb(61, 64, 78)',
                        fontFamily: 'monospace',
                        fontSize: 13,
                        fontWeight: 400,
                        width: '100%',
                      }}
                      autoSize={{ maxRows: 3, minRows: 3 }}
                      rows={3}
                      value={
                        this.state.variations[index] &&
                        this.state.variations[index].message
                          ? this.state.variations[index].message
                          : ''
                      }
                      onChange={(value) =>
                        this.handleChangeVariations(index, 'message', value)
                      }
                      size="large"
                    />
                    <span
                      style={{
                        color: '#94969e',
                        fontSize: '10px',
                        paddingLeft: '5px',
                        paddingTop: '5px',
                        display: 'block',
                      }}
                    >
                      {'Recommended maximum length: ' +
                        (this.state.variations[index] &&
                        this.state.variations[index].pushType === 'BANNER'
                          ? 42
                          : 160) +
                        ' characters. Current count:' +
                        (this.state.variations[index] &&
                        this.state.variations[index].message
                          ? this.state.variations[index].message.length
                          : 0)}
                    </span>
                  </div>
                </div>
              </div>
              <div style={styles.dataRow}>
                {this.inputGenerator('icon', index)}
              </div>
              <div style={styles.dataRow}>
                <div style={styles.editContainer}>
                  <div
                    style={{
                      ...styles.editLabel,
                      position: 'relative',
                      top: -10,
                    }}
                  >
                    ON-CLICK ACTIONS
                  </div>
                  <div
                    style={{
                      ...styles.editFieldContainer,
                      marginLeft: 20,
                      flex: 3,
                    }}
                  >
                    <InputSelector
                      type="richInline"
                      index={index}
                      journeySteps={this.props.journeyStepsForVariable}
                      disabled={this.isEditDisable()}
                      id="deep-link-url"
                      attributes={this.props.attributes}
                      events={this.props.events}
                      currentType={this.props.currentMessage?.type}
                      currentEvent={this.props.currentMessage?.event}
                      businessEvents={this.props.businessEvents}
                      hideEmojiPicker
                      placeholder="https://www.abc.com"
                      readOnly={this.props.readOnly}
                      value={
                        this.state.variations[index] &&
                        this.state.variations[index].androidOnClickAction
                          ? this.state.variations[index].androidOnClickAction
                          : ''
                      }
                      onChange={(value) =>
                        this.handleChangeVariations(
                          index,
                          'androidOnClickAction',
                          value
                        )
                      }
                    />
                    <span
                      style={{
                        color: '#94969e',
                        fontSize: '10px',
                        paddingLeft: '5px',
                        paddingTop: '5px',
                        display: 'block',
                      }}
                    >
                      {'URL can be HTTP or HTTPS'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          {this.state.variations[index] &&
            this.state.variations[index].pushType === 'BANNER' && (
              <Card
                styles={{
                  marginTop: 40,
                }}
              >
                <div style={{ ...styles.infoBoxHeader, flexDirection: 'row' }}>
                  <div style={styles.headTitleContainer}>
                    <span>Image</span>
                  </div>
                </div>
                <div style={styles.dataRowContainer}>
                  <div style={styles.dataRowFirst}>
                    <div style={styles.editContainer}>
                      <div
                        style={{
                          ...styles.editLabel,
                          position: 'relative',
                          top: -25,
                        }}
                      >
                        IMAGE
                      </div>
                      <div
                        style={{
                          marginLeft: 20,
                          flex: 3,
                          fontSize: 13,
                          lineHeight: 1.43,
                          color: '#3d404e',
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <Form.Item
                            validateStatus={
                              this.checkValidImageUrl(
                                this.state.variations[index].image
                              )
                                ? null
                                : 'warning'
                            }
                          >
                            <InputSelector
                              disabled={this.isEditDisable()}
                              id="push-picture-url"
                              attributes={this.props.attributes}
                              events={this.props.events}
                              journeySteps={this.props.journeyStepsForVariable}
                              currentType={this.props.currentMessage?.type}
                              currentEvent={this.props.currentMessage?.event}
                              businessEvents={this.props.businessEvents}
                              hideEmojiPicker
                              hideAttributePicker
                              placeholder="https://www.abc.com/image.png"
                              value={
                                this.state.variations[index] &&
                                this.state.variations[index].image
                                  ? this.state.variations[index].image
                                  : ''
                              }
                              onChange={(value) =>
                                this.handleChangeVariations(
                                  index,
                                  'image',
                                  value
                                )
                              }
                              size="large"
                              style={{ ...styles.editField, width: '100%' }}
                            />
                          </Form.Item>
                          {!isNil(this.state.variations[index].image) &&
                          this.state.variations[index].image.length > 0 ? (
                            <Button
                              disabled={this.isEditDisable()}
                              type="primary"
                              shape="round"
                              onClick={() =>
                                this.handleChangeVariations(
                                  index,
                                  'image',
                                  null
                                )
                              }
                              ghost
                              size={'small'}
                              style={{
                                marginLeft: 15,
                              }}
                            >
                              Reset
                            </Button>
                          ) : (
                            <React.Fragment>
                              <span style={{ marginInline: 8 }}>or</span>
                              {this.renderWebPushIconUploader('image', index)}
                            </React.Fragment>
                          )}
                        </div>
                        <div
                          style={{
                            color: '#94969e',
                            fontSize: '10px',
                            paddingLeft: '5px',
                            paddingTop: '5px',
                            display: 'block',
                          }}
                        >
                          {
                            'Recommended size: 720px x 480px. Minimum size: 360px x 240px. Aspect ratio (width:height): 3:2. Actual rendering depends on screen size. JPG, JPEG, PNG formats only. Less than 1 MB in size. URL must begin with HTTPS.'
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            )}
          {this.renderAndroidPushButton(index)}
          {this.renderAdvanceWebPush(index)}
          {this.renderPushModalVisible(index)}
        </React.Fragment>
      );
    }
    return null;
  };

  renderPushSectionPreview = (index) => {
    if (this.channel === 'PUSH') {
      const pid = getProductId(this.props.pathname);

      const productTitle =
        (this.props.userProducts &&
          this.props.userProducts?.find((p) => p.id === pid)?.name) ||
        texts.brandName;

      return (
        <PushPreview
          productTitle={productTitle}
          variation={this.state.variations[index] || {}}
        />
      );
    }
    return null;
  };

  renderInAppSectionPreview = (index) => {
    if (this.channel === 'IN_APP') {
      return (
        <InAppPreview
          variation={this.state.variations[index] || {}}
          mobileDevice={this.props.currentAudience.mobileDevice}
          configs={this.parseInAppConfiguration(
            this.state.variations[index] || {}
          )}
        />
      );
    }
    return null;
  };

  renderOnSiteSectionPreview = (index) => {
    if (
      this.channel === 'ON_SITE' &&
      !this.props.currentMessage?.variationType &&
      !this.props.pathname.includes('survey')
    ) {
      return (
        <OnSitePreview
          variation={this.state.variations[index] || {}}
          mobileDevice={this.props.currentAudience.mobileDevice}
          openInNewTab
          onPreviewOpened={() => {
            this.setState({ isInPreviewMode: false });
            this.props.resetPreview();
          }}
        />
      );
    }
    return null;
  };

  renderDetailsAndPreviewCards = (message, preview) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
        <div style={{ width: '75%' }}>{message}</div>
        {preview}
      </div>
    );
  };

  renderEditor = (index) => {
    return (
      <div>
        {this.renderEmailSection(index)}
        <div style={styles.renderEditor}>
          {this.renderCustomChannel(index)}
          {this.renderSMSSectionServiceProviderMessage(index)}
          {this.renderPushSectionLayoutMessage(index)}
          {this.renderWebPushSectionLayoutMessage(index)}
          {this.renderInAppSectionLayoutMessage(index)}
          {this.renderOnSiteSectionLayoutMessage(index)}
          {this.renderWhatsAppSectionLayoutMessage(index)}
          {this.renderTelegramSectionMessage(index)}
          {this.renderSurveySectionMessage()}
        </div>
      </div>
    );
  };

  getVariationPercentage = (index, variationCount) => {
    let percentage = null;
    if (
      this.props.currentMessage?.variations &&
      Array.isArray(this.props.currentMessage?.variations) &&
      this.props.currentMessage?.variations?.length > 1
    ) {
      percentage =
        this.props.currentMessage?.variations?.length < variationCount
          ? (100 / variationCount).toFixed()
          : this.props.currentMessage?.variations?.length > variationCount
          ? (100 / variationCount).toFixed()
          : this.props.currentMessage?.variations?.[index]?.percentage;
      if (
        (this.props.currentMessage?.variations?.length < variationCount ||
          this.props.currentMessage?.variations?.length > variationCount) &&
        variationCount === 3 &&
        index === 2
      ) {
        percentage = '34';
      }
    } else if (
      this.props.currentMessage?.variations &&
      Array.isArray(this.props.currentMessage?.variations)
    ) {
      percentage = (100 / variationCount).toFixed();
      if (variationCount === 3 && index === 2) {
        percentage = '34';
      }
    }
    return percentage;
  };

  renderVariationBar = () => {
    let isNotStoppedEnded =
      this.props.currentMessage &&
      this.props.currentMessage?.status !== 'STOPPED' &&
      this.props.currentMessage?.status !== 'ENDED';
    let activeIndex = this.state.activeIndex;
    if (activeIndex > this.state.variations.length - 1) {
      activeIndex = this.state.variations.length - 1;
    }

    if (this.props.currentMessage?.variationType === 'SURVEY') return null;

    return (
      <div style={{ cursor: this.props.readOnly ? 'not-allowed' : null }}>
        <div
          style={{
            borderBottom: '1px solid #e7e8e9',
            width: '100%',
            backgroundColor: '#FFFFFF',
            padding: '0 15px',
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          {this.state.variations.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom:
                      activeIndex === index ? '3px solid' : '3px solid',
                    borderColor:
                      activeIndex === index ? vars.primaryColor : '#FFFFFF',
                    width: this.state.variations.length === 1 ? 120 : 160,
                    marginLeft: 20,
                    paddingRight: 5,
                    paddingLeft: 5,
                  }}
                >
                  <div
                    id={'variation' + index}
                    data-cy={'variation' + index}
                    onClick={() => this.handleClickActiveVariation(index)}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span
                      style={{
                        color: '#3d404e',
                        fontWeight: '500',
                        lineHeight: '60px',
                      }}
                    >
                      {'Variation ' + variationLetter[index]}
                      {this.state.variations.length > 1 && (
                        <span
                          style={{
                            background: vars.primaryColor,
                            height: 20,
                            borderRadius: 10,
                            padding: '0 7px',
                            marginLeft: 5,
                            color: 'white',
                          }}
                        >
                          {this.getVariationPercentage(
                            index,
                            this.state.variations.length
                          ) + '%'}
                        </span>
                      )}
                    </span>
                  </div>
                  {isNotStoppedEnded && (
                    <MoreOutlined
                      style={{
                        color: '#BBBCC0',
                        fontSize: 25,
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        const showVariationModal =
                          this.state.showVariationModal;
                        const newArr = showVariationModal.map((item) =>
                          item === true ? false : false
                        );
                        newArr[index] = true;
                        this.setState({ showVariationModal: newArr });
                      }}
                    />
                  )}
                </div>
                {index === this.state.variations.length - 1 &&
                  this.state.variations.length < 5 &&
                  isNotStoppedEnded && (
                    <i
                      id={'int-communication-message-variation-add'}
                      data-cy="int-communication-message-variation-add"
                      onClick={() => this.addVariation()}
                      className="fl-add-circle"
                      style={{
                        display: 'flex',
                        alignSelf: 'center',
                        fontSize: '40px',
                        color: vars.primaryColor,
                        marginLeft: 10,
                        cursor: 'pointer',
                      }}
                    ></i>
                  )}
              </React.Fragment>
            );
          })}
        </div>
        {this.renderVariationBarModal()}
      </div>
    );
  };

  renderVariationBarModal = () => {
    let isNotStoppedEnded =
      this.props.currentMessage &&
      this.props.currentMessage?.status !== 'STOPPED' &&
      this.props.currentMessage?.status !== 'ENDED';
    let index = lodashFindIndex(
      this.state.showVariationModal,
      (o) => o === true
    );
    let deleteAddedVarOnEditMode =
      isNotStoppedEnded &&
      this.props.currentMessage?.variations?.length <
        this.state.variations.length &&
      index > this.props.currentMessage?.variations?.length - 1;
    if (index > -1) {
      return (
        <div
          ref={this.ref}
          id={'int-communication-message-variation-menu-' + index}
          style={{
            position: 'absolute',
            zIndex: 2,
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'center',
            flexDirection: 'column',
            width: 120,
            height:
              this.props.currentMessage?.status === 'DRAFT' ||
              deleteAddedVarOnEditMode
                ? 80
                : 40,
            borderRadius: 10,
            paddingLeft: 20,
            marginTop: -10,
            boxShadow: '1px 2px 9px #CFD2D5',
            marginLeft:
              index === 0 && this.state.showVariationModal.length === 1
                ? 20
                : index === 0 && this.state.showVariationModal.length !== 1
                ? 60
                : index === 1
                ? 240
                : index === 2
                ? 420
                : index === 3
                ? 600
                : 780,
            backgroundColor: 'white',
          }}
        >
          {isNotStoppedEnded && (
            <div
              style={{
                cursor:
                  this.state.showVariationModal.length < 5
                    ? 'pointer'
                    : 'not-allowed',
                marginBottom: 10,
                marginTop:
                  this.props.currentMessage?.status === 'DRAFT' ||
                  deleteAddedVarOnEditMode
                    ? 0
                    : 8,
              }}
              onClick={() => {
                this.duplicateVariation(index);
              }}
            >
              Duplicate
            </div>
          )}
          {this.props.currentMessage?.status === 'DRAFT' ? (
            <div
              onClick={() => {
                this.removeVariation(index);
              }}
              style={{
                cursor:
                  this.state.showVariationModal.length === 1
                    ? 'not-allowed'
                    : 'pointer',
              }}
            >
              Delete
            </div>
          ) : deleteAddedVarOnEditMode ? (
            <div
              onClick={() => {
                this.removeVariation(index);
              }}
              style={{
                cursor:
                  this.state.showVariationModal.length === 1
                    ? 'not-allowed'
                    : 'pointer',
              }}
            >
              Delete
            </div>
          ) : null}
        </div>
      );
    } else {
      return null;
    }
  };

  previewCloseButtonTopOffset = () => {
    const isSurvey = checkIsSurvey(
      this.channel,
      this.props.currentMessage,
      this.props.pathname
    );

    if (this.channel === 'WEB_PUSH') return 16;

    if (this.channel === 'ON_SITE') {
      if (isSurvey) return -36;

      return 16;
    }
    return -24;
  };

  render() {
    const loadingSpin = <LoadingOutlined style={{ fontSize: 35 }} spin />;

    const isSurvey = checkIsSurvey(
      this.channel,
      this.props.currentMessage,
      this.props.pathname
    );

    return (
      <div
        style={{
          position: 'relative',
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 30,
          paddingBottom: this.channel === 'SMS' ? 30 : 30,
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: 5,
            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.05)',
          }}
        ></div>
        {this.props.loadingUpdateMessage ? null : this.renderSteps()}
        {this.props.loadingUpdateMessage ? (
          <div
            style={{
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              paddingTop: 50,
              paddingBottom: 50,
            }}
          >
            <Spin indicator={loadingSpin} />
          </div>
        ) : (
          <React.Fragment>
            {this.renderVariationBar()}
            {this.renderEditor(this.state.activeIndex)}
            {this.renderFooter(this.state.activeIndex)}
            <Modal
              footer={null}
              title={null}
              closeIcon={null}
              closable={false}
              destroyOnClose
              open={this.state.isInPreviewMode}
              onCancel={() => {
                this.setState({ isInPreviewMode: false });
                sessionStorage.removeItem('sticky_countdown');
                this.props.resetPreview();
              }}
              className={`preview-modal ${isSurvey ? 'survey' : ''} ${
                isSurvey &&
                this.state.newVariations?.setting?.layout === 'MOBILE_MODAL'
                  ? 'mobile-modal-survey'
                  : ''
              }
              }`}
              style={{ background: 'transparent' }}
              styles={{ body: { background: 'transparent' } }}
              width="fit-content"
              centered
            >
              <div
                onClick={() => {
                  this.setState({ isInPreviewMode: false });
                  sessionStorage.removeItem('sticky_countdown');
                  this.props.resetPreview();
                }}
                style={{
                  position: 'absolute',
                  zIndex: 999,
                  top: this.previewCloseButtonTopOffset(),
                  right: 0,
                  cursor: 'pointer',
                }}
              >
                <CloseCircleFilled style={{ fontSize: 30 }} />
              </div>
              {this.renderTelegramSectionPreview(this.state.activeIndex)}
              {this.renderOnSiteSectionPreview(this.state.activeIndex)}
              {this.renderInAppSectionPreview(this.state.activeIndex)}
              {this.renderWebPushSectionPreview(this.state.activeIndex)}
              {this.renderWhatsAppSectionLayoutPreview(this.state.activeIndex)}
              {this.renderPushSectionPreview(this.state.activeIndex)}
              {this.renderSMSSectionMessage(this.state.activeIndex)}
              {this.renderSurveySectionPreview(this.state.activeIndex)}
            </Modal>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default CommunicationMessageComponent;
